import { FlatTreeControl } from '@angular/cdk/tree';
import { DatePipe, formatDate } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injectable,
  OnDestroy,
  OnInit,
  TemplateRef
} from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { JsonAdvancedSearchResult, NodeServiceResourceService } from '@psnb/nwt-api';
import {
  Apu,
  ApuCertifications,
  ApuShowVisit,
  ApuShowVisitCertifications,
  ApuShowVisitTriageCertifications,
  ApuTriageCertifications,
  ApuType,
  DefaultService,
  ImageMetaDataUpdateRequest,
  IP,
  NaturalGasProvider,
  Node,
  PowerSupply,
  PowerSupplyAlertsRequest,
  PowerSupplyCertifications,
  PowerSupplyCertificationsReqResponse,
  PowerSupplyCertsAlarm,
  PowerSupplyCertsTelemetryConfig,
  PowerSupplyImageMetaData,
  PowerSupplyTriageImage,
  Prefix,
  UserDetails
} from '@psnb/psnb-api';
import {
  AuthService,
  BatteryHeaterMatService,
  CabinetVendorService,
  isUndefinedOrNullOrEmpty,
  MandatoryImagesService,
  NaturalGasProviderService,
  NextGenNodeService,
  PowerSupplyAputypesService,
  PowerSupplyModelsService,
  PowerSupplyOperationsService,
  PowerSupplyPrefixService,
  PowerSupplyService,
  PowerSupplyTransponderModelService,
  PowerSupplyVendorService,
  PSConfigService,
  PsImagesService,
  PSTransponderVendorsModelsService,
  TransponderVendorService
} from '@psnb/services';
import * as FileSaver from 'file-saver';
import { BottomSheetComponent } from 'desktop/power-supply/bottom-sheet/bottom-sheet.component';
import {
  BatteryDateCodeValidation
} from 'desktop/power-supply/power-supply-create/Validations/battery.datecode.validator';
import {
  GpsLatitudeValidation
} from 'desktop/power-supply/power-supply-create/Validations/gps.latitude.validator';
import {
  GpsLongitudeValidation
} from 'desktop/power-supply/power-supply-create/Validations/gps.longitude.validator';
import {
  MACPlaceholderValidation
} from 'desktop/power-supply/power-supply-create/Validations/mac.placeholder.validator';
import {
  PowerSupplyNumValidation
} from 'desktop/power-supply/power-supply-create/Validations/powersupply.number.validator';
import {
  TransponderFormValidator
} from 'desktop/power-supply/power-supply-create/Validations/transponder.form.validator';
import { DatesharedService } from 'desktop/power-supply/power-supply-edit/dateshared.service';
import {
  PowerSupplyMoveErrorDialog
} from 'desktop/power-supply/power-supply-move/power-supply-move-error-dialog';
import {
  ValidationErrorDialog
} from 'desktop/power-supply/Upload/power-supply-bulk-upload/validation-error-dialog';
import { Observable } from 'rxjs';
import { debounceTime, map, shareReplay, take, tap } from 'rxjs/operators';
import { CommonService } from '../../common/common.service';
import { UploadDialog } from '../../common/message-dialog/upload-dialog';
import { NumberOnlyValidation } from '../../power-supply/power-supply-apu/numberOnly.validation';
import { MessageService } from '../message.service';
import {
  PowerSupplyEditApuVisitComponent
} from '../power-supply-apu/power-supply-edit-apu-visit/power-supply-edit-apu-visit.component';
import { PowerSupplyEditApuComponent } from '../power-supply-apu/power-supply-edit-apu/power-supply-edit-apu.component';
import {
  PowerSupplyEditSupplyComponent
} from '../power-supply-apu/power-supply-edit-supply/power-supply-edit-supply.component';
import {
  PowerSupplyEditSupplysfpComponent
} from '../power-supply-apu/power-supply-edit-supplysfp/power-supply-edit-supplysfp';
import {
  PowerSupplyNameEditNetConnectDialog
} from '../power-supply-edit/power-supply-name-editnetconnect-dialog.component';
import { DataService } from '../power-supply-list/data.service';
import { PowersupplyCertWorkitemComponent } from '../powersupply-cert-workitem/powersupply-cert-workitem.component';
import { environment } from './../../../environments/environment';
import { Image, PowerSupplyEditViewModel } from './power-supply-edit.model';
import { PowerSupplyUpdatedDialog } from './power-supply-updated-dialog.component';

interface subNode {
  name: string;
  children?: subNode[];
}
const TREE_DATA: subNode[] = [
  {
    name: 'Location Info',
    children: [
      { name: 'location' },
    ]
  }, {
    name: 'Transponder Info',
    children: [
      { name: 'transponder' },
    ]
  },
  {
    name: 'Battery Info',
    children: [
      { name: 'battery' },
    ]
  },
  {
    name: 'APU',
    children: [
      { name: 'apu' },
    ]
  },
  {
    name: 'Last Visit/Inspection',
    children: [
      { name: 'lastvisit' },
    ]
  },
  {
    name: 'WorkItems Performed Onsite',
    children: [
      { name: 'workitemsperformed' },
    ]
  },
  {
    name: 'Photos',
    children: [
      { name: 'photos' },
    ]
  },
  {
    name: 'Alarms',
    children: [
      { name: 'alarms' },
    ]
  },
  {
    name: 'Technician Info',
    children: [
      { name: 'technicianinfo' },
    ]
  },
  {
    name: 'Telemetry Config Info',
    children: [
      { name: 'telemetryconfig' },
    ]
  },
  // {
  //   name: 'Self Test Info',
  //   children: [
  //     { name: 'selftest' },
  //   ]
  // },
 ];

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}
@Injectable({
  providedIn: 'root'
})
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'nwt-power-supply-edit',
  templateUrl: './power-supply-edit.component.html',
  styleUrls: ['./power-supply-edit.component.scss']
})
export class PowerSupplyEditComponent implements OnInit, OnDestroy {
  public zoomLevel: number = 1;
  public vm: PowerSupplyEditViewModel;

  private readonly mandatoryImageCategoryIds: number[] = [1, 3, 5, 8, 10, 11];

  private compareDateForCertification: Date = new Date('2025-06-25');
  private getPowerSupplyId: number;
  private psCreationDate: string;

  private _transformer = (node: subNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  }
  private powerSupplyNameEditNetConnectDialog: MatDialogRef<PowerSupplyNameEditNetConnectDialog>;
  batteryManufacturers: Map<any, string> = new Map<any, string>();
  batteryDateCodes: Map<any, string> = new Map<any, string>();
  batterySerial: Map<any, string> = new Map<any, string>();
  batteryInstallDates: Map<any, string> = new Map<any, string>();
  batteryVoltages: Map<any, string> = new Map<any, string>();
  batteryManagerModels1: Array<string> = new Array<string>();
  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  apuFormGroup: FormGroup;
  public userDetails: UserDetails;
  locationInfoForm: FormGroup;
  transponderInfoForm: FormGroup;
  lastVisitInfoForm: FormGroup;
  certificateFlag:any;
  batteryInfoForm: FormGroup;
  nodesForm: FormGroup;
  batteryStringForm: FormGroup;
  batteryBatteryForm: FormGroup;
  transponderVendorControl = new FormControl();
  showPowerSupplyModel: boolean = true;
  showPowerSupplyType9360: boolean = true;
  showLoading: boolean = false;
  showPSNumberSelect: boolean = true;
  showPSNumberInput: boolean = false;
  oldinspection:any;
  filterNodeOptions: Observable<JsonAdvancedSearchResult[]>[] = [];
  split: string[] = [];
  powerSupplyName = '';
  powerSupplyAlertProfile = '';
  activeMacAddress = '';
  nodesServed: string = '';
  prevNodes: any = 0;
  min: number;
  max: number;
  batteryGroup: any;
  nodeValues: Array<string> = new Array<string>(33);
  nodeName: string = '';
  node2: string = '';
  node3: string = '';
  node4: string = '';
  node5: string = '';
  node6: string = '';
  node7: string = '';
  node8: string = '';
  node9: string = '';
  node10: string = '';
  node11: string = '';
  node12: string = '';
  node13: string = '';
  node14: string = '';
  node15: string = '';
  node16: string = '';
  node17: string = '';
  node18: string = '';
  node19: string = '';
  node20: string = '';
  node21: string = '';
  node22: string = '';
  node23: string = '';
  node24: string = '';
  node25: string = '';
  node26: string = '';
  node27: string = '';
  node28: string = '';
  node29: string = '';
  node30: string = '';
  node31: string = '';
  node32: string = '';
  powerSupplyAlertsRequest: PowerSupplyAlertsRequest;
  showProgressBaralert: boolean = false;
  alertResult:any;
  showcount: boolean = false;
  alertResultData:any;
  noData:boolean = false;
  poleNumber: string = '';
  houseNumber: string = '';
  street: string = '';
  crossStreet: string = '';
  visitTypesinhouse: any[] = [];
  visitTypesbp: any[] = [];
  city: string = '';
  state: string = '';
  region: string = '';
  hierarchyPath: string = '';
  nodeId: number = 0;
  moremonth:any;
  powerSupplyId: number = 0;
  apuVisitFormGroup: FormGroup;
  apuBatteryManuTypes: string[] = [];
  apuBatteryTerminals: string[] = ['Yes', 'No'];
  followups: string[] = ['Yes', 'No', 'Alpha'];
  apuTestRuns: string[] = ['Pass', 'Fail'];
  checkOilLevels: string[] = ['OK', 'Add', 'Changed'];
  oilFilterTights: string[] = ['Yes', 'Tighten'];
  inspectGenerators: string[] = ['Pass', 'Changed'];
  inspectSparkPlugs: string[] = ['Pass', 'Changed'];
  clearApuEventlogs: string[] = ['Yes', 'No'];
  airFilters: string[] = ['Yes', 'No'];
  rodentInsectDamages: string[] = ['OK', 'Yes-See Notes Below'];
  checkLamps: string[] = ['OK', 'Replaced-See Notes Below'];
  clearWeeds: string[] = ['Yes', 'No', 'NA'];
  checkRegrouts: string[] = ['OK', 'Re-grouted'];
  ifGroundMounts: string[] = ['Yes', 'OK', 'No'];
  anyEnclosures: string[] = ['Yes-See Notes Below', 'None'];
  cleanUpGarbages: string[] = ['Yes', 'No'];
  testOilPressures: string[] = ['Pass', 'Fail'];
  testhighTemps: string[] = ['Pass', 'Fail'];
  generatorDcBuses: string[] = ['Pass', 'Fail'];
  checkForGases: string[] = ['Pass', 'Fail'];
  testCombustibles: string[] = ['Pass', 'Fail'];
  testTampers: string[] = ['Pass', 'Fail'];
  testWaterIntrusions: string[] = ['Pass', 'Fail'];
  testPads: string[] = ['Pass', 'Fail'];
  showProgressBar: boolean = false;
  showProgressspinner: boolean = false;
  disableSaveButton: boolean = false;
  SaveFlag: boolean = false;
  showEditProgressBar: boolean = false;
  showForms: boolean = false;
  mapNumber: string = '';
  gpsLatitude: number= 0;
  gpsLongitude: number= 0;
  noOfBatteries1: Array<number>;
  noOfStrings: Array<number>;
  desc: string = '';
  powersNode: string = '';
  priority: string = '';
  businessPartnerRestriction: string = '';
  basePowerSupplyName: string = '';
  basePowerSupplyNumber: string = '';
  userName: string = '';
  noOfBatteriesFused: Array<number>;
  sysContact: string = "POLE#" + this.poleNumber + "_" + this.houseNumber + " " + this.street + "_" + this.city + ", " + this.state;
  sysLocation: string = "NODES#" + this.nodeName + "-" + this.node2 + "-" + this.node3 + "-" + this.node4 + "-" + this.node5 + "_MAP#" + this.mapNumber + "_LAT#" + this.gpsLatitude + "_LONG#" + this.gpsLongitude + "_DETAILS#" + this.desc + "_RUNS NODE#" + this.powersNode + "_PRIORITY " + this.priority;
  editPowerSupply: PowerSupply;
  private powerSupplyUpdatedDialog: MatDialogRef<PowerSupplyUpdatedDialog>;
  private powerSupplyMoveErrorDialog: MatDialogRef<PowerSupplyMoveErrorDialog>;
  private validationErrorDialog: MatDialogRef<ValidationErrorDialog>;
  private createRendererComponent: MatDialogRef<PowersupplyCertWorkitemComponent>;
  private uploadDialog: MatDialogRef<UploadDialog>;
  editNodes: Array<string> = new Array<string>();
  editBatteryBalancers: Array<string> = new Array<string>();
  editBatterySep: Array<string> = new Array<string>();
  editManu: Array<string> = new Array<string>();
  editCode: Array<string> = new Array<string>();
  editSerial: Array<string> = new Array<string>();
  editInst: Array<string> = new Array<string>();
  editNoload: Array<string> = new Array<string>();
  editUnder: Array<string> = new Array<string>();
  editCond: Array<string> = new Array<string>();
  editCondCorr: Array<string> = new Array<string>();
  editVltgString: Array<string> = new Array<string>();
  date: Date;
  insDate: Date;
  powerSupplyType936000: any;
  pullTransponderButton: boolean = true;
  asterisk: string = '';
  originalMac: string = '';
  noOfBatteries: number = 0;
  regionId: number = 0;
  selectedPSType: string = 'hint';
  prvString: any = 0;
  prvBattery: any = 0;
  showApu: boolean = false;
  lastCert: boolean = false;
  certFlag:any;
  macAddress: string = '';
  dataval: boolean = true;
  communityServed: string = '';
  validateFN: boolean = false;
  linkMacAddress: string = '';
  division: string = '';
  nodeIdValues: Array<number> = new Array<number>(33);
  node2_id: number;
  node3_id: number;
  node4_id: number;
  node5_id: number;
  node6_id: number;
  node7_id: number;
  node8_id: number;
  node9_id: number;
  node10_id: number;
  node11_id: number;
  node12_id: number;
  node13_id: number;
  node14_id: number;
  node15_id: number;
  node16_id: number;
  node17_id: number;
  node18_id: number;
  node19_id: number;
  node20_id: number;
  node21_id: number;
  node22_id: number;
  node23_id: number;
  node24_id: number;
  node25_id: number;
  node26_id: number;
  node27_id: number;
  node28_id: number;
  node29_id: number;
  node30_id: number;
  node31_id: number;
  node32_id: number;
  powerCompanyFinderUrl: string;
  visitdata: string = '';
  typeOfVisit_data: string = '';
  private apuComponent: MatDialogRef<PowerSupplyEditApuComponent>;
  private apuVistComponent: MatDialogRef<PowerSupplyEditApuVisitComponent>;
  private supplyComponent: MatDialogRef<PowerSupplyEditSupplyComponent>;
  private sfpsupplyComponent: MatDialogRef<PowerSupplyEditSupplysfpComponent>;

  interval;
  formhiddenlocval;
  formhiddenloctransval;
  formhiddenlocbatval;
  formhiddenlocbatstrval;
  formhiddenlocbatstrformval;
  formhiddenlocnodeformval;
  url: any = null;
  loading: boolean = false;
  imagesLoaded: boolean = false;
  imgName: string = '';
  catImgArray = [];
  imageresponse: any;
  categoryid: any;
  linkip:any;
  psnamelink:any;

  detailedImage: any = null;
  detailedImage1: any = null;
  detailedImage2: any = null;
  file: File;
  fileName: string = '';
  filearray = [];
  fileblobarray = [];

  reminderflag = 0;
  triageId: any;
  pslogdate:any;
  triage:any;
  triageImagesDetail: Array<PowerSupplyTriageImage>;
  triageApprovalList: string[] = [];
  triageLogName: string;
  triageLogNt: string;
  isAnnualInspect : boolean = false;
  latestDateDetail: Array<DateAndLatestImage> = new Array<DateAndLatestImage>();
  permissionValue:any;
  showMeter: boolean = false;
  visitStatusvalue: any = [];
  followUpReasons: any = [];
  CleanDustDirtFromEnclosure: any = [];
  TightenAllEnclosureHardwares: any = [];
  InspectWireHarnessesConnectors: any = [];
  InspectBatteryTemperatureProbes: any = [];
  //TypeofVisitInhouse: any = [];
  //TypeofVisitBP: any = [];
  XOCTransponderVerifications: any = [];
  MeterPanCondition: any = [];
  coRiserCondition: any = [];
  batteryHeaterMatType: any = [];
  snowSheildOptionss: any = [];
  seizureScres: any = [];
  powerSupplyIDLegibilitis: any = [];
  lampCheckOptionValues: any = [];
  checkCircuitBreakOptionValues: any = [];
  cabinetInspectionvalues: any = [];
  cabinetLockOptionvalues: any = [];
  checkGroundConnectionvalues: any = [];
  batteryStringFuses: string[] = [];
  securityBarOptionvalues: any = [];
  tamperInstalledvalue: any = [];
  checkLAPsvalue: any = [];
  cabinetVendorvalues: any = [];
  batteryCapacitievalues: any = [];
  operatingLightvalues: any = [];
  followUpActionvalue: any = [];
  surgeArrestorInputvalues: any = [];
  outputSurgeArrestorvalues: any = [];
  coaxOptionvalues: any = [];
  ACIOptionvalues: any = [];
  LRIOptionvalues: any = [];
  catErrMessage: Array<string> = [];
  PsEditFieldsMetadata:any;
  catTriageErrMessage : Array<string> = [];
  isLoadingdata:boolean = false;
  showProgressPDFBar:boolean = false;
  refreshSpin: string = '';
  telemetryinverter:any;
  manualdisabled:boolean=false;
  lastRundate: any;
  lastRunDate: any;
  lastRunStatus: string;
  rowData:any;
  processedData: any;
  telemetryinverterStatus:any;
  ipAddress: string;
  inverterStatusVal:any;
  telementryData: import("@psnb/psnb-api").TelemetryDataResponse;
  flag:boolean=false;
  showProgressBarRefresh=false;
  //Apu changes
  apuTab:boolean = false;
  apuMakeModels: ApuType[] = [];
  deviceIds: number[] = [1, 2, 3, 4, 5];
  ecmAcms: string[] = ['ECM', 'ACM'];
  apuOpVltgRatings: string[] = ['36V', '48V'];
  apuEnclosures: string[] = [];
  ngLps: string[] = ['NG', 'LP'];
  ngProvideres: NaturalGasProvider[] = [];
  id: number = 0;
  inbuiltValue:boolean = false;
  apu_id: any;
  certData: any;
  certId: any;
  private gridApi;
  private gridColumnApi;
  public context;
  public frameworkComponents;
  public columnDefs;
  public defaultColDef;
  private prefix: Prefix;
  public editIndex: number = 0;
  powerSupplyIdval: number;
  batfirst: any;
  batlast: any;
  DetailView: any;
  subselectedTabIndex:any;
  returnCertificationDate:any;
  workItems: any[] = [];
  workItemsMaterial: any[] = [];
  catDate1:string;
  catDate2:string;
  catDate3:string;
  catDate4:string;
  catDate5:string;
  catDate6:string;
  catDate7:string;
  catDate8:string;
  catDate9:string;
  catDate10:string;
  catDate11:string;
  apu_id_cert:any;
  apuvisit_id_cert:any
  telemetryThresholdProfileData : Array<string> = [];
  alarm : string;
  info : string;
  warning : string;
  validationFlag:boolean = true;
  pscreateddate:any;
  certRequiredValue:boolean = true;
  genomeMsg:any;
  psSuccessMsg:any;
  showLocationEnable:any;
  showTransponderEnable:any;
  showBatteryEnable:any;
  showHistoryEnable:any;
  showAlertsEnable:any;
  showPhotosEnable:any;
  showLastVisitEnable:any;
  psMacLinkEnable:any;
  xmRepBtnEnable:any;
  showLastCertEnable:any;
  showApuVisit:any;
  showApuInfo:any;
  userpermissions:any;
  status:any;
  testduration:any;
  teststartdate:any;
  testenddate:any;
  selftestexpired:boolean=false;
  currSub;
  apu_inspection_date:any;
  apu_battery_install_date:any;
  apu_installed_date:any;
  test_start_date:any;
  test_end_date:any;
  powerCompanywebsiteUrl: any;
  nwtTeamData:any;
  workitemFlag:boolean = false;
  calcRuntime: number;
  gpsgreaterFlag: boolean;
  latitudeField: any;
  longitudeField: any;
  scanSerialNum:any;
  scanBatteryModel:any;
  scanManufactureDate:any;
  scanCurrentDate: any;
  parallelBatteries: String = null;
  parallel: String = "Parallel";
  lionBat: String = "1LionBMS";
  parallelBatt: boolean =  false;
  lionBatt:boolean = false;
  parallelBatts : boolean;
  ins_date: string;
  atOneChecked: boolean;
  isCheckedCheck: boolean;
  psData: any;
  followUpActionData: any;
  public scannerEnabled: Array<any> = [];
  public information: string = "";
  searchText = '';
  mac_address = '';
  remcolon = '';
  searchTerm: FormControl = new FormControl();
  macSearchResult: PowerSupply[] = [];
  insFlag :boolean = false;
  triageInfoFlag:any;
  triageInfoFlowCurrent:any;
  triageInfoFlowTriage : any;
  certInsPDate: any;
  certCertDate: any;
  showsfp: boolean = false;
  sfpMAC: any;
  certtechnicianName: any;
  activeMacAddresscopy: any;
  submitFlag: boolean;
  enablephotoStatus: boolean = false;
  zoomFlag: Array<any> = [];
  constructor(
    private data: MessageService,
    private data_ser: DataService,
    private fb: FormBuilder,
    private mandatoryImagesService: MandatoryImagesService,
    private authService: AuthService,
    private powerSupplyService: PowerSupplyService,
    private existingMacValidator: MACPlaceholderValidation,
    private nodeService: NodeServiceResourceService,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private transponderModelService: PowerSupplyTransponderModelService,
    private powerSupplyVendorService: PowerSupplyVendorService,
    private transponderVendorService: TransponderVendorService,
    private powerSupplyModelsService: PowerSupplyModelsService,
    private nextGenNodeService: NextGenNodeService,
    private batteryHeaterMatService: BatteryHeaterMatService,
    private cabinetVendorService: CabinetVendorService,
    private bottomSheet: MatBottomSheet,
    private sanitizer: DomSanitizer,
    private commonService: CommonService,
    private psImagesService: PsImagesService,
    public datepipe: DatePipe,
    private psnbApi : DefaultService,
    private msalService: MsalService,
    private psConfigService: PSConfigService,
    private powerSupplyOperationsSvc: PowerSupplyOperationsService,
    private matsnackbar: MatSnackBar,
    private powerSupplyPrefixService:PowerSupplyPrefixService,
    private naturalGasProviderService: NaturalGasProviderService,
    private powerSupplyAputypesService: PowerSupplyAputypesService,
    private powerSupplyResourceService: PowerSupplyService,
    private datesharedService: DatesharedService,
    private transponderVendorsModelsService: PSTransponderVendorsModelsService,

  ) {
    this.powerSupplyAlertsRequest = {};
    this.route.queryParams
      .subscribe(params => {
        this.macAddress = params['macAddress'];
        this.triage = params['triage'];
        this.triageId = params['triageId'];
      });
      this.dataSource.data = TREE_DATA;
      localStorage.removeItem('powerSupplySfp');
  }
  permissionlevel(level){
    if(level === CommonService.DISABLED) {
      return 1;
    } else if(level === CommonService.ENABLED){
      return 0;
    } else {
      return 2;
    }
  }
  enablestatus(){
    this.showLocationEnable==2?this.locationInfoForm.disable():'';
    this.showTransponderEnable==2?this.transponderInfoForm.disable():'';
    this.showApuInfo==2?this.apuFormGroup.disable():'';
    this.showBatteryEnable==2?this.batteryInfoForm.disable():'';
    this.showBatteryEnable==2?this.batteryBatteryForm.disable():'';
    this.showBatteryEnable==2?this.batteryStringForm.disable():'';
    this.showLastVisitEnable==2?this.lastVisitInfoForm.disable():'';
    this.showApuVisit==2?this.apuVisitFormGroup.disable():'';
  }

  private checkMandatoryImages(shouldDetectChanges: boolean = true): void {
    this.vm.mandatoryImagesMissing = !this.mandatoryImagesService.checkMandatoryImages(this.detailedImage);
    if (shouldDetectChanges) {
      this.ref.detectChanges();
    }
  }

  private setMandatoryFlagOnImages(images: Image[]): void {
    images?.forEach((img: Image): void => {
      img.isMandatory = this.mandatoryImageCategoryIds.includes(img.id);
    });
  }

  ngOnInit() {
    this.vm = {
      mandatoryImageCheckInProgress: false,
      mandatoryImageInHouseCertification: false,
      mandatoryImagesMissing: true
    };
    this.datesharedService.editpssharedDataExportCall$
    .subscribe(expdate => {
   // this.export();
  });
  //pass data from supply to edit ps page
  this.datesharedService.editpssharedsupplyDatadetail$
    .subscribe(supplyData => {
       setTimeout(() => {
        this.transponderInfoForm.controls['sfpMac'].setValue(supplyData);
      });
    });

    this.datesharedService.editpssharedDatadetail$
    .subscribe(resultdetailview => {
    this.DetailView = true;
    this.certData = resultdetailview[0];

    this.apu_inspection_date=(this.certData.apuShowVisitCertifications.inspectionDate)?new Date(this.certData.apuShowVisitCertifications.inspectionDate).toLocaleString():null;
    this.apu_battery_install_date=(this.certData.apuShowVisitCertifications.apuBatteryInstallDate)?new Date(this.certData.apuShowVisitCertifications.apuBatteryInstallDate).toLocaleString():null;
    this.apu_installed_date=(this.certData.apuCertifications.dateApuInstalled)?new Date(this.certData.apuCertifications.dateApuInstalled).toLocaleString():null;
    // this.test_start_date=(this.certData.powerSupplyCertifications.testStartDate)?new Date(this.certData.powerSupplyCertifications.testStartDate).toLocaleString():'NA';
    // this.test_end_date=(this.certData.powerSupplyCertifications.testEndDate)?new Date(this.certData.powerSupplyCertifications.testEndDate).toLocaleString():'NA';
    this.getWorkItemsviewCertification(this.certData.powerSupplyCertifications.powerSupplyId,this.certData.powerSupplyCertifications.psCertificationId);
    this.getMaterialItemsviewCertification(this.certData.powerSupplyCertifications.powerSupplyId,this.certData.powerSupplyCertifications.psCertificationId);
    this.rearrangePhotoDates(this.certData.powerSupplyCertifications.photoUploadedDate);
    this.numberOfBatteriesAndStrings(this.certData['powerSupplyCertifications']['numberOfBatteries']);
    this.batteryManufacturers.set("1,1", this.certData['powerSupplyCertifications'].type11);
    this.batteryManufacturers.set("1,2",this.certData['powerSupplyCertifications'].type12);
    this.batteryManufacturers.set("1,3",this.certData['powerSupplyCertifications'].type13);
    this.batteryManufacturers.set("1,4",this.certData['powerSupplyCertifications'].type14);
    if(this.parallelBatt){
      this.batteryManufacturers.set("1,5",this.certData['powerSupplyCertifications'].type15);
      this.batteryManufacturers.set("1,6",this.certData['powerSupplyCertifications'].type16);
    }

    this.batteryManufacturers.set("2,1",this.certData['powerSupplyCertifications'].type21);
    this.batteryManufacturers.set("2,2",this.certData['powerSupplyCertifications'].type22);
    this.batteryManufacturers.set("2,3",this.certData['powerSupplyCertifications'].type23);
    this.batteryManufacturers.set("2,4",this.certData['powerSupplyCertifications'].type24);
    this.batteryManufacturers.set("3,1",this.certData['powerSupplyCertifications'].type31);
    this.batteryManufacturers.set("3,2",this.certData['powerSupplyCertifications'].type32);
    this.batteryManufacturers.set("3,3",this.certData['powerSupplyCertifications'].type33);
    this.batteryManufacturers.set("3,4",this.certData['powerSupplyCertifications'].type34);
    this.batteryManufacturers.set("4,1",this.certData['powerSupplyCertifications'].type41);
    this.batteryManufacturers.set("4,2",this.certData['powerSupplyCertifications'].type42);
    this.batteryManufacturers.set("4,3",this.certData['powerSupplyCertifications'].type43);
    this.batteryManufacturers.set("4,4",this.certData['powerSupplyCertifications'].type44);
    this.batteryManufacturers.set("5,1",this.certData['powerSupplyCertifications'].type51);
    this.batteryManufacturers.set("5,2",this.certData['powerSupplyCertifications'].type52);
    this.batteryManufacturers.set("5,3",this.certData['powerSupplyCertifications'].type53);
    this.batteryManufacturers.set("5,4",this.certData['powerSupplyCertifications'].type54);
    this.batteryManufacturers.set("6,1",this.certData['powerSupplyCertifications'].type61);
    this.batteryManufacturers.set("6,2",this.certData['powerSupplyCertifications'].type62);
    this.batteryManufacturers.set("6,3",this.certData['powerSupplyCertifications'].type63);
    this.batteryManufacturers.set("6,4",this.certData['powerSupplyCertifications'].type64);

    this.batteryDateCodes.set("1,1",this.certData['powerSupplyCertifications'].manufactureDate11);
    this.batteryDateCodes.set("1,2",this.certData['powerSupplyCertifications'].manufactureDate12);
    this.batteryDateCodes.set("1,3",this.certData['powerSupplyCertifications'].manufactureDate13);
    this.batteryDateCodes.set("1,4",this.certData['powerSupplyCertifications'].manufactureDate14);
    if(this.parallelBatt){
      this.batteryDateCodes.set("1,5",this.certData['powerSupplyCertifications'].manufactureDate15);
      this.batteryDateCodes.set("1,6",this.certData['powerSupplyCertifications'].manufactureDate16);
    }
    this.batteryDateCodes.set("2,1",this.certData['powerSupplyCertifications'].manufactureDate21);
    this.batteryDateCodes.set("2,2",this.certData['powerSupplyCertifications'].manufactureDate22);
    this.batteryDateCodes.set("2,3",this.certData['powerSupplyCertifications'].manufactureDate23);
    this.batteryDateCodes.set("2,4",this.certData['powerSupplyCertifications'].manufactureDate24);
    this.batteryDateCodes.set("3,1",this.certData['powerSupplyCertifications'].manufactureDate31);
    this.batteryDateCodes.set("3,2",this.certData['powerSupplyCertifications'].manufactureDate32);
    this.batteryDateCodes.set("3,3",this.certData['powerSupplyCertifications'].manufactureDate33);
    this.batteryDateCodes.set("3,4",this.certData['powerSupplyCertifications'].manufactureDate34);
    this.batteryDateCodes.set("4,1",this.certData['powerSupplyCertifications'].manufactureDate41);
    this.batteryDateCodes.set("4,2",this.certData['powerSupplyCertifications'].manufactureDate42);
    this.batteryDateCodes.set("4,3",this.certData['powerSupplyCertifications'].manufactureDate43);
    this.batteryDateCodes.set("4,4",this.certData['powerSupplyCertifications'].manufactureDate44);
    this.batteryDateCodes.set("5,1",this.certData['powerSupplyCertifications'].manufactureDate51);
    this.batteryDateCodes.set("5,2",this.certData['powerSupplyCertifications'].manufactureDate52);
    this.batteryDateCodes.set("5,3",this.certData['powerSupplyCertifications'].manufactureDate53);
    this.batteryDateCodes.set("5,4",this.certData['powerSupplyCertifications'].manufactureDate54);
    this.batteryDateCodes.set("6,1",this.certData['powerSupplyCertifications'].manufactureDate61);
    this.batteryDateCodes.set("6,2",this.certData['powerSupplyCertifications'].manufactureDate62);
    this.batteryDateCodes.set("6,3",this.certData['powerSupplyCertifications'].manufactureDate63);
    this.batteryDateCodes.set("6,4",this.certData['powerSupplyCertifications'].manufactureDate64);


    this.batterySerial.set("1,1",this.certData['powerSupplyCertifications'].batterySerial11);
    this.batterySerial.set("1,2",this.certData['powerSupplyCertifications'].batterySerial12);
    this.batterySerial.set("1,3",this.certData['powerSupplyCertifications'].batterySerial13);
    this.batterySerial.set("1,4",this.certData['powerSupplyCertifications'].batterySerial14);
    if(this.parallelBatt){
      this.batterySerial.set("1,5",this.certData['powerSupplyCertifications'].batterySerial15);
      this.batterySerial.set("1,6",this.certData['powerSupplyCertifications'].batterySerial16);
    }
    this.batterySerial.set("2,1",this.certData['powerSupplyCertifications'].batterySerial21);
    this.batterySerial.set("2,2",this.certData['powerSupplyCertifications'].batterySerial22);
    this.batterySerial.set("2,3",this.certData['powerSupplyCertifications'].batterySerial23);
    this.batterySerial.set("2,4",this.certData['powerSupplyCertifications'].batterySerial24);
    this.batterySerial.set("3,1",this.certData['powerSupplyCertifications'].batterySerial31);
    this.batterySerial.set("3,2",this.certData['powerSupplyCertifications'].batterySerial32);
    this.batterySerial.set("3,3",this.certData['powerSupplyCertifications'].batterySerial33);
    this.batterySerial.set("3,4",this.certData['powerSupplyCertifications'].batterySerial34);
    this.batterySerial.set("4,1",this.certData['powerSupplyCertifications'].batterySerial41);
    this.batterySerial.set("4,2",this.certData['powerSupplyCertifications'].batterySerial42);
    this.batterySerial.set("4,3",this.certData['powerSupplyCertifications'].batterySerial43);
    this.batterySerial.set("4,4",this.certData['powerSupplyCertifications'].batterySerial44);
    this.batterySerial.set("5,1",this.certData['powerSupplyCertifications'].batterySerial51);
    this.batterySerial.set("5,2",this.certData['powerSupplyCertifications'].batterySerial52);
    this.batterySerial.set("5,3",this.certData['powerSupplyCertifications'].batterySerial53);
    this.batterySerial.set("5,4",this.certData['powerSupplyCertifications'].batterySerial54);
    this.batterySerial.set("6,1",this.certData['powerSupplyCertifications'].batterySerial61);
    this.batterySerial.set("6,2",this.certData['powerSupplyCertifications'].batterySerial62);
    this.batterySerial.set("6,3",this.certData['powerSupplyCertifications'].batterySerial63);
    this.batterySerial.set("6,4",this.certData['powerSupplyCertifications'].batterySerial64);




    this.batteryInstallDates.set("1,1",this.certData['powerSupplyCertifications'].installDate11);
    this.batteryInstallDates.set("1,2",this.certData['powerSupplyCertifications'].installDate12);
    this.batteryInstallDates.set("1,3",this.certData['powerSupplyCertifications'].installDate13);
    this.batteryInstallDates.set("1,4",this.certData['powerSupplyCertifications'].installDate14);
    if(this.parallelBatt){
      this.batteryInstallDates.set("1,5",this.certData['powerSupplyCertifications'].installDate15);
      this.batteryInstallDates.set("1,6",this.certData['powerSupplyCertifications'].installDate16);
    }


    this.batteryInstallDates.set("2,1",this.certData['powerSupplyCertifications'].installDate21);
    this.batteryInstallDates.set("2,2",this.certData['powerSupplyCertifications'].installDate22);
    this.batteryInstallDates.set("2,3",this.certData['powerSupplyCertifications'].installDate23);
    this.batteryInstallDates.set("2,4",this.certData['powerSupplyCertifications'].installDate24);
    this.batteryInstallDates.set("3,1",this.certData['powerSupplyCertifications'].installDate31);
    this.batteryInstallDates.set("3,2",this.certData['powerSupplyCertifications'].installDate32);
    this.batteryInstallDates.set("3,3",this.certData['powerSupplyCertifications'].installDate33);
    this.batteryInstallDates.set("3,4",this.certData['powerSupplyCertifications'].installDate34);
    this.batteryInstallDates.set("4,1",this.certData['powerSupplyCertifications'].installDate41);
    this.batteryInstallDates.set("4,2",this.certData['powerSupplyCertifications'].installDate42);
    this.batteryInstallDates.set("4,3",this.certData['powerSupplyCertifications'].installDate43);
    this.batteryInstallDates.set("4,4",this.certData['powerSupplyCertifications'].installDate44);
    this.batteryInstallDates.set("5,1",this.certData['powerSupplyCertifications'].installDate51);
    this.batteryInstallDates.set("5,2",this.certData['powerSupplyCertifications'].installDate52);
    this.batteryInstallDates.set("5,3",this.certData['powerSupplyCertifications'].installDate53);
    this.batteryInstallDates.set("5,4",this.certData['powerSupplyCertifications'].installDate54);
    this.batteryInstallDates.set("6,1",this.certData['powerSupplyCertifications'].installDate61);
    this.batteryInstallDates.set("6,2",this.certData['powerSupplyCertifications'].installDate62);
    this.batteryInstallDates.set("6,3",this.certData['powerSupplyCertifications'].installDate63);
    this.batteryInstallDates.set("6,4",this.certData['powerSupplyCertifications'].installDate64);

    this.batteryVoltages.set("1,1",this.certData['powerSupplyCertifications'].voltage11);
    this.batteryVoltages.set("1,2",this.certData['powerSupplyCertifications'].voltage12);
    this.batteryVoltages.set("1,3",this.certData['powerSupplyCertifications'].voltage13);
    this.batteryVoltages.set("1,4",this.certData['powerSupplyCertifications'].voltage14);
    if(this.parallelBatt){
      this.batteryVoltages.set("1,5",this.certData['powerSupplyCertifications'].voltage15);
      this.batteryVoltages.set("1,6",this.certData['powerSupplyCertifications'].voltage16);
    }


    this.batteryVoltages.set("2,1",this.certData['powerSupplyCertifications'].voltage21);
    this.batteryVoltages.set("2,2",this.certData['powerSupplyCertifications'].voltage22);
    this.batteryVoltages.set("2,3",this.certData['powerSupplyCertifications'].voltage23);
    this.batteryVoltages.set("2,4",this.certData['powerSupplyCertifications'].voltage24);
    this.batteryVoltages.set("3,1",this.certData['powerSupplyCertifications'].voltage31);
    this.batteryVoltages.set("3,2",this.certData['powerSupplyCertifications'].voltage32);
    this.batteryVoltages.set("3,3",this.certData['powerSupplyCertifications'].voltage33);
    this.batteryVoltages.set("3,4",this.certData['powerSupplyCertifications'].voltage34);
    this.batteryVoltages.set("4,1",this.certData['powerSupplyCertifications'].voltage41);
    this.batteryVoltages.set("4,2",this.certData['powerSupplyCertifications'].voltage42);
    this.batteryVoltages.set("4,3",this.certData['powerSupplyCertifications'].voltage43);
    this.batteryVoltages.set("4,4",this.certData['powerSupplyCertifications'].voltage44);
    this.batteryVoltages.set("5,1",this.certData['powerSupplyCertifications'].voltage51);
    this.batteryVoltages.set("5,2",this.certData['powerSupplyCertifications'].voltage52);
    this.batteryVoltages.set("5,3",this.certData['powerSupplyCertifications'].voltage53);
    this.batteryVoltages.set("5,4",this.certData['powerSupplyCertifications'].voltage54);
    this.batteryVoltages.set("6,1",this.certData['powerSupplyCertifications'].voltage61);
    this.batteryVoltages.set("6,2",this.certData['powerSupplyCertifications'].voltage62);
    this.batteryVoltages.set("6,3",this.certData['powerSupplyCertifications'].voltage63);
    this.batteryVoltages.set("6,4",this.certData['powerSupplyCertifications'].voltage64);

    this.batteryManagerModels1.push(this.certData['powerSupplyCertifications'].batteryBalancerString);

    // this.batteryManagerModels1.push(this.certData['powerSupplyCertifications'].batteryBalancerString1);
    // this.batteryManagerModels1.push(this.certData['powerSupplyCertifications'].batteryBalancerString1);
    // this.batteryManagerModels1.push(this.certData['powerSupplyCertifications'].batteryBalancerString1);
    // this.batteryManagerModels1.push(this.certData['powerSupplyCertifications'].batteryBalancerString1);
    // this.batteryManagerModels1.push(this.certData['powerSupplyCertifications'].batteryBalancerString1);
    // this.batteryManagerModels1.push(this.certData['powerSupplyCertifications'].batteryBalancerString1);
    var str = this.certData['powerSupplyCertifications']['numberOfBatteries'];
    var splitted = str.split(" ");
    if (str.includes(this.parallel)) {
      this.batfirst = 1;
    } else {
      this.batfirst = splitted[0];
    }
    this.batlast = splitted[3];

  });
    this.datesharedService.editpssharedDatadetailtab$
    .subscribe(resultdetail=> {
      if (resultdetail == 'tabview') {
        setTimeout(() => {

          this.subselectedTabIndex = 1;
          this.ref.detectChanges();
        });
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
    this.userDetails = JSON.parse(localStorage['user-details']);
    if (this.userDetails.permissions.includes('{1091}')) {
      this.permissionValue = true;
    }else{
      this.permissionValue = false;
    }

    //this.userpermissions = this.authService.getDecryptConfig
    this.userpermissions = JSON.parse(localStorage.getItem('user-permissions'));
    if (this.userpermissions=='' || !this.authService.isAuthorizedPSNBUser) {
      this.router.navigate(['/unauthorized']);
    }
    for (let element of this.userpermissions) {
      if (element.category === CommonService.EDITICONCAT && element.functionality === CommonService.EDITICON && element.permission != CommonService.ENABLED) {
        this.router.navigate(['/pageunauthorized']);
        return;
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.EDITLOCATION) {
        this.showLocationEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.EDITTRANSPONDERINFO) {
        this.showTransponderEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.EDITBATTERYINFO) {
        this.showBatteryEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.SHOWALERTSEVENTS) {
        this.showAlertsEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.SHOWHISTORY) {
        this.showHistoryEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.EDITLASTVISITINFO) {
        this.showLastVisitEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.EDITPHOTOS) {
        this.showPhotosEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.EDITLASTCERTIFICATION) {
        this.showLastCertEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.MACADDRESSLINK) {
        this.psMacLinkEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.XM360REPORTBUTTON) {
        this.xmRepBtnEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.ADDAPUINFO) {
        this.showApuInfo = this.permissionlevel(element.permission);;
      }
      if (element.category === CommonService.POWERSUPPLYEDIT && element.functionality === CommonService.ADDAPUVISIT) {
        this.showApuVisit = this.permissionlevel(element.permission);;
      }
    }
    const message = `PowerSupply Edit. MAC Address: ${this.macAddress}`;
    const activity = 'PowerSupply Edit';
    this.commonService.loggerPost(message, activity, 3);

    this.data_ser.currentMessage.subscribe((data) => {
      //get the visit form data
      this.visitdata = data;
    })
    this.locationInfoForm = this.fb.group({
      locationInfoFormInput: [],
    })

    this.powerCompanyFinderUrl = environment.powerCompanyFinderUrl;
    this.getPowerSupplyDetails(this.macAddress,this.triageId);

    this.userName = this.authService.getUserDetails.userName;
    this.batteryHeaterMatService.getBatteryHeaterMatTypesService().subscribe(res => {
      res.forEach(result => this.batteryHeaterMatTypes.push(result.batteryHeaterMatType));
    });
    this.powerSupplyService.getOutputSurgeArrestorsService().subscribe(res => {
      res.forEach(result => this.outputSurgeArrestors.push(result.name));
    });
    // this.powerSupplyService.getControllerCardTypesService().subscribe(res => {
    //   res.forEach(result => this.cardTypes.push(result.name));
    // });
    this.powerSupplyService.getBatteryTypesService().subscribe(res => {
      res.forEach(result => this.batteryManufactureres.push(result.batteryType));
    });
    // this.powerSupplyService.getBatteryBalancersService().subscribe(res => {
    //   res.forEach(result => this.batteryManagerModels.push(result.balancerModel));
    // });
    // this.powerSupplyService.getEstimatedDesignRuntimesService().subscribe(res => {
    //   res.forEach(result => this.estimates.push(result.name));
    // });
    this.nextGenNodeService.getAllNextGenNodes().subscribe(result => {
      result.forEach(res => this.nextGenOptions.push(res.nextGenNode));
    });
    this.powerSupplyService.getInputSurgeArrestorsService().subscribe(res => {
      res.forEach(result => this.surgeArrestorInputs.push(result.name));
    });
    this.cabinetVendorService.getAllCabinetVendors().subscribe(res => {
      res.forEach(result => this.cabinetVendors.push(result.name));
    });
    this.powerSupplyService.getStandByOptionsByState(this.state).subscribe(res => {
      res.forEach(result => this.standByOptions.push(result.standbyOptions));
    });

    this.getTelemetryThresholdsAlertProfileData();
    //common edit save
    this.currSub = this.data.currentMessage.subscribe((data) => {
      if (data['issubmit']) {
        this.save();
      }
    })
    this.checkMandatoryImages(false);
  }
  getFormsApuVisit() {
    this.apuVisitFormGroup = this.fb.group({
      apuinspectionDate: [''],
      apuVisitedTech: [(this.triageLogNt) ? this.triageLogNt : this.userName],
      apuBatteryManuType: [''],
      apuBatteryDateCode: [''],
      apuBatteryInstallDate: [''],
      apuBatteryVltgNoLoad: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryConductance: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryCon77deg: [''],
      apuBatteryTorque: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryTerminals: [''],
      apuStarter: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuCharger: ['', [NumberOnlyValidation.ValidateNumber()]],
      followup: [''],
      recordAsFoundAlarms: [''],
      apuTestRun: [''],
      checkOilLevel: [''],
      ifOilAdded: [''],
      oilFilterTight: [''],
      inspectGenerator: [''],
      inspectSparkPlug: [''],
      clearApuEventlog: [''],
      apuFrequency: [''],
      tank1: [''],
      tank2: [''],
      gasMeter: [''],
      gasMeterReading: [''],
      ngPressure: [''],
      airFilter: [''],
      rodentInsectDamage: [''],
      checkLamps: [''],
      clearWeeds: [''],
      checkRegrout: [''],
      ifGroundMount: [''],
      anyEnclosure: [''],
      cleanUpGarbage: [''],
      testOilPressure: [''],
      testhighTemp: [''],
      generatorDcBus: [''],
      checkForGas: [''],
      testCombustible: [''],
      testTamper: [''],
      testWaterIntrusion: [''],
      testPad: [''],
      comments: ['', [Validators.maxLength(225)]]
    });

    this.apuFormGroup = this.fb.group({
      apuMakeModel: ['', this.inbuiltValue ? null : Validators.required],
      apuSerialNumber: ['', this.inbuiltValue ? null : Validators.required],
      apuDeviceId: ['', this.inbuiltValue ? null : Validators.required],
      apuRunTime: ['', this.inbuiltValue ? null : Validators.required],
      ecmAcm: ['', this.inbuiltValue ? null : Validators.required],
      dateApuInstalled: ['', this.inbuiltValue ? null : Validators.required],
      apuOpVltgRating: ['', this.inbuiltValue ? null : Validators.required],
      apuNoLoadVltg: ['', [this.inbuiltValue ? null : Validators.required, NumberOnlyValidation.ValidateNumber()]],
      apuLoadVltg: ['', [this.inbuiltValue ? null : Validators.required, NumberOnlyValidation.ValidateNumber()]],
      apuEnclosure: ['', this.inbuiltValue ? null : Validators.required],
      ngLp: ['', this.inbuiltValue ? null : Validators.required],
      ngProvider: ['', this.inbuiltValue ? null : Validators.required],
      lpTankCapacity: ['', this.inbuiltValue ? null : Validators.required],
      noOfTanksInstalled: ['', [this.inbuiltValue ? null : Validators.required, NumberOnlyValidation.ValidateNumber()]],
    });

    this.locationInfoForm = this.fb.group({
      houseNumberInput: [''],
      street: ['', Validators.required],
      crossStreet: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      primaryNode: [{ value: '', disabled: true }],
      prevNodeServed: [{ value: '', disabled: true }],
      mutliNodes: ['', Validators.required],
      latitude: ['', [Validators.required, GpsLatitudeValidation.ValidateDecimal(this.region), GpsLatitudeValidation.ValidateRange(this.region)]],
      longitude: ['', [Validators.required, GpsLongitudeValidation.ValidateDecimal(this.region), GpsLongitudeValidation.ValidateRange(this.region)]],
      calculatedRuntime: [{value: '', disabled: true}],
      powerNode: ['', Validators.required],
      spLocDetails: [''],
      areial: ['', Validators.required],
      powerAccountType: [''],
      pole: [''],
      powerCompany: ['', Validators.required],
      companyAccNum: [''],
      companyContact: [''],
      companyWebsite: [''],
      nwtTeam: [{value: '', disabled: true}],
      nitroCompletionDate: [''],
      nitroReasonNotCompleted: [''],
      meter: [''],
      mapPageNumber: [''],
      businesspartner: [''],
      locationComments: ['', [Validators.maxLength(225)]]
    });
    this.transponderInfoForm = this.fb.group({
      standByOpts: ['', Validators.required],
      activeMacAddress: [{ value: this.activeMacAddress }, [Validators.required, MACPlaceholderValidation.ValidateMac00(), MACPlaceholderValidation.ValidateEditMac()]],
      prevMacAddress: [{ value: '', disabled: true }],
      ip: ['', Validators.required],
      powerSupplyNum: ['', [Validators.required, PowerSupplyNumValidation.ValidatePowerSupplyNum(this.region)]],
      nextGenNode: [''],
      sfpMac: [{ value: '', disabled: true }],
      transponderVendor: ['', [Validators.required]],
      transponderModel: ['', Validators.required],
      powerSupplyModel: [''],
      powerSupplyType9360: [''],
      acInputVoltage: ['', [Validators.required]],
      acOutputVoltage: ['', [Validators.required]],
      // acInputVoltage: ['', [Validators.required, PowerSupplyNumValidation.ValidateacInputVoltage(this.inputVoltageRatings)]],
      // acOutputVoltage: ['', [Validators.required, PowerSupplyNumValidation.ValidateacOutputVoltage(this.outputVoltageRatings)]],
      currentAmp: ['', [Validators.required, PowerSupplyNumValidation.ValidatecurrentAmp(this.ampRatings)]],
      //currentAmpOutput: ['', [Validators.required, PowerSupplyNumValidation.ValidatecurrentAmpOutput()]],
      //currentAmpOutput: ['', [Validators.required]],
      powerSupplyAlertProfile: [{ value: this.powerSupplyAlertProfile, disabled: true }],
      serialNum: [''],
      //controlledCardType: ['', Validators.required],
      dcReady: [''],
      priority: [''],
      egisName: [''],
      externalSendor: [''],
      globalidentifier: [{ value: '', disabled: true }],
      transponderComments: ['', [Validators.maxLength(225)]]
    }, {
      validator: TransponderFormValidator.ValidateVendorType
    });

    this.onChangeSysLocation();

    this.lastVisitInfoForm = this.fb.group({
      inspectionDate: [''],
      selftest: ['', Validators.required],
      selftestrunning: ['', Validators.required],
      // selftestfailed: ['', Validators.required],
      typeOfVisit: [''],
      xocVerified: [''],
      visitStatus: [''],
      followupReason: [''],
      mobileno: ['', this.permissionValue ? null : Validators.required],
      cleanDust: [''],
      tightenAll: [''],
      inspectWire: [''],
      inspectBattery: [''],
      meterPan: [''],
      powerCo: [''],
      batteryHeaterType: [''],
      batteryHeaterQuantity: [''],
      encloseSnow: [''],
      internalBreaker: [''],
      serviceEntrance: [''],
      receptacleType: [''],
      checkSeizure: [''],
      psIDLegibile: [''],
      checkLamps: [''],
      checkCircuitBreaker: [''],
      visualInspection: [''],
      cabinetLocked: [''],
      securityBar: [''],
      checkGround: [''],
      batteryStringFused1: [''],
      batteryStringFused2: [''],
      batteryStringFused3: [''],
      batteryStringFused4: [''],
      batteryStringFused5: [''],
      batteryStringFused6: [''],
      tamperInstalled: [''],
      checkLaps: [''],
      cabinetVendor: [''],
      cabinetBattery: [''],
      checkOperating: [''],
      followUp: [''],
      inputSurge: [''],
      outputSurge: [''],
      coaxTvss: [''],
      acIndicator: [''],
      lri: [''],
      lastVisitComments: [''],
      workitem: [''],
      checkAll:['']
    });

    this.batteryInfoForm = this.fb.group({
      numberofBatteries: ['', Validators.required],
      batteriesReplaced: ['', Validators.required],
      //airTemperature: [''],
      batteryManagerModel: ['', Validators.required],
      batteryComments: ['', [Validators.maxLength(225)]]
    });

    this.nodesForm = this.fb.group({
      node: this.fb.array([])
    })

    this.batteryStringForm = this.fb.group({
      batteryString: this.fb.array([])
    });

    this.batteryBatteryForm = this.fb.group({
      batteryBatteries: this.fb.array([])
    });

    if (this.region === 'Boston Region') {
      this.showPSNumberInput = true;
      this.showPSNumberSelect = false;
    } else if (this.region === 'Freedom Region') {
      this.showPSNumberInput = false;
      this.showPSNumberSelect = true;
      this.PSNOptions = this.PSNFreedomOptions;
    } else if (this.region === 'Keystone Region') {
      if (this.hierarchyPath.includes('Keystone East')) {
        this.PSNOptions = this.PSKeyStoneEastOptions;
      } else if (this.hierarchyPath.includes('Keystone West')) {
        this.PSNOptions = this.PSKeyStoneWestOptions;
      }
    } else if (this.region === 'Beltway Region') {
      this.showPSNumberInput = false;
      this.showPSNumberSelect = true;
      this.PSNOptions = this.PSNOptionsOther;
    } else {
      this.showPSNumberInput = true;
      this.showPSNumberSelect = false;
    }
    this.showForms = true;
  }
  rearrangePhotoDates(photoDates) {
    var photoSplitted = photoDates != null ? photoDates.split(",") : null;
    if (photoSplitted != null) {
      for (let i = 0; i < photoSplitted.length; i++) {
        var photoCatDate = photoSplitted[i].split("=>");
        for (let j = 1; j <= 11; j++) {
          if (photoCatDate[0].trim() === j.toString()) {
            this['catDate'+j] = photoCatDate[1];
            break;
          }
        }
      }
    }

  }
  getWorkItemsviewCertification(powerSupplyId,certid) {
    this.powerSupplyService.getWorkItemsByPowerSupplyId(powerSupplyId, certid).subscribe((res) => {
      this.workItems = res;
    });
  }
  getMaterialItemsviewCertification(powerSupplyId,certid) {
    this.powerSupplyService.getMaterialItemsByPsId(powerSupplyId, certid).subscribe((res) => {
      this.workItemsMaterial = res;

    });
  }
/*Function to get the Power Supply battery data - Detailed view based */
numberOfBatteriesAndStrings(numberOfBatteries: string) {
  if (numberOfBatteries !== '' && numberOfBatteries !== null && numberOfBatteries !== undefined || numberOfBatteries !== '0 String Of 0') {
    const split: string[] = numberOfBatteries.split(' ');
    // this.noOfStrings = Array(Number(split[0])).fill(0).map((x, i) => i + 1);
    // this.noOfBatteries1 = Array(Number(split[3])).fill(0).map((x, i) => i + 1);
    if(split != null && split.length > 0){
      if(split[0] == 'Parallel')
        this.parallelBatts = true;
    }
    if(this.parallelBatts){
      this.noOfBatteries1 = Array(Number(split[1])).fill(0).map((x, i) => i + 1);
      this.noOfStrings = Array(Number('1')).fill(0).map((x, i) => i + 1);
    } else {
      if(numberOfBatteries == '1LionBMS'){
        this.noOfStrings = Array(1);
        this.noOfBatteries1 = Array(1);
      }else{

        this.noOfStrings = Array(Number(split[0])).fill(0).map((x, i) => i + 1);
        this.noOfBatteries1 = Array(Number(split[3])).fill(0).map((x, i) => i + 1);
      }
    }
  }
}
onChangeIns(event){
  this.ins_date = formatDate(new Date(), 'dd/MM/yyyy', 'en-US');
  if(event.checked){
      this.lastVisitInfoForm.controls['inspectionDate'].setValue('');
      this.lastVisitInfoForm.controls['inspectionDate'].setValue(new Date());
  }else{
    this.lastVisitInfoForm.controls['inspectionDate'].setValue('');
  }
  var selectedDate = this.lastVisitInfoForm.value.inspectionDate;
  if((selectedDate != '' || selectedDate != null) && this.certRequiredValue){
    this.insFlag = true
    let inspectionDate = formatDate(new Date(selectedDate), 'MM/dd/yyyy', 'en-US')
    this.getPSCertificationID(this.powerSupplyIdval,inspectionDate);
  }
 }
//change the inspection date if more than 30 days from the old inspection date
onChangeinspection(templateRef: TemplateRef<any>,templateRefReturn: TemplateRef<any>) {
  // var selectedDate = this.lastVisitInfoForm.value.inspectionDate;
  // var oldinspectionDate = new Date(this.oldinspection).getTime();
  // //alert(oldinspectionDate)
  // var newinspectionDate = new Date(selectedDate).getTime();
  // let lastVisitExpiryDate = environment.thirtyDaysInMilliseconds;
  // if(oldinspectionDate != 0){
  //   if ((newinspectionDate - oldinspectionDate > lastVisitExpiryDate) && this.certFlag) {
  //     //change the inspection date if more than 30 days from the old inspection date
  //    // this.dialog.open(templateRef);
  //     this.dialog.open(
  //       templateRef, {
  //           disableClose: true
  //       });
  //       this.moremonth = true;
  //   }
  //   //If the type of visit is return visit and inspection Date is more than 30 days
  //   let eventtypeofvisit = this.lastVisitInfoForm.value.typeOfVisit;
  //   if ((newinspectionDate - oldinspectionDate > lastVisitExpiryDate)) {
  //     if(eventtypeofvisit == 'Return Visit' && !this.permissionValue){
  //       //Return Visit Logic -- more than 30 days show edit certification or new certification(work only on atleast one cert)
  //       this.dialog.open(
  //         templateRefReturn, {
  //         disableClose: true
  //       });
  //     }
  //   }
  // }

  var selectedDate = this.lastVisitInfoForm.value.inspectionDate;
  if((selectedDate != '' || selectedDate != null) && this.certRequiredValue){
    this.insFlag = true
    let inspectionDate = formatDate(new Date(selectedDate), 'MM/dd/yyyy', 'en-US')
    this.getPSCertificationID(this.powerSupplyIdval,inspectionDate);
  }
}
  processData(rowData) {
    this.showProgressBar = true;
    rowData.psAlertsList.forEach(element => {
      if (element.deviceName && element.deviceType) {
        element.impactedDevices = element.deviceName.replace(/,/g, ', ') + ' - ' + element.deviceType  + ' (Storm)';
      }
      element.alertStartTime = (element.alertStartTime) ? new Date(element.alertStartTime).toLocaleString() : null;
      element.alertEndTime = (element.alertEndTime) ? new Date(element.alertEndTime).toLocaleString() : null;
      element.psExpectedFailureTime = (element.psExpectedFailureTime) ? new Date(element.psExpectedFailureTime).toLocaleString() : null;

      let alertDuration = null;
      if (element.alertDuration) {
        alertDuration = (element.alertDuration > 1) ? 'Mins' : 'Min';
        alertDuration = element.alertDuration + ' ' + alertDuration;
      } else if ( element.alertEndTime && Math.abs(element.alertEndTime - element.alertStartTime) < 100000) {
        alertDuration = '0 Min';
      }
      element.alertDuration =  alertDuration;

      if (!element.deviceName && element.psNodes) {
        element.impactedDevices = element.psNodes + ' - ' + element.deviceType + ' (PSNB)';
      }
    });
    this.showProgressBar = false;
    return rowData;
  }
  getAlerts(psid){
    this.showProgressBar = true;
    this.showcount = false;
    this.powerSupplyAlertsRequest.alertClearType = "B";
    //this.powerSupplyAlertsRequest.alertLevelList = ['alert'];
    this.powerSupplyAlertsRequest.powersupplyId = Number(psid);
    this.powerSupplyAlertsRequest.historyReq = false;
    this.powerSupplyAlertsRequest.pageNo = 0;
    this.powerSupplyAlertsRequest.rowLimit = 5000;
    this.powerSupplyAlertsRequest.sortBy = "DESC";
    this.psnbApi.getPowerSupplyAlertsList(this.powerSupplyAlertsRequest).subscribe(result => {
      this.alertResult = this.processData(result);
      if(this.alertResult['psAlertsList'].length > 0){
        this.noData = false;
        this.alertResultData = this.alertResult['psAlertsList'];
      }else{
        this.noData = true;
        this.alertResultData = [];
      }
      this.showcount = true;
      this.showProgressBar = false;
    }, err => {
      this.showProgressBar = false;
    });
  }
  /*selftestvalidity() {
    if (this.telemetryinverterStatus != 'OFFLINE' && this.telemetryinverterStatus != undefined ) {
      if (this.lastRunDate != null && this.lastRunDate != 'NA' && this.lastRunDate != undefined) {
        var currentDate = new Date().getTime() + (1 * 24 * 60 * 60)
        var currdate = new Date(new Date(currentDate).toLocaleString());
        var Rundate = new Date(new Date(this.lastRunDate).toLocaleString());
        var currdatebefore = new Date();
        currdatebefore.setDate(currdate.getDate() - 1);
        if (currdatebefore > Rundate)
          this.selftestexpired = true;
        else
          this.selftestexpired = false;
      } else {
        this.selftestexpired = true;
      }
    }
  }
  refresh() {
    this.refreshSpin = 'fa-spin';
    this.powerSupplyService.getPowerSupplyTelemetryData(this.macAddress).subscribe(result => {
      if (result != null) {
        this.inverterStatusVal = result.inverterStatusVal;
        this.telemetryinverterStatus = result.inverterStatus;
      }
      else {
        this.inverterStatusVal = 'NA';
        this.telemetryinverterStatus = 'NA';
      }
    });
    let i = 0;
    let self_test_op_found = false;
    this.powerSupplyOperationsSvc.getPowerSupplyOperationsList(this.powerSupplyId).subscribe(res => {
      this.rowData = res;
      setTimeout(() => {
      if (this.rowData != null && this.rowData != undefined) {
        for (i = 0; i < this.rowData.length; i++) {
          if (this.rowData[i].operationPerformed == "SELF_TEST") {
            self_test_op_found = true;
            this.lastRunStatus = this.rowData[i].status;
            this.lastRunDate = this.rowData[i].testStartDate ? new Date(this.rowData[i].testStartDate).toLocaleString() : 'NA';
            this.selftestvalidity();
            //default values for the last selftest run results
            this.status = this.rowData[i].status;
            this.testduration = this.rowData[i].testDuration;
            this.teststartdate = this.rowData[i].testStartDate ? new Date(this.rowData[i].testStartDate) : null;
            this.testenddate = this.rowData[i].actualEndDate ? new Date(this.rowData[i].actualEndDate) : null;
            break;
          }
        }
        if (self_test_op_found == false) {
          this.lastRunDate = 'NA';
          this.status = null;
          this.testduration = null;
          this.teststartdate = null;
          this.testenddate = null;
          this.selftestvalidity();
        }
      }
      else {
        this.lastRunDate = 'NA';
        this.status = null;
        this.testduration = null;
        this.teststartdate = null;
        this.testenddate = null;
        this.selftestvalidity();
      }
    }, 3000);
    });
    setTimeout(() => {

      if (self_test_op_found == true) {
        if (this.rowData[i].actualEndDate != null && this.inverterStatusVal == null) {
          //OFFLINE
          if (this.lastRunStatus == 'FAILURE') {
            this.telemetryinverter = "FAILURE";
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            this.manualdisabled = true;
            clearInterval(this.interval);
          } else {
            this.telemetryinverter = "Self Test Completed";
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            this.manualdisabled = true;
            clearInterval(this.interval);
          }
        } else if (this.rowData[i].actualEndDate == null && this.inverterStatusVal == 1) {
          //NORMAL - 1 but actualEndDate is null
          if (this.lastRunStatus == 'FAILURE') {
            this.telemetryinverter = "FAILURE"
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            this.manualdisabled = false;
          } else {
            this.telemetryinverter = "Self Test Initiated"
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            if (this.certRequiredValue) {
              this.lastVisitInfoForm.controls["selftestrunning"].setValidators(Validators.required);
              this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            }
            this.manualdisabled = true;
          }
        } else if ((this.rowData[i].actualEndDate == null && this.inverterStatusVal == 4) || (this.rowData[i].actualEndDate == null && this.inverterStatusVal == 3)) {
          //ON: Remote test initiated - 4
          this.telemetryinverter = "Self Test Running";
          this.lastVisitInfoForm.controls["selftest"].clearValidators();
          this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
          if (this.certRequiredValue) {
            this.lastVisitInfoForm.controls["selftestrunning"].setValidators(Validators.required);
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
          }
          this.manualdisabled = true;
        } else if ((this.rowData[i].actualEndDate != null && this.inverterStatusVal == 5) || (this.rowData[i].actualEndDate != null && this.inverterStatusVal == 2)) {
          //ALARM: Last Test Failed - 5
          //LINE FAILED -2
          if (this.lastRunStatus == 'FAILURE') {
            this.telemetryinverter = "Self Test Failed";
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            this.manualdisabled = false;
            clearInterval(this.interval);
          } else {
            this.telemetryinverter = "Self Test Completed";
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            if (this.selftestexpired)
              this.manualdisabled = false;
            else
              this.manualdisabled = true;
            clearInterval(this.interval);
          }
        } else if (this.rowData[i].actualEndDate != null && this.inverterStatusVal == 3) {
          if (this.lastRunStatus == 'FAILURE') {
            this.telemetryinverter = "FAILURE";
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            this.manualdisabled = false;
            clearInterval(this.interval);
          } else {
            this.telemetryinverter = "Self Test Completed";
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            if (this.selftestexpired)
              this.manualdisabled = false;
            else
              this.manualdisabled = true;
            clearInterval(this.interval);
          }
        } else if (this.rowData[i].actualEndDate != null && this.inverterStatusVal == 1) {
          //NORMAL - 1
          if (this.lastRunStatus == 'FAILURE') {
            this.telemetryinverter = "FAILURE";
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            this.manualdisabled = false;
            clearInterval(this.interval);
          } else {
            this.telemetryinverter = "Self Test Completed";
            this.lastVisitInfoForm.controls["selftest"].clearValidators();
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
            if (this.selftestexpired)
              this.manualdisabled = false;
            else
              this.manualdisabled = true;
            clearInterval(this.interval);
          }
        } else {
          this.telemetryinverter = this.lastRunStatus ? this.lastRunStatus : 'NA';
          this.selftestexpired = false;
          this.lastVisitInfoForm.controls["selftest"].clearValidators();
          this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
          this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
          this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
        }
        if (this.telemetryinverter != "Self Test Initiated" && this.telemetryinverter != "Self Test Running" && this.selftestexpired && this.certRequiredValue) {
          this.lastVisitInfoForm.controls["selftest"].setValidators(Validators.required);
          this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
          this.ref.detectChanges();
        } else if (this.telemetryinverter == "Self Test Initiated" || this.telemetryinverter == "Self Test Running") {
          if (!this.interval) {
            this.interval = setInterval(() => {
              this.refresh();
            }, 60000);
          }
        }
      } else {
        if (this.telemetryinverterStatus == 'ON: Local Test Cycle') {
          this.telemetryinverter = "Self Test Running";
          this.selftestexpired=false;
          this.lastVisitInfoForm.controls["selftest"].clearValidators();
          this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
          if (this.certRequiredValue) {
            this.lastVisitInfoForm.controls["selftestrunning"].setValidators(Validators.required);
            this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
          }
        } else {
          if (this.selftestexpired && this.certRequiredValue) {
            this.lastVisitInfoForm.controls["selftest"].setValidators(Validators.required);
            this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
            this.ref.detectChanges();
          }
          this.telemetryinverter = 'NA';
          if (this.telemetryinverterStatus == 'OFFLINE')
            this.manualdisabled = true;
        }
      }
      this.refreshSpin = '';
      this.ref.detectChanges();
    }, 6000);
    this.ref.detectChanges();
  }*/
  SortByName(x, y) {
    return ((x == y) ? 0 : ((x > y) ? 1 : -1));
  }
  ngOnDestroy() {
    if(this.currSub)
    this.currSub.unsubscribe();
    // if(this.interval) clearInterval(this.interval);
  }

/*getOperationList(macaddress) {
  this.showProgressBar = true;
  this.powerSupplyOperationsSvc.getPowerSupplyOperationsList(macaddress).subscribe(res => {
    this.processedData = this.processData(res);
    this.rowData = res;
    if (this.rowData !== null && this.rowData.length > 0) {
      this.lastRundate = this.rowData[0].lastRunDate;
      this.lastRunDate = new Date(this.lastRundate).toLocaleString();
      this.lastRunStatus = this.rowData[0].status;
      //Checking for validation more than 24 hours old
      var currentDate = new Date().getTime() + (1 * 24 * 60 * 60)
      var currdate = new Date(new Date(currentDate).toLocaleString());
      var Rundate = new Date(new Date(this.lastRunDate).toLocaleString());
      var currdatebefore = new Date();
      currdatebefore.setDate(currdate.getDate() - 1);
      if (currdatebefore > Rundate) {
         //this.flag=true;
        setTimeout(() => {
          this.lastVisitInfoForm.controls["selftest"].setValidators(Validators.required);
          this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
          this.lastVisitInfoForm.controls["selftestrunning"].clearValidators();
          this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
          this.ref.detectChanges();
        }, 12000);
      }
      this.refresh();
    }else{
      this.lastRundate = 'NA';
      this.lastRunDate = 'NA';
      this.lastRunStatus = 'NA';
      this.telemetryinverter = 'NA';
      this.manualdisabled = true;
    }
    this.refreshSpin = '';
    this.showProgressBar = false;
    this.ref.detectChanges();

  }, err => {
    if (err.status === 401) {
      this.router.navigate(['/unauthorized']);
      this.refreshSpin = '';
    }
  });
}*/

/*processData(rowData) {
  rowData.forEach(element => {
    element.testStartDate = element.testStartDate ? new Date(element.testStartDate).toLocaleString() : null;
  });
  return rowData;
}*/

/*remotetest() {
   this.manualdisabled = true;
   this.onClickGenerateIP();
   this.psnbApi.selfTestStart(this.ipAddress, this.macAddress,this.powerSupplyId).subscribe(result => {
    if(result.success === true) {
      this.flag=true;
      this.matsnackbar.open('Self Start Completed successfully.', 'dismiss', {
      duration: 2000
      });
      this.telemetryinverter = "Self Test Initiated";
      this.lastVisitInfoForm.controls["selftest"].clearValidators();
      this.lastVisitInfoForm.controls["selftest"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["selftestrunning"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["selftestrunning"].updateValueAndValidity();
      this.ref.detectChanges();
      this.interval = setInterval(() => {
        this.refresh();
      }, 60000);
    } else {
      this.manualdisabled = false;
      this.matsnackbar.open('Self Start not Completed successfully. Please try again.', 'error', {
      duration: 4000
      });
      this.ref.detectChanges();
    }
   },err => {
    this.manualdisabled = false;
    this.matsnackbar.open('Self Start not Completed successfully. Please try again.', 'error', {
     duration: 4000
    });
    this.ref.detectChanges();
   });
}*/
  fieldConfig() {
    this.PsEditFieldsMetadata = JSON.parse(localStorage['AllPsEditFieldsMetadata']);
    if (this.PsEditFieldsMetadata == null || this.PsEditFieldsMetadata == '') {
      return new Promise((resolve, reject) => {
        this.psConfigService.getAllPsEditFieldsMetadata().subscribe((res) => {
          this.PsEditFieldsMetadata = res;
          this.getFieldValue();
        });
        resolve('Fetched AllPsEditFieldsMetadata Detail');

      });
    } else {
    this.getFieldValue();
    }
     //sorting json values asc
     //this.visitTypesbp.sort(this.SortByName);
     //this.visitTypesinhouse.sort(this.SortByName);
       this.visitStatusvalue.sort(this.SortByName);
       this.followUpReasons.sort(this.SortByName);
       this.InspectBatteryTemperatureProbes.sort(this.SortByName);
       this.coRiserCondition.sort(this.SortByName);
       this.snowSheildOptionss.sort(this.SortByName);
       this.seizureScres.sort(this.SortByName);
       this.powerSupplyIDLegibilitis.sort(this.SortByName);
       this.cabinetInspectionvalues.sort(this.SortByName);
       this.cabinetLockOptionvalues.sort(this.SortByName);
       this.securityBarOptionvalues.sort(this.SortByName);
       this.checkGroundConnectionvalues.sort(this.SortByName);
       this.batteryStringFuses.sort(this.SortByName);
       this.tamperInstalledvalue.sort(this.SortByName);
       this.checkLAPsvalue.sort(this.SortByName);
       this.batteryCapacitievalues.sort(this.SortByName);
       this.followUpActionvalue.sort(this.SortByName);
       this.coaxOptionvalues.sort(this.SortByName);
       this.ACIOptionvalues.sort(this.SortByName);
       this.LRIOptionvalues.sort(this.SortByName);
       // this.nodeFeeds.sort(this.SortByName);
       this.UGs.sort(this.SortByName);
       this.nodePowers.sort(this.SortByName);
       this.acctypes.sort(this.SortByName);
       this.businessPartneRestrictions.sort(this.SortByName);
       this.DCReadyDecisions.sort(this.SortByName);
       this.ampOutputRatings.sort(this.SortByName);
       // this.ampRatings.sort(this.SortByName);
       this.outputVoltageRatings.sort(this.SortByName);
       this.inputVoltageRatings.sort(this.SortByName);
       //this.standByOptions.sort(this.SortByName);
       this.numberofBatteries.sort(this.SortByName);
       //this.batterySeparatorPresent.sort(this.SortByName);
       this.batteriesReplaced.sort(this.SortByName);
  }

  getFieldValue() {
      this.PsEditFieldsMetadata.forEach((Itemdata, index) => {
        //     //Location page dynamic
        // if(itemData['fieldName'] == "Feed Multiple Nodes"){
        // this.nodeFeeds.push(itemData['value'])
        // }
        if (Itemdata['fieldName'] == 'Follow Up Reason Needed') {
                  this.followUpReasons.push(Itemdata['value'])
                }
         /*if (Itemdata['fieldName'] == 'Type of Visit - BP') {
           this.TypeofVisitBP.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Type of Visit - Inhouse') {
           this.TypeofVisitInhouse.push(Itemdata['value'])
         }*/
         if (Itemdata['fieldName'] == 'Visit Status') {
           this.visitStatusvalue.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'visitTypes') {
           this.visitTypes.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Clean Dust And Dirt From Enclosure') {
           this.CleanDustDirtFromEnclosure.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Meter Pan Condition') {
           this.MeterPanCondition.push(Itemdata['value'])
         }
        //  if (Itemdata['fieldName'] == 'Battery Heater Mat Type') {
        //    this.batteryHeaterMatType.push(Itemdata['value'])
        //  }
         if (Itemdata['fieldName'] == 'Cabinet Battery Capacity') {
           this.batteryCapacitievalues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Check Operating Lights') {
           this.operatingLightvalues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Follow Up Action Needed') {
           this.followUpActionvalue.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'AC Indicator Green light (ACI)') {
           this.ACIOptionvalues.push(Itemdata['value'])
         }
         if(Itemdata['fieldName']=='Battery String - Fused'){
           this.batteryStringFuses.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Power Co Riser Condition') {
           this.coRiserCondition.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Enclosure Snow Shield') {
           this.snowSheildOptionss.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Check Seizure Screw / Alt Box') {
           this.seizureScres.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Check For 20 Amp Hi-Magnetic Circuit Breaker') {
           this.checkCircuitBreakOptionValues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Visual Inspection Of Cabinet') {
           this.cabinetInspectionvalues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Cabinet Locked') {
           this.cabinetLockOptionvalues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Security Bar Present') {
           this.securityBarOptionvalues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == "Check LAP's") {
           this.checkLAPsvalue.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Coax TVSS Present') {
           this.coaxOptionvalues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Tighten All Enclosure Hardware') {
           this.TightenAllEnclosureHardwares.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Inspect Wire Harnesses And Connectors') {
           this.InspectWireHarnessesConnectors.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Inspect Battery Temperature Probes') {
           this.InspectBatteryTemperatureProbes.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Is Power Supply ID Legible') {
           this.powerSupplyIDLegibilitis.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Check Lamps & LEDs') {
           this.lampCheckOptionValues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Check Ground Connection At Cabinet') {
           this.checkGroundConnectionvalues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Local and Remote Indicator (LRI)') {
           this.LRIOptionvalues.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'XOC Verified Transponder Operational') {
           this.XOCTransponderVerifications.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Tamper Installed And Functioning') {
           this.tamperInstalledvalue.push(Itemdata['value'])
         }
         // if (Itemdata['fieldName'] == 'Feed Multiple Nodes') {
         //   this.nodeFeeds.push(Itemdata['value'])
         // }
         if (Itemdata['fieldName'] == 'Aerial/UG') {
           this.UGs.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Powers Node') {
           this.nodePowers.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Power Company Account Type') {
           this.acctypes.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Business Partner Restriction') {
           this.businessPartneRestrictions.push(Itemdata['value'])
         }
         /*if (Itemdata['fieldName'] == 'StandBy/Non-StandBy') {
           this.standByOptions.push(Itemdata['value'])
         }*/
         if (Itemdata['fieldName'] == 'AC Input Voltage Rating') {
           this.inputVoltageRatings.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'AC Output Voltage Rating') {
           this.outputVoltageRatings.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Current Amp Rating') {
           this.ampRatings.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Current (Amp Output) Rating') {
           this.ampOutputRatings.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'DC Ready?') {
           this.DCReadyDecisions.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Number Of Batteries') {
           this.numberofBatteries.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Battery Separator Present') {
           //this.batterySeparatorPresent.push(Itemdata['value'])
         }
         if (Itemdata['fieldName'] == 'Were The Batteries Replaced(Yes or No)?') {
           this.batteriesReplaced.push(Itemdata['value'])
         }
         if (this.permissionValue) {
          if (Itemdata['fieldName'] == 'Type of Visit - Inhouse') {
            this.visitTypesinhouse.push(Itemdata['value']);
            this.visitTypes.sort();
          }
        } else {
          if (Itemdata['fieldName'] == 'Type of Visit - BP') {
            this.visitTypesbp.push(Itemdata['value']);
            this.visitTypes.sort();
          }
        }
      });
  }

  onchangeSave() {
    this.locationInfoForm.controls['locationInfoFormInput'].valueChanges.subscribe((formhiddenlocval) => {
      if (formhiddenlocval == false) {
        this.data.editsaveEnabledMessage('locform', "false");
      } else {
        this.data.editsaveEnabledMessage('locform', "true");
      }
    });
  }


  //for comcast Users
  getPowerSupplyDetails(macAddress: string, triageId: number) {
    this.regionId = 0;
    this.showEditProgressBar = true;
    //this.getOperationList(macAddress);
    this.fieldConfig();
    const promiseGetPsDetail = new Promise( (resolve, reject) => {
      this.powerSupplyService.getPowerSupplyByMAC(macAddress).pipe(map(res => res))
        .subscribe(res => {
          this.ipAddress=res.ip;
          this.powerSupplyId=res.powerSupplyId;
          this.getPowerSupplyId = this.powerSupplyId;
          this.psCreationDate = res.inspectionDate;
          const certificationDate: Date = new Date(this.psCreationDate);
          const isInvalidDate: boolean =
              isUndefinedOrNullOrEmpty(this.psCreationDate) ||
              isNaN(certificationDate.getTime());

          this.vm.mandatoryImagesMissing = isInvalidDate || certificationDate > this.compareDateForCertification;
          this.ref.detectChanges();
          this.powerSupplyService
            .getPsnbSdsImageDetailByPsId(this.getPowerSupplyId)
            .pipe(take(1))
            .subscribe((result: PowerSupplyImageMetaData[]): void => {
              if (result.some((img: PowerSupplyImageMetaData): boolean => Number(img.category) === 1)) {
                this.vm.mandatoryImagesMissing = false;
                this.ref.detectChanges();
              }
            });
          this.calcRuntime = res.calculatedRuntime;
          this.getAlerts(this.powerSupplyId);

          if(this.triageId){
            this.powerSupplyService.getPowerSupplySfpTriageByPsId(this.powerSupplyId,this.triageId).subscribe(res => {
              if (res && res.id != null) {
                this.sfpMAC = res.sfpMacAddress;
                setTimeout(() => {
                  this.transponderInfoForm.controls['sfpMac'].setValue(this.sfpMAC);
                });
              }else if(res && res.id == null){
                //No change in SFP data by Bp user - but comcast user is having SFP data
                this.powerSupplyService.getPowerSupplySfpByPowerSupplyId(this.powerSupplyId).subscribe(res => {
                  if (res.id != 0 && res.id != null) {
                  this.sfpMAC = res.sfpMacAddress;
                  setTimeout(() => {
                    this.transponderInfoForm.controls['sfpMac'].setValue(this.sfpMAC);
                  });
                  } else this.id = 0;
                }, err => {
                   this.ref.detectChanges();
                  this.showProgressBar = false;
                });
              }
            });
          }else{
            this.powerSupplyService.getPowerSupplySfpByPowerSupplyId(this.powerSupplyId).subscribe(res => {
                if (res && res.id != null) {
                this.sfpMAC = res.sfpMacAddress;
                setTimeout(() => {
                  this.transponderInfoForm.controls['sfpMac'].setValue(this.sfpMAC);
                });
              }
            });
          }
          // this.powerSupplyService.getPowerSupplySfpByPowerSupplyId(this.powerSupplyId).subscribe(res => {
          //   if (res && res != null) {
          //     this.sfpMAC = res.sfpMacAddress;
          //     setTimeout(() => {
          //       this.transponderInfoForm.controls['sfpMac'].setValue(this.sfpMAC);
          //     });
          //   }
          // });
          //this.refresh();
          resolve(res);
        }, err => {
          reject(err);
        });
    });

    let promiseGetPsTriageDetla;
    let promiseGetTriageImagesDetail;
    let promiseGetPsTriage;
    let promiseGetPsTriageBySection;
    let promiseGetPsTriageCertDetla;
    if (triageId) {
      promiseGetPsTriageDetla = new Promise( (resolve, reject) => {
        this.psnbApi.getPSDeltaDetails(triageId).pipe(map(res => res))
          .subscribe(res => {
            resolve(res);
          }, err => {
            reject(err);
          });
      });

      promiseGetPsTriageCertDetla = new Promise((resolve, reject) => {
        this.psnbApi.getPSCertDeltaDetails(triageId).pipe(map(res => res))
          .subscribe(res => {
            resolve(res);
          }, err => {
            reject(err);
          });
      });

      promiseGetPsTriage = new Promise( (resolve, reject) => {
        this.psnbApi.getPSTriage(triageId).pipe(map(res => res))
          .subscribe(res => {
            resolve(res);
          }, err => {
            reject(err);
          });
      });

      promiseGetPsTriageBySection = new Promise( (resolve, reject) => {
        this.psnbApi.getPSSectionsTriageList(triageId).pipe(map(res => res))
          .subscribe(res => {
            resolve(res);
          }, err => {
            reject(err);
          });
      });

      promiseGetTriageImagesDetail =  new Promise( (resolve, reject) => {
        this.psnbApi.getPsnbSdsTriageImageDetailByTriageId(triageId)
          .pipe(map((imagesDetail: PowerSupplyTriageImage[]): PowerSupplyTriageImage[] => imagesDetail))
          .subscribe((imagesDetail: PowerSupplyTriageImage[]) => {
            resolve(imagesDetail);
          }, err => {
            reject(err);
          });
      });

    } else {
      promiseGetPsTriageDetla = new Promise( (resolve) => {
        resolve(true);
      });
      promiseGetPsTriageCertDetla = new Promise((resolve) => {
        resolve(true);
      });
      promiseGetPsTriage = new Promise( (resolve) => {
        resolve(true);
      });
      promiseGetPsTriageBySection = new Promise( (resolve) => {
        resolve(true);
      });
      promiseGetTriageImagesDetail = new Promise( (resolve) => {
        resolve(true);
      });
    }


    Promise.all([promiseGetPsDetail, promiseGetPsTriageDetla, promiseGetPsTriage, promiseGetPsTriageBySection,promiseGetTriageImagesDetail,promiseGetPsTriageCertDetla]).then( ([psData, triageDeltaData, triageActualData, triageSectionData, triageImagesDetail,CertDeltaData]) => {
      var data = <any> psData; //Current powersupply data from service
      this.psData = data;
      var certData=<any>CertDeltaData;
      if (data.type11 != null) {
        this.batteryManufactureres.push(data.type11)
      } if (data.type12 != null) {
        this.batteryManufactureres.push(data.type12)
      } if (data.type13 != null) {
        this.batteryManufactureres.push(data.type13)
      } if (data.type14 != null) {
        this.batteryManufactureres.push(data.type14)
      } if (data.type21 != null) {
        this.batteryManufactureres.push(data.type21)
      } if (data.type22 != null) {
        this.batteryManufactureres.push(data.type22)
      } if (data.type23 != null) {
        this.batteryManufactureres.push(data.type23)
      } if (data.type24 != null) {
        this.batteryManufactureres.push(data.type24)
      } if (data.type31 != null) {
        this.batteryManufactureres.push(data.type31)
      } if (data.type32 != null) {
        this.batteryManufactureres.push(data.type32)
      } if (data.type33 != null) {
        this.batteryManufactureres.push(data.type33)
      } if (data.type34 != null) {
        this.batteryManufactureres.push(data.type34)
      } if (data.type41 != null) {
        this.batteryManufactureres.push(data.type41)
      } if (data.type42 != null) {
        this.batteryManufactureres.push(data.type42)
      } if (data.type43 != null) {
        this.batteryManufactureres.push(data.type43)
      } if (data.type44 != null) {
        this.batteryManufactureres.push(data.type44)
      } if (data.type51 != null) {
        this.batteryManufactureres.push(data.type52)
      } if (data.type52 != null) {
        this.batteryManufactureres.push(data.type52)
      } if (data.type53 != null) {
        this.batteryManufactureres.push(data.type53)
      } if (data.type54 != null) {
        this.batteryManufactureres.push(data.type54)
      } if (data.type61 != null) {
        this.batteryManufactureres.push(data.type61)
      } if (data.type62 != null) {
        this.batteryManufactureres.push(data.type62)
      } if (data.type63 != null) {
        this.batteryManufactureres.push(data.type63)
      } if (data.type64 != null) {
        this.batteryManufactureres.push(data.type64)
      }
      this.batteryManufactureres = this.batteryManufactureres.filter((el, i, a) => i === a.indexOf(el))

      if (certData != null) {
        var triagedataapu = <any>certData.triageApuCert;
        var dataapu = <any>certData.currentApuCert;
        var dataapuvisit = <any>certData.currentApuShowVisitCert;
      } else {
        var triagedataapu = <any>[];
        var dataapu = <any>[];
        var dataapuvisit = <any>[];
      }
      this.linkip = data.ip;
      this.psnamelink = data.powerSupplyName;
      this.powerSupplyIdval = data.powerSupplyId;
      this.oldinspection = data.inspectionDate;
      if (triageId) {
        //Edit Triage submitted but powersupply is not there in the inventory at the time of review
        if (triageActualData.powerSupplyId && !data.powerSupplyId) {
          this.showEditProgressBar = false;
          this.openErrorDialog('Something went wrong! Power Supply is not there to edit. Please contact Admin!!');
          return;
        }


        let locationInfoField = [];
        let transponderInfoField = [];
        let batteryInfoField = [];
        let lastVistInfoField = [];
        let apuInfoField =[];
        let apuVisitInfoField =[];
        let commonInfoField = [];


        if (triageDeltaData && triageDeltaData.editedFields) {
          locationInfoField = (triageDeltaData.editedFields.LOCATIONINFO) ? triageDeltaData.editedFields.LOCATIONINFO : [];
          transponderInfoField = (triageDeltaData.editedFields.TRANSPONDERINFO) ? triageDeltaData.editedFields.TRANSPONDERINFO : [];
          batteryInfoField = (triageDeltaData.editedFields.BATTERYINFO) ? triageDeltaData.editedFields.BATTERYINFO : [];
          lastVistInfoField = (triageDeltaData.editedFields.LASTVISITINFO) ? triageDeltaData.editedFields.LASTVISITINFO : [];
          commonInfoField = (triageDeltaData.editedFields.COMMONINFO) ? triageDeltaData.editedFields.COMMONINFO : [];
          if(CertDeltaData && CertDeltaData.editedFields) {
            apuInfoField = (CertDeltaData.editedFields.APUINFO) ? CertDeltaData.editedFields.APUINFO : [];
            apuVisitInfoField = (CertDeltaData.editedFields.APUSHOWVISITINFO) ? CertDeltaData.editedFields.APUSHOWVISITINFO : [];
          }
        } else if (triageSectionData) {
          locationInfoField = (triageSectionData.locationInfoSection) ? Object.keys(triageSectionData.locationInfoSection) : [];
          transponderInfoField = (triageSectionData.transponderInfoSection) ? Object.keys(triageSectionData.transponderInfoSection) : [];
          batteryInfoField = (triageSectionData.batteryInfoSection) ? Object.keys(triageSectionData.batteryInfoSection) : [];
          lastVistInfoField = (triageSectionData.lastVisitInfoSection) ? Object.keys(triageSectionData.lastVisitInfoSection) : [];
          commonInfoField = (triageSectionData.commonInfoSection) ? Object.keys(triageSectionData.commonInfoSection) : [];
        }

        if (locationInfoField) {
          triageActualData['calculatedRuntime']=(triageDeltaData)?triageDeltaData.currentPowerSupply['calculatedRuntime']:null;
          locationInfoField.forEach(element => {
            data[element] = triageActualData[element];
          });
        }

        if (transponderInfoField) {
          transponderInfoField.forEach(element => {
            data[element] = triageActualData[element];
          });

        }

        if (batteryInfoField) {
          batteryInfoField.forEach(element => {
            data[element] = triageActualData[element];
          });

        }

        if (lastVistInfoField) {
          lastVistInfoField.forEach(element => {
            data[element] = triageActualData[element];
          });
          data['phoneNo'] = triageActualData['phoneNo'];
          this.triageInfoFlowCurrent = triageDeltaData.currentPowerSupply['inspectionDate']
          this.triageInfoFlowTriage = triageDeltaData.triagePowerSupply['inspectionDate']
          if(this.triageInfoFlowCurrent != this.triageInfoFlowTriage){
            this.triageInfoFlag = triageDeltaData.triagePowerSupply['inspectionDate'];//for triage  flow to pass inspection date for getpscertificationId API
          }else{
            this.triageInfoFlag = null;
          }
          this.triageLogNt = triageActualData.logNt.toUpperCase();
        }

        if (apuInfoField) {
            apuInfoField.forEach(element => {
              dataapu[element] = certData.triageApuCert[element];
          });
        }
        if (apuVisitInfoField) {
          apuVisitInfoField.forEach(element => {
            dataapuvisit[element] = certData.triageApuShowVisitCert[element];
          });
        }
        if (commonInfoField) {
          commonInfoField.forEach(element => {
            data[element] = triageActualData[element];
          });
        }


        this.triageLogName = triageActualData.logName;
        this.triageImagesDetail = triageImagesDetail;
      }


      if (data.nodeId != null && data.nodeId != 0) {
        this.communityServed = data.node.community.communityName;
        this.powerSupplyId = data.powerSupplyId;
        this.nodeId = data.nodeId;
        //this.getImageDetails(this.powerSupplyId);
        this.powerSupplyService.getPSNameAndRegion(data.nodeId)
          .subscribe(result => {
            this.region = result.regionName;
            this.nodeName = result.nodeName;
            this.basePowerSupplyName = result.powerSupplyName;
            this.regionId = result.regionId;
            this.hierarchyPath = result.hierarchyPath;
            if (this.hierarchyPath.includes('Central Div')) this.division = 'Central Div';
            if (this.hierarchyPath.includes('Northeast Div')) this.division = 'Northeast Div';
            if (this.hierarchyPath.includes('West Div')) this.division = 'West Div';
            //calling the nwt team api
            this.state = this.psData.state;
            if(this.nodeName != '' || this.nodeName != null){
              this.powerSupplyService.getNWTTeams(this.nodeName,this.state).subscribe(resultdata => {
                this.nwtTeamData = resultdata['nwtTeam'];
                this.locationInfoForm.controls['nwtTeam'].patchValue(this.nwtTeamData);
              });
            }
            this.getForms();
            this.markAsTouched(this.apuVisitFormGroup);
            this.markAsTouched(this.apuFormGroup);
            this.markAsTouched(this.locationInfoForm);
            this.markAsTouched(this.transponderInfoForm);
            this.markAsTouched(this.batteryInfoForm);
            this.markAsTouched(this.lastVisitInfoForm);
            this.markAsTouched(this.batteryBatteryForm);
            this.markAsTouched(this.batteryStringForm);
            this.ref.detectChanges();
            this.ref.detectChanges();
            //this.transponderModelService.getAllModelsFromService().subscribe(result => {
            this.transponderVendorsModelsService.getTransponderModelName().subscribe(result => {
              result.forEach(res => {
                //if (res.regionId === this.regionId) this.transponderModels.push(res.modelName);
                this.transponderModels.push(res);
              });
            });
            this.powerSupplyVendorService.getPowerSupplyVendors().subscribe(result => {
              result.forEach(res => { if (res.regionId === this.regionId) this.powerCompanies.push(res.vendorName); });
              if (data.utilityProvider === null || data.utilityProvider === '' || data.utilityProvider === undefined)
                this.transponderInfoForm.controls['powerCompany'].setErrors({ required: true });
              else {
                this.locationInfoForm.patchValue({
                  powerCompany: data.utilityProvider
                });
              }
            });
            this.powerSupplyService.getStates().subscribe(result => {
              result.forEach(res => { if (res.regionId === this.regionId) this.states.push(res.name); });
              if (data.state === null || data.state === '' || data.state === undefined)
                this.transponderInfoForm.controls['state'].setErrors({ required: true });
              else {
                this.locationInfoForm.patchValue({
                  state: data.state
                });
              }
              this.onChangeSysContact();
            });
            //this.transponderVendorService.getAllVendorsFromService().subscribe(result => {
              this.transponderVendorsModelsService.getTransponderVendorName().subscribe(result => {
              result.forEach(res => {
                //if (res.regionId === this.regionId)
                //this.transponderVendors.push(res.vendorName);
                this.transponderVendors.push(res);
              });
            });
            this.powerSupplyModelsService.getPowerSupplyModels().subscribe(result => {
              result.forEach(res => { this.powerSupplyModels.push(res.modelName); });
              if ((data.powerSupplyModel === null || data.powerSupplyModel === '' || data.powerSupplyModel === undefined) && data.transponderVendor.toUpperCase() !== 'AM COMMUNICATIONS')
                this.transponderInfoForm.controls['powerSupplyModel'].setErrors({ validatePowerSupplyModel: true });
              else {
                this.transponderInfoForm.patchValue({
                  powerSupplyModel: data.powerSupplyModel.trim()
                });
              }
              this.showEditProgressBar = false;

            });
            // this.nextGenNodeService.getAllNextGenNodes().subscribe(result => {
            //   result.forEach(res => this.nextGenOptions.push(res.nextGenNode));
            // });
            this.basePowerSupplyNumber = data.powerSupplyNumber;
            this.editPowerSupply = data;
            if (data.feedsMultipleNodes.toUpperCase() === 'YES') {
              this.locationInfoForm.patchValue({
                mutliNodes: "Yes - 2 Nodes"
              })
            } else {
              this.locationInfoForm.patchValue({
                mutliNodes: data.feedsMultipleNodes
              })
            }
            let editPSType9360 = this.powerSupplyTypes.find(x => x.id === data.powerSupplyType9360);
            this.activeMacAddress = data.macAddress;
            this.mac_address = data.macAddress;
            this.linkMacAddress = data.macAddress;
            this.powerCompanywebsiteUrl = data.powerCompanyWebsite;
            if(data.gpsLatitude == "" || data.gpsLatitude == null) {
              this.latitudeField = '';
            } else {
               // Change Request -- remove zeros code commented
              // let gpslat = this.commonService.decimalCount(data.gpsLatitude);
              // if (gpslat > 6) {
              //   this.latitudeField = data.gpsLatitude;
              // } else {
              //   this.latitudeField = data.gpsLatitude.toFixed(6);
              // }
              this.latitudeField = data.gpsLatitude;
            }

            if (data.gpsLongitude == "" || data.gpsLongitude == null) {
              this.longitudeField = '';
            } else {
              // Change Request -- remove zeros code commented
              // let gpslong = this.commonService.decimalCount(data.gpsLongitude);
              // if (gpslong > 6) {
              //   this.longitudeField = data.gpsLongitude;
              // } else {
              //   this.longitudeField = data.gpsLongitude.toFixed(6);
              // }
              this.longitudeField = data.gpsLongitude;
            }
            // if(data.powerAccountType == null){
            //   this.locationInfoForm.controls["meter"].clearValidators();
            //   this.locationInfoForm.controls["meter"].updateValueAndValidity();
            // }else if(data.powerAccountType !== 'MDU Power Supply'){
            //   if(data.electricMeterNumber == '' || data.electricMeterNumber == null){
            //     this.locationInfoForm.controls["meter"].setValidators(Validators.required);
            //     this.locationInfoForm.controls["meter"].updateValueAndValidity();
            //   }
            // }
            setTimeout(() => {
              this.locationInfoForm.patchValue({
                houseNumberInput: data.houseNumber,
                street: data.powerSupplyAddress,
                crossStreet: data.crossStreet,
                city: data.city,
                zip: data.zip,
                prevNodeServed: data.prevNodeServed,
                primaryNode: data.nodeName,
                latitude: this.latitudeField,
                longitude: this.longitudeField,
                calculatedRuntime: data.calculatedRuntime,
                powerNode: data.powersNode,
                spLocDetails: data.specialLocationDetails,
                areial: data.aerialUnderground,
                powerAccountType: data.powerAccountType,
                pole: data.poleNumber,
                companyAccNum: data.companyAccountNumber,
                companyContact: data.powerCompanyContactNumber,
                companyWebsite: data.powerCompanyWebsite,
                nitroCompletionDate: data.nitroCompletionDate,
                nwtTeam: this.nwtTeamData,
                nitroReasonNotCompleted: data.nitroReasonNotCompleted,
                meter: data.electricMeterNumber,
                mapPageNumber: data.mapNumber,
                pscreateddate : (data.createdDate)?new Date(data.createdDate).toLocaleString():null,
                locationComments: data.locationComments,
                businessPartnerRestriction: data.businessPartnerRestriction,
              });
            });

            setTimeout(() => {
              this.transponderInfoForm.patchValue({
                prevMacAddress: data.macAddressPrevious,
              });
            });
            this.transponderInfoForm.patchValue({
              standByOpts: data.powerSupplyType,
              activeMacAddress: data.macAddress,
              prevMacAddress: data.macAddressPrevious,
              ip: data.ip,
              powerSupplyNum: data.powerSupplyNumber,
              nextGenNode: data.nextGenNode,
              powerSupplyModel: (data.powerSupplyModel) ? data.powerSupplyModel.trim() : null,
              powerSupplyType9360: editPSType9360,
              acInputVoltage: data.acInputVoltage,
              acOutputVoltage: data.outputVoltage,
              currentAmp: data.inputCurrent,
              //currentAmpOutput: data.currentAmpOutput,
              powerSupplyAlertProfile: data.alertProfile,
              serialNum: data.serialNumber,
              //controlledCardType: data.controllerCardType,
              dcReady: data.dcReady,
              priority: data.priority,
              egisName: data.egisName,
              externalSensor: data.externalSensor,
              globalidentifier: data.globalId,
              transponderComments: data.transponderComments
            });
            if (triageId) {
              this.apu_id_cert =triagedataapu.apuId;
              this.apuFormGroup.patchValue({
                apuMakeModel : dataapu.apuMakeModel,
                apuSerialNumber : dataapu.apuSerialNumber,
                apuDeviceId:dataapu.apuDeviceId,
                apuRunTime:dataapu.apuRunTime,
                ecmAcm:dataapu.ecmAcm,
                dateApuInstalled:new Date(dataapu.dateApuInstalled),
                apuOpVltgRating:dataapu.apuOutputVoltageRating,
                apuNoLoadVltg:dataapu.apuNoLoadVoltage,
                apuLoadVltg:dataapu.apuLoadVoltage,
                apuEnclosure:dataapu.apuEnclosureMake,
                ngLp:dataapu.ngLp,
                ngProvider:dataapu.ngProvider,
                lpTankCapacity:dataapu.lpTankCapacity,
                noOfTanksInstalled:dataapu.numberTanksInstalled,
               })
              this.apuvisit_id_cert=dataapuvisit.id;
              this.apuVisitFormGroup.patchValue({
                apuinspectionDate: new Date(dataapuvisit.inspectionDate),
                apuVisitedTech: dataapuvisit.apuCompletedBy,
                apuBatteryManuType: dataapuvisit.apuBatteryManufacturerType,
                apuBatteryDateCode: dataapuvisit.apuBatteryDateCode,
                apuBatteryInstallDate: new Date(dataapuvisit.apuBatteryInstallDate),
                apuBatteryVltgNoLoad: dataapuvisit.apuBatteryVoltageNoLoad,
                apuBatteryConductance: dataapuvisit.apuBatteryConductance,
                apuBatteryCon77deg: dataapuvisit.apuBatteryConductanceCrrctd,
                apuBatteryTorque: dataapuvisit.apuBatteryTorque,
                apuBatteryTerminals: dataapuvisit.apuBatteryTerminalsCleaned,
                apuStarter: dataapuvisit.apuStarterBatteryChrgrVlt,
                apuCharger: dataapuvisit.apuChargerCurrentAmps,
                followup: dataapuvisit.followUpActionNeeded,
                recordAsFoundAlarms: dataapuvisit.recordAsFoundAlarms,
                apuTestRun: dataapuvisit.apuTestRun,
                checkOilLevel: dataapuvisit.checkOilLevel,
                ifOilAdded: dataapuvisit.oilAddedAmount,
                oilFilterTight: dataapuvisit.oilFilterTight,
                inspectGenerator: dataapuvisit.inspectGeneratorAirFilter,
                inspectSparkPlug: dataapuvisit.inspectSparkPlug,
                clearApuEventlog: dataapuvisit.clearApuEventLog,
                apuFrequency: dataapuvisit.apuFrequency,
                tank1: dataapuvisit.tankOneLevel,
                tank2: dataapuvisit.tankTwoLevel,
                gasMeter: dataapuvisit.gasMeterNumber,
                gasMeterReading: dataapuvisit.gasMeterReading,
                ngPressure: dataapuvisit.ngPressure,
                airFilter: dataapuvisit.changeCleanenClosureAirFilter,
                rodentInsectDamage: dataapuvisit.checkForRodentDamage,
                checkLamps: dataapuvisit.checkLampsLed,
                clearWeeds: dataapuvisit.clearWeeds,
                checkRegrout: dataapuvisit.checkRegroutPadConduit,
                ifGroundMount: dataapuvisit.groundMountPadUndermining,
                anyEnclosure: dataapuvisit.enclosureDamageVandalism,
                cleanUpGarbage: dataapuvisit.cleanupGarbage,
                testOilPressure: dataapuvisit.testOilPressureAlarm,
                testhighTemp: dataapuvisit.testHighTempAlarm,
                generatorDcBus: dataapuvisit.generatorDcBusFunction,
                checkForGas: dataapuvisit.checkForGasLeaks,
                testCombustible: dataapuvisit.testCombustibleGasAlarm,
                testTamper: dataapuvisit.testTamperAlarm,
                testWaterIntrusion: dataapuvisit.testWaterIntrusionAlarm,
                testPad: dataapuvisit.testPadShearAlarm,
                comments: dataapuvisit.apuVisitComments,
              })
            }
            this.onPullTransponder();
            this.originalMac = data.macAddress;
            this.onMacChange(data.macAddress);
            if (data.inspectionDate !== null) {
              this.date = new Date(data.inspectionDate);
              this.insDate = new Date(this.date);
            }
            if (this.visitdata !== null) {
              if(this.visitdata != "default message"){
                this.typeOfVisit_data = this.visitdata;
              }else{
                this.typeOfVisit_data = data.typeOfVisit;
              }
            } else {
              this.typeOfVisit_data = data.typeOfVisit;
            }
            if(data.typeOfVisit && data.typeOfVisit.indexOf('Cert Required') !== -1){
              if(data.followUpReason == null || data.followUpReason == ''){
                this.followUpActionData = 'N/A';
              }else{
                this.followUpActionData = data.followUpReason;
              }
            }else{
               this.followUpActionData = data.followUpReason;
            }
            setTimeout(() => {
              this.lastVisitInfoForm.patchValue({
                inspectionDate: this.insDate,
                typeOfVisit: this.typeOfVisit_data,
                xocVerified: data.xocVerified,
                visitStatus: data.visitStatus,
                followUpReasons: this.followUpActionData,
                mobileno: data.phoneNo,
                cleanDust: data.cleanEnclosure,
                tightenAll: data.tightenHardware,
                inspectWire: data.inspectConnectors,
                inspectBattery: data.inspectProbes,
                meterPan: data.meterPanCondition,
                powerCo: data.powerCoRiserCondition,
                batteryHeaterType: data.batteryHeaterMatType,
                batteryHeaterQuantity: data.batteryHeaterMatQuantity,
                encloseSnow: data.enclosureSnowShield,
                internalBreaker: data.internalBreaker,
                serviceEntrance: data.serviceEntrance,
                receptacleType: data.receptacleType,
                checkSeizure: data.checkSeizureAltBox,
                psIDLegibile: data.powerSupplyIdLegible,
                checkLamps: data.checkLampsLeds,
                checkCircuitBreaker: data.checkMagneticBreaker,
                visualInspection: data.visualCabinetInspection,
                cabinetLocked: data.cabinetLocked,
                securityBar: data.securityBarPresent,
                checkGround: data.checkGroundCabinet,
                batteryStringFused1: data.batteryString1Fused,
                batteryStringFused2: data.batteryString2Fused,
                batteryStringFused3: data.batteryString3Fused,
                batteryStringFused4: data.batteryString4Fused,
                batteryStringFused5: data.batteryString5Fused,
                batteryStringFused6: data.batteryString6Fused,
                tamperInstalled: data.tamperInstalledFunctioning,
                checkLaps: data.checkLaps,
                cabinetVendor: data.cabinetVendor,
                cabinetBattery: data.cabinetBatteryCapacity,
                checkOperating: data.checkOperatingLights,
                followUp: data.followUpNeeded,
                inputSurge: data.inputSurgeArrestor,
                outputSurge: data.outputSurgeArrestor,
                coaxTvss: data.coaxTvssPresent,
                acIndicator: data.acIndicatorGreenLight,
                lri: data.localRemoteIndicator,
                lastVisitComments: data.comments
              });
            });
            setTimeout(() => {
              this.lastVisitInfoForm.patchValue({
                batteryStringFused1: data.batteryString1Fused,
                batteryStringFused2: data.batteryString2Fused,
                batteryStringFused3: data.batteryString3Fused,
                batteryStringFused4: data.batteryString4Fused,
                batteryStringFused5: data.batteryString5Fused,
                batteryStringFused6: data.batteryString6Fused
              });

            });
            this.batteryInfoForm.patchValue({
              numberofBatteries: data.numberOfBatteries,
              batteriesReplaced: data.batteriesReplaced,
              batteryManagerModel: data.batteryBalancerString,
              //airTemperature: data.airTemperature,
              batteryComments: data.batteryComments
            });

            this.onChangeNumberOfBatteries();
            this.onChangePowerSupplyNum();
            setTimeout(() => {
              this.onChangevisitType();
            });

            this.editNodes.push(data.node2);
            this.editNodes.push(data.node3);
            this.editNodes.push(data.node4);
            this.editNodes.push(data.node5);
            this.editNodes.push(data.node6);
            this.editNodes.push(data.node7);
            this.editNodes.push(data.node8);
            this.editNodes.push(data.node9);
            this.editNodes.push(data.node10);
            this.editNodes.push(data.node11);
            this.editNodes.push(data.node12);
            this.editNodes.push(data.node13);
            this.editNodes.push(data.node14);
            this.editNodes.push(data.node15);
              this.editNodes.push(data.node16);
              this.editNodes.push(data.node17);
              this.editNodes.push(data.node18);
              this.editNodes.push(data.node19);
              this.editNodes.push(data.node20);
              this.editNodes.push(data.node21);
              this.editNodes.push(data.node22);
              this.editNodes.push(data.node23);
              this.editNodes.push(data.node24);
              this.editNodes.push(data.node25);
              this.editNodes.push(data.node26);
              this.editNodes.push(data.node27);
              this.editNodes.push(data.node28);
              this.editNodes.push(data.node29);
              this.editNodes.push(data.node30);
              this.editNodes.push(data.node31);
              this.editNodes.push(data.node32);
            this.node2_id = data.node2_id;
            this.node3_id = data.node3_id;
            this.node4_id = data.node4_id;
            this.node5_id = data.node5_id;
            this.node6_id = data.node6_id;
            this.node7_id = data.node7_id;
            this.node8_id = data.node8_id;
            this.node9_id = data.node9_id;
            this.node10_id = data.node10_id;
            this.node11_id = data.node11_id;
            this.node12_id = data.node12_id;
            this.node13_id = data.node13_id;
            this.node14_id = data.node14_id;
            this.node15_id = data.node15_id;
              this.node16_id = data.node16_id;
              this.node17_id = data.node17_id;
              this.node18_id = data.node18_id;
              this.node19_id = data.node19_id;
              this.node20_id = data.node20_id;
              this.node21_id = data.node21_id;
              this.node22_id = data.node22_id;
              this.node23_id = data.node23_id;
              this.node24_id = data.node24_id;
              this.node25_id = data.node25_id;
              this.node26_id = data.node26_id;
              this.node27_id = data.node27_id;
              this.node28_id = data.node28_id;
              this.node29_id = data.node29_id;
              this.node30_id = data.node30_id;
              this.node31_id = data.node31_id;
              this.node32_id = data.node32_id;
              this.editBatteryBalancers.push(data.batteryBalancerString);
            // this.editBatteryBalancers.push(data.batteryBalancerString1);
            // this.editBatteryBalancers.push(data.batteryBalancerString1);
            // this.editBatteryBalancers.push(data.batteryBalancerString1);
            // this.editBatteryBalancers.push(data.batteryBalancerString1);
            // this.editBatteryBalancers.push(data.batteryBalancerString1);
            // this.editBatteryBalancers.push(data.batteryBalancerString1);
            //this.editBatterySep.push(data.batterySeparatorPresent14);
            //this.editBatterySep.push(data.batterySeparatorPresent14);
            //this.editBatterySep.push(data.batterySeparatorPresent14);
            //this.editBatterySep.push(data.batterySeparatorPresent14);
            //this.editBatterySep.push(data.batterySeparatorPresent14);
            //this.editBatterySep.push(data.batterySeparatorPresent14);

            this.editManu.push(data.type11);
            this.editManu.push(data.type12);
            this.editManu.push(data.type13);
            this.editManu.push(data.type14);
            //Added for Parallel Batts
            if (this.parallelBatt) {
            this.editManu.push(data.type15);
            this.editManu.push(data.type16);
            }
            this.editManu.push(data.type21);
            this.editManu.push(data.type22);
            this.editManu.push(data.type23);
            this.editManu.push(data.type24);
            this.editManu.push(data.type31);
            this.editManu.push(data.type32);
            this.editManu.push(data.type33);
            this.editManu.push(data.type34);
            this.editManu.push(data.type41);
            this.editManu.push(data.type42);
            this.editManu.push(data.type43);
            this.editManu.push(data.type44);
            this.editManu.push(data.type51);
            this.editManu.push(data.type52);
            this.editManu.push(data.type53);
            this.editManu.push(data.type54);
            this.editManu.push(data.type61);
            this.editManu.push(data.type62);
            this.editManu.push(data.type63);
            this.editManu.push(data.type64);

            this.editNoload.push(data.voltage11);
            this.editNoload.push(data.voltage12);
            this.editNoload.push(data.voltage13);
            this.editNoload.push(data.voltage14);
            //Added for parallel Batts
            if (this.parallelBatt) {
            this.editNoload.push(data.voltage15);
            this.editNoload.push(data.voltage16);
            }
            this.editNoload.push(data.voltage21);
            this.editNoload.push(data.voltage22);
            this.editNoload.push(data.voltage23);
            this.editNoload.push(data.voltage24);
            this.editNoload.push(data.voltage31);
            this.editNoload.push(data.voltage32);
            this.editNoload.push(data.voltage33);
            this.editNoload.push(data.voltage34);
            this.editNoload.push(data.voltage41);
            this.editNoload.push(data.voltage42);
            this.editNoload.push(data.voltage43);
            this.editNoload.push(data.voltage44);
            this.editNoload.push(data.voltage51);
            this.editNoload.push(data.voltage52);
            this.editNoload.push(data.voltage53);
            this.editNoload.push(data.voltage54);
            this.editNoload.push(data.voltage61);
            this.editNoload.push(data.voltage62);
            this.editNoload.push(data.voltage63);
            this.editNoload.push(data.voltage64);

            this.editUnder.push(data.batteryVoltageUnderload11);
            this.editUnder.push(data.batteryVoltageUnderload12);
            this.editUnder.push(data.batteryVoltageUnderload13);
            this.editUnder.push(data.batteryVoltageUnderload14);
            //Added for parallel Batts
            if (this.parallelBatt) {
            this.editUnder.push(data.batteryVoltageUnderload15);
            this.editUnder.push(data.batteryVoltageUnderload16);
            }
            this.editUnder.push(data.batteryVoltageUnderload21);
            this.editUnder.push(data.batteryVoltageUnderload22);
            this.editUnder.push(data.batteryVoltageUnderload23);
            this.editUnder.push(data.batteryVoltageUnderload24);
            this.editUnder.push(data.batteryVoltageUnderload31);
            this.editUnder.push(data.batteryVoltageUnderload32);
            this.editUnder.push(data.batteryVoltageUnderload33);
            this.editUnder.push(data.batteryVoltageUnderload34);
            this.editUnder.push(data.batteryVoltageUnderload41);
            this.editUnder.push(data.batteryVoltageUnderload42);
            this.editUnder.push(data.batteryVoltageUnderload43);
            this.editUnder.push(data.batteryVoltageUnderload44);
            this.editUnder.push(data.batteryVoltageUnderload51);
            this.editUnder.push(data.batteryVoltageUnderload52);
            this.editUnder.push(data.batteryVoltageUnderload53);
            this.editUnder.push(data.batteryVoltageUnderload54);
            this.editUnder.push(data.batteryVoltageUnderload61);
            this.editUnder.push(data.batteryVoltageUnderload62);
            this.editUnder.push(data.batteryVoltageUnderload63);
            this.editUnder.push(data.batteryVoltageUnderload64);

            this.editCond.push(data.batteryConductance11);
            this.editCond.push(data.batteryConductance12);
            this.editCond.push(data.batteryConductance13);
            this.editCond.push(data.batteryConductance14);
            //Added for parallel Batts
            if (this.parallelBatt) {
            this.editCond.push(data.batteryConductance15);
            this.editCond.push(data.batteryConductance16);
            }
            this.editCond.push(data.batteryConductance21);
            this.editCond.push(data.batteryConductance22);
            this.editCond.push(data.batteryConductance23);
            this.editCond.push(data.batteryConductance24);
            this.editCond.push(data.batteryConductance31);
            this.editCond.push(data.batteryConductance32);
            this.editCond.push(data.batteryConductance33);
            this.editCond.push(data.batteryConductance34);
            this.editCond.push(data.batteryConductance41);
            this.editCond.push(data.batteryConductance42);
            this.editCond.push(data.batteryConductance43);
            this.editCond.push(data.batteryConductance44);
            this.editCond.push(data.batteryConductance51);
            this.editCond.push(data.batteryConductance52);
            this.editCond.push(data.batteryConductance53);
            this.editCond.push(data.batteryConductance54);
            this.editCond.push(data.batteryConductance61);
            this.editCond.push(data.batteryConductance62);
            this.editCond.push(data.batteryConductance63);
            this.editCond.push(data.batteryConductance64);

            this.editCondCorr.push(data.batteryConductanceCorrected11);
            this.editCondCorr.push(data.batteryConductanceCorrected12);
            this.editCondCorr.push(data.batteryConductanceCorrected13);
            this.editCondCorr.push(data.batteryConductanceCorrected14);
           //Added for parallel Batts
            if (this.parallelBatt) {
              this.editCondCorr.push(data.batteryConductanceCorrected15);
              this.editCondCorr.push(data.batteryConductanceCorrected16);
            }
            this.editCondCorr.push(data.batteryConductanceCorrected21);
            this.editCondCorr.push(data.batteryConductanceCorrected22);
            this.editCondCorr.push(data.batteryConductanceCorrected23);
            this.editCondCorr.push(data.batteryConductanceCorrected24);
            this.editCondCorr.push(data.batteryConductanceCorrected31);
            this.editCondCorr.push(data.batteryConductanceCorrected32);
            this.editCondCorr.push(data.batteryConductanceCorrected33);
            this.editCondCorr.push(data.batteryConductanceCorrected34);
            this.editCondCorr.push(data.batteryConductanceCorrected41);
            this.editCondCorr.push(data.batteryConductanceCorrected42);
            this.editCondCorr.push(data.batteryConductanceCorrected43);
            this.editCondCorr.push(data.batteryConductanceCorrected44);
            this.editCondCorr.push(data.batteryConductanceCorrected51);
            this.editCondCorr.push(data.batteryConductanceCorrected52);
            this.editCondCorr.push(data.batteryConductanceCorrected53);
            this.editCondCorr.push(data.batteryConductanceCorrected54);
            this.editCondCorr.push(data.batteryConductanceCorrected61);
            this.editCondCorr.push(data.batteryConductanceCorrected62);
            this.editCondCorr.push(data.batteryConductanceCorrected63);
            this.editCondCorr.push(data.batteryConductanceCorrected64);

            this.editCode.push(data.manufactureDate11);
            this.editCode.push(data.manufactureDate12);
            this.editCode.push(data.manufactureDate13);
            this.editCode.push(data.manufactureDate14);

            //Added for parallel Batts
            if (this.parallelBatt) {
            this.editCode.push(data.manufactureDate15);
            this.editCode.push(data.manufactureDate16);
            }
            this.editCode.push(data.manufactureDate21);
            this.editCode.push(data.manufactureDate22);
            this.editCode.push(data.manufactureDate23);
            this.editCode.push(data.manufactureDate24);
            this.editCode.push(data.manufactureDate31);
            this.editCode.push(data.manufactureDate32);
            this.editCode.push(data.manufactureDate33);
            this.editCode.push(data.manufactureDate34);
            this.editCode.push(data.manufactureDate41);
            this.editCode.push(data.manufactureDate42);
            this.editCode.push(data.manufactureDate43);
            this.editCode.push(data.manufactureDate44);
            this.editCode.push(data.manufactureDate51);
            this.editCode.push(data.manufactureDate52);
            this.editCode.push(data.manufactureDate53);
            this.editCode.push(data.manufactureDate54);
            this.editCode.push(data.manufactureDate61);
            this.editCode.push(data.manufactureDate62);
            this.editCode.push(data.manufactureDate63);
            this.editCode.push(data.manufactureDate64);

            //battery serial
            this.editSerial.push(data.batterySerial11);
            this.editSerial.push(data.batterySerial12);
            this.editSerial.push(data.batterySerial13);
            this.editSerial.push(data.batterySerial14);
            //Added for parallel Batts
            if (this.parallelBatt) {
              this.editSerial.push(data.batterySerial15);
              this.editSerial.push(data.batterySerial16);
            }

            this.editSerial.push(data.batterySerial21);
            this.editSerial.push(data.batterySerial22);
            this.editSerial.push(data.batterySerial23);
            this.editSerial.push(data.batterySerial24);
            this.editSerial.push(data.batterySerial31);
            this.editSerial.push(data.batterySerial32);
            this.editSerial.push(data.batterySerial33);
            this.editSerial.push(data.batterySerial34);
            this.editSerial.push(data.batterySerial41);
            this.editSerial.push(data.batterySerial42);
            this.editSerial.push(data.batterySerial43);
            this.editSerial.push(data.batterySerial44);
            this.editSerial.push(data.batterySerial51);
            this.editSerial.push(data.batterySerial52);
            this.editSerial.push(data.batterySerial53);
            this.editSerial.push(data.batterySerial54);
            this.editSerial.push(data.batterySerial61);
            this.editSerial.push(data.batterySerial62);
            this.editSerial.push(data.batterySerial63);
            this.editSerial.push(data.batterySerial64);

            this.editInst.push(data.installDate11);
            this.editInst.push(data.installDate12);
            this.editInst.push(data.installDate13);
            this.editInst.push(data.installDate14);
            //Added for parallel Batts
            if (this.parallelBatt) {
            this.editInst.push(data.installDate15);
            this.editInst.push(data.installDate16);
            }
            this.editInst.push(data.installDate21);
            this.editInst.push(data.installDate22);
            this.editInst.push(data.installDate23);
            this.editInst.push(data.installDate24);
            this.editInst.push(data.installDate31);
            this.editInst.push(data.installDate32);
            this.editInst.push(data.installDate33);
            this.editInst.push(data.installDate34);
            this.editInst.push(data.installDate41);
            this.editInst.push(data.installDate42);
            this.editInst.push(data.installDate43);
            this.editInst.push(data.installDate44);
            this.editInst.push(data.installDate51);
            this.editInst.push(data.installDate52);
            this.editInst.push(data.installDate53);
            this.editInst.push(data.installDate54);
            this.editInst.push(data.installDate61);
            this.editInst.push(data.installDate62);
            this.editInst.push(data.installDate63);
            this.editInst.push(data.installDate64);

            this.editVltgString.push(data.totalVoltageString11);
            this.editVltgString.push(data.totalVoltageString12);
            this.editVltgString.push("");
            this.editVltgString.push("");
            this.editVltgString.push(data.totalVoltageString21);
            this.editVltgString.push(data.totalVoltageString22);
            this.editVltgString.push("");
            this.editVltgString.push("");
            this.editVltgString.push(data.totalVoltageString31);
            this.editVltgString.push(data.totalVoltageString32);
            this.editVltgString.push("");
            this.editVltgString.push("");
            this.editVltgString.push(data.totalVoltageString41);
            this.editVltgString.push(data.totalVoltageString42);
            this.editVltgString.push("");
            this.editVltgString.push("");
            this.editVltgString.push(data.totalvoltagestring51);
            this.editVltgString.push(data.totalvoltagestring52);
            this.editVltgString.push(data.totalvoltagestring53);
            this.editVltgString.push(data.totalvoltagestring54);
            this.editVltgString.push(data.totalvoltagestring61);
            this.editVltgString.push(data.totalvoltagestring62);
            this.editVltgString.push(data.totalvoltagestring63);
            this.editVltgString.push(data.totalvoltagestring64);

            if (this.nodesForms.length > 0) {
              for (let i = 0; i < this.nodesForms.length; i++) {
                let fb = this.nodesForms.at(i).get('node') as FormControl;
                let value = this.editNodes[i];
                fb.patchValue(value);
                this.updateForm(value, i);
              }
            }

            if (this.batteryStringForms.length > 0) {
              for (let i = 0; i < this.batteryStringForms.length; i++) {
                //let fbModel = this.batteryStringForms.at(i).get('batteryManagerModel') as FormControl;
                //let fbSep = this.batteryStringForms.at(i).get('batterySeparator') as FormControl;
                //fbModel.patchValue(this.editBatteryBalancers[i]);
                //fbModel.markAsTouched();
                //fbSep.patchValue(this.editBatterySep[i]);
                //fbSep.markAsTouched();
              }
            }
            if (this.batteryBatteryForms.length > 0) {
              let preArray: any = [];
              let battArray: any = [];
              for (let i = 0; i < this.prvString; i++) {
                for (let j = 0; j < this.prvBattery; j++) {
                  preArray.push(i + '' + j)
                }
              }
              if (this.parallelBatt) {
                let battStringCount = 1;
                let parallelBattsInString = 6;
                for (let i = 0; i < battStringCount; i++) {
                  for (let j = 0; j < parallelBattsInString; j++) {
                    if (preArray.includes(i + '' + j)) {
                      battArray.push(55);
                    } else {
                      battArray.push(66);
                    }
                  }
                }
              } else {
                for (let i = 0; i < 6; i++) {
                  for (let j = 0; j < 4; j++) {
                    if (preArray.includes(i + '' + j)) {
                      battArray.push(55);
                    } else {
                      battArray.push(66);
                    }
                  }
                }
              }
              let temp = 0;
              for (let i = 0; i < this.batteryBatteryForms.length; i++) {
                let fbManu = this.batteryBatteryForms.at(i).get('batteryManufacturer') as FormControl;
                let fbSerial = this.batteryBatteryForms.at(i).get('batterySerial') as FormControl;
                let fbCode = this.batteryBatteryForms.at(i).get('batteryCode') as FormControl;
                let fbinst = this.batteryBatteryForms.at(i).get('batteryInstallDate') as FormControl;
                let fbVltgNo = this.batteryBatteryForms.at(i).get('batteryVoltageNoLoad') as FormControl;
                let fbVltgunder = this.batteryBatteryForms.at(i).get('batteryVoltageUnderLoad') as FormControl;
                let fbCond = this.batteryBatteryForms.at(i).get('batteryConductance') as FormControl;
                let fbCondCorre = this.batteryBatteryForms.at(i).get('batteryConductanceCorrected') as FormControl;
                let fbtotal = this.batteryBatteryForms.at(i).get('totalVoltage') as FormControl;
                if (battArray[temp] == 55) {
                  fbManu.patchValue(this.editManu[temp]);
                  fbVltgNo.patchValue(this.editNoload[temp]);
                  fbVltgunder.patchValue(this.editUnder[temp]);
                  fbCond.patchValue(this.editCond[temp]);
                  fbCondCorre.patchValue(this.editCondCorr[temp]);
                  fbtotal.patchValue(this.editVltgString[temp]);
                  fbSerial.patchValue(this.editSerial[temp]);
                  fbCode.patchValue(this.editCode[temp]);
                  if (this.editInst[temp] !== null)
                    fbinst.patchValue(new Date(this.editInst[temp]));
                } else i--;
                temp++;
              }
            }
            this.onChangeSysLocation();
            this.onChangeSysContact();
            this.onChangePowerSupplyType();
            this.onChangeNextgenType();
            setTimeout(() => {
              this.onChangefollowup();
            });
            this.markAsTouched(this.transponderInfoForm);
            this.markAsTouched(this.batteryInfoForm);
            this.markAsTouched(this.lastVisitInfoForm);
            this.markAsTouched(this.batteryBatteryForm);
            this.markAsTouched(this.batteryStringForm);
            this.ref.detectChanges();
            this.showEditProgressBar = false;
          }, err => {
            this.showEditProgressBar = false;
          });

          //condition for did you check the following
          if(data.checkSeizureAltBox === 'Ok' && data.powerCoRiserCondition === 'Good' && data.checkMagneticBreaker === 'Ok' &&
          data.checkLaps === 'Ok' && data.visualCabinetInspection === 'Ok' && data.inspectConnectors === 'Yes' &&
          data.checkLampsLeds === 'Ok' && data.inspectProbes === 'Yes' && data.xocVerified === 'Yes'
          && data.checkOperatingLights === 'Ok'  && data.acIndicatorGreenLight === 'Ok'
          && data.serviceEntrance === null && data.powerSupplyIdLegible === 'Yes'  && data.localRemoteIndicator === 'Yes'){
            this.isCheckedCheck = true;
            this.SaveFlag = true;
            // setTimeout(() => {
            //   this.lastVisitInfoForm.controls["checkAll"].clearValidators();
            //   this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
            // });
            // this.ref.detectChanges()
          }else{
            // setTimeout(() => {
            //   this.lastVisitInfoForm.controls["checkAll"].setValidators(Validators.required);
            //   this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
            //   });
            //  this.ref.detectChanges()
            this.isCheckedCheck = false;
            this.SaveFlag = false;
            let event = data.typeOfVisit;
            if(event && event.indexOf('Cert Required') !== -1){
            //cert required
            //this.disableSaveButton = true;
            this.SaveFlag = true;
            }
            else{
            //cert not required or empty case
            //this.disableSaveButton = true;
            this.SaveFlag = false;
            }
            setTimeout(() => {
              this.lastVisitInfoForm.controls["checkAll"].setValidators(Validators.required);
              this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
            });
            this.ref.detectChanges()

          }
      } else {
        this.showEditProgressBar = false;
        this.openErrorDialog('Node is Not associated with Watchtower. Please contact Admin !!');
      }
    }, err => {
      this.showEditProgressBar = false;
    });
  }

  getPSCertificationID(powerSupplyId,inspectionDate){
    this.powerSupplyService.getPSCertificationID(powerSupplyId,inspectionDate).subscribe(certid => {
     this.certId = certid;

     //workitem starts here
     let event = this.lastVisitInfoForm.value.typeOfVisit;
     let eventBP = (event !== undefined) ? event.startsWith("BP") : false;
     if(eventBP && !this.permissionValue && (this.triageId == null || this.triageId == undefined)) {
       this.powerSupplyService.getTriageWorkItemsBYPsCertID(this.certId,this.powerSupplyId, this.triageId).subscribe(res => {
        if(res && res.length > 0){
           this.lastVisitInfoForm.controls["workitem"].clearValidators();
           this.lastVisitInfoForm.controls["workitem"].updateValueAndValidity();
        }else{
           this.lastVisitInfoForm.controls["workitem"].setValidators(Validators.required);
          this.lastVisitInfoForm.controls["workitem"].updateValueAndValidity();
        }
        this.ref.detectChanges();
        this.ref.markForCheck();
       });
     }

     this.ref.markForCheck();
     if(this.certId != null){
      this.powerSupplyService.getPSCertifications(powerSupplyId,this.certId).subscribe(resultdetailview => {
        //this.DetailView = true;
        this.certData = resultdetailview[0];
        this.certtechnicianName = resultdetailview[0]['powerSupplyCertifications'].technicianName;
        this.certInsPDate = resultdetailview[0]['powerSupplyCertifications'].inspectionDate;
        this.certCertDate = resultdetailview[0]['powerSupplyCertifications'].certificationDate;
        if(this.certData != undefined){

        let gpslat = this.commonService.decimalCount(resultdetailview[0]['powerSupplyCertifications'].gpsLatitude);
        let gpslong = this.commonService.decimalCount(resultdetailview[0]['powerSupplyCertifications'].gpsLongitude);
        if(gpslat > 6){
          this.gpsgreaterFlag = true;
         }else{
          this.gpsgreaterFlag = false;
        }

        if(gpslong > 6){
          this.gpsgreaterFlag = true;
        }else{
          this.gpsgreaterFlag = false;
        }

        this.returnCertificationDate = new Date(resultdetailview[0].powerSupplyCertifications.certificationDate).toLocaleString();
        var str = this.certData['powerSupplyCertifications']['numberOfBatteries'];
        var splitted = str.split(" ");
        if (str.includes(this.parallel)) {
          this.batfirst = 1;
        } else {
          this.batfirst = splitted[0];
        }
        this.batlast = splitted[3];

        if(this.certData.powerSupplyCertsAlarm.alertLevel === 'Alert')
          this.alarm = this.certData.powerSupplyCertsAlarm.alertLevel;
        else if(this.certData.powerSupplyCertsAlarm.alertLevel === 'Warning')
          this.warning = this.certData.powerSupplyCertsAlarm.alertLevel;
        else if(this.certData.powerSupplyCertsAlarm.alertLevel === 'Informational')
          this.info = this.certData.powerSupplyCertsAlarm.alertLevel;
        }
      });
     }
    this.getWorkItems(powerSupplyId);
    this.showProgressBar = false;
    });
  }

  getWorkItems(powerSupplyId) {
    this.showProgressBar = true;
    this.powerSupplyService.getWorkItemsByPowerSupplyId(powerSupplyId, this.certId).subscribe((res) => {
      this.showProgressBar = false;
      this.workItems = res;
      // let event = this.lastVisitInfoForm.value.typeOfVisit;
      // let eventBP = (event !== undefined) ? event.startsWith("BP") : false;
      // if((res && res.length > 0 && eventBP)){
      //   this.workitemFlag = true;
      //   this.lastVisitInfoForm.controls["workitem"].clearValidators();
      //   this.lastVisitInfoForm.controls["workitem"].updateValueAndValidity();
      // }else{
      //   this.workitemFlag = false;
      //   this.lastVisitInfoForm.controls["workitem"].setValidators(Validators.required);
      //   this.lastVisitInfoForm.controls["workitem"].updateValueAndValidity();
      // }
    });
  }
  newCert(){
    if(this.powerSupplyIdval != null){
      this.getPSCertificationID(this.powerSupplyIdval,null);
    }
  }
  resetInspection(){

    let eventtypeofvisit = this.lastVisitInfoForm.value.typeOfVisit;
    this.lastVisitInfoForm.reset();
    this.apuVisitFormGroup.reset();
    for(let i=0;i < this.batteryBatteryForms.length;i++) {
    //this.batteryBatteryForms.controls[i].get('batteryVoltageNoLoad').reset();
    this.batteryBatteryForms.controls[i].get('batteryVoltageUnderLoad').reset();
    this.batteryBatteryForms.controls[i].get('batteryConductance').reset();
    this.batteryBatteryForms.controls[i].get('batteryConductanceCorrected').reset();
    this.batteryBatteryForms.controls[i].get('totalVoltage').reset();
    }
    this.lastVisitInfoForm.controls['inspectionDate'].patchValue('');
    this.lastVisitInfoForm.controls['typeOfVisit'].patchValue(eventtypeofvisit);
    this.apuVisitFormGroup.controls['apuVisitedTech'].patchValue((this.triageLogNt) ? this.triageLogNt : this.userName);
    //adding validation for last visit and apu visit
    setTimeout(() => {
      this.lastCert = true;
      this.showApu = true;
      this.lastVisitInfoFormValidation();
      this.apuVisitFormGroupValidation();
      this.markAsTouched(this.apuVisitFormGroup);
      this.dialog.closeAll();
    });
  }



  getImageDetails(powerSupplyId,triageId) {
    if(triageId){
      this.showLoading = true;
      if(this.visitdata == 'Annual Inspection'){
        this.isAnnualInspect = true;

      }
      this.initializeLatestDateImage();
      // Get PS Images from Image details
      var promises1 = [];
      this.psImagesService.setImages();
      var psImages1 = this.psImagesService.getImages();
      this.powerSupplyService.getPsnbSdsImageDetailByPsId(this.powerSupplyId).subscribe(result => {
        result.forEach(psnbimagedata => {
          this.isImageLatest(psnbimagedata.category,psnbimagedata.createDate,psnbimagedata.latestImage);
          promises1.push(this.getPsnbImageByPsId(this.powerSupplyId, psnbimagedata.category));
        });
        Promise.all(promises1)
          .then(imagesResponse => {
            this.ref.detectChanges();
            result.forEach((imageDetail, key) => {
              let catgry = <any>imageDetail['category'] - 1;
              if(!this.catErrMessage.includes(imageDetail['category'].toString())){
                let objectURL = URL.createObjectURL(imagesResponse[key]);
                psImages1[catgry]['url'] = this.sanitizer.bypassSecurityTrustUrl(objectURL);
              }
            });
          }).catch((err) => {
            this.showProgressspinner = false;
            this.openErrorDialog("Unable to fetch the images");
          });
      }, err => {
        this.showProgressspinner = false;
        this.openErrorDialog("Unable to fetch the images");
      });

      // Get PS Images from Image details
      var promises2 = [];
      this.psImagesService.setImages();
      var psImages2 = this.psImagesService.getImages();
      this.psnbApi.getPsnbSdsTriageImageDetailByTriageId(this.triageId).subscribe(result => {
        result.forEach(psnbimagedata => {
          this.isImageLatest(psnbimagedata.category,psnbimagedata.createDate,psnbimagedata.latestImage);
          promises2.push(this.getPsnbtriageImageByPsId(this.triageId, psnbimagedata.category));
        });
        Promise.all(promises2)
          .then(imagesResponse => {
            this.ref.detectChanges();
            result.forEach((imageDetail, key) => {
              let catgry = <any>imageDetail['category'] - 1;
              if(!this.catTriageErrMessage.includes(imageDetail['category'].toString())){
                let objectURL = URL.createObjectURL(imagesResponse[key]);
                psImages2[catgry]['url'] = this.sanitizer.bypassSecurityTrustUrl(objectURL);
              }
            });
            let resultObj = {};
            for (let i = 0; i < psImages1.length; i++) {
              resultObj[psImages1[i].id] = psImages1[i];
            }
            for (let i = 0; i < psImages2.length; i++) {
              if(psImages2[i].url == "") {

              }else{
                resultObj[psImages2[i].id] = psImages2[i];
              }
            }
            this.showLoading = false;
            if(this.catErrMessage.length > 0 || this.catTriageErrMessage.length > 0){
              //let arr = Array.from(new Set(this.catErrMessage.concat(this.catTriageErrMessage))).sort();
              let errMessage = "Unable to fetch Images categories from ";
              if(this.catErrMessage.length > 0)
                errMessage = errMessage.concat("Master: "+ this.catErrMessage.sort());
              if(this.catTriageErrMessage.length > 0)
                errMessage = errMessage.concat(" Triage: "+ this.catTriageErrMessage.sort());
              this.openDialog(errMessage);
            }
            this.detailedImage = Object.values(resultObj);
            this.setMandatoryFlagOnImages(this.detailedImage);
          }).catch((err) => {
          });
      }, err => {

      });

    }
    //View Image Section Starts here
    if ((powerSupplyId !== null || powerSupplyId !== undefined) && !triageId ) {
      this.showLoading = true;
      if(this.visitdata == 'Annual Inspection'){
        this.isAnnualInspect = true;

      }
      this.initializeLatestDateImage();
      // Get PS Images from Image details
      var promises = [];
      this.psImagesService.setImages();
      var psImages = this.psImagesService.getImages();
      this.powerSupplyService.getPsnbSdsImageDetailByPsId(this.powerSupplyId).subscribe(result => {
        result.forEach(psnbimagedata => {
          //if(this.visitdata == 'Annual Inspection'){
          this.isImageLatest(psnbimagedata.category,psnbimagedata.createDate,psnbimagedata.latestImage);
          //}
          promises.push(this.getPsnbImageByPsId(this.powerSupplyId, psnbimagedata.category));
        });
        Promise.all(promises)
          .then(imagesResponse => {
            result.forEach((imageDetail, key) => {
              let catgry = <any>imageDetail['category'] - 1;
              if(!this.catErrMessage.includes(imageDetail['category'].toString())){
                let objectURL = URL.createObjectURL(imagesResponse[key]);
                psImages[catgry]['url'] = this.sanitizer.bypassSecurityTrustUrl(objectURL);
              }
            });
            this.ref.markForCheck();
            this.detailedImage = psImages;
            this.setMandatoryFlagOnImages(this.detailedImage);
            this.showLoading = false;
            if(this.catErrMessage.length > 0)
              this.openDialog("Unable to fetch the images for categories: "+ this.catErrMessage.sort());
          }).catch((err) => {
            this.showProgressspinner = false;
            this.openErrorDialog("Unable to fetch the images");
          });
      }, err => {
        this.showProgressspinner = false;
        this.openErrorDialog("Unable to fetch the images");
      });
    }
  }

  initializeLatestDateImage(){
    for(let index = 0; index < 11; index++){
      var dataVal: DateAndLatestImage;
      dataVal = {
        latestImage : "No Image",
        uploadedDate : "null"
      }
      this.latestDateDetail.push(dataVal);
    }
  }

  isImageLatest(category,createDate,latestImage){
    let catgry = category -1;
    for(let index = 0; index < this.latestDateDetail.length; index++){
      var dataVal: DateAndLatestImage;
      if(catgry == index){
        if(latestImage === 'Old'){
          dataVal = {
            latestImage : latestImage,
            uploadedDate : createDate != null ? new Date(createDate).toLocaleString(): ''
          }
        } else{
          dataVal = {
            latestImage : latestImage,
            uploadedDate : createDate != null ? new Date(createDate).toLocaleString(): ''
          }
        }
        this.latestDateDetail[index]= dataVal;
      }
    }
  }

  getPsnbImageByPsId(powerSupplyId, category) {
    return new Promise((resolve, reject) => {
      this.powerSupplyService.getPsnbSdsImageByPsIdAndCategory(powerSupplyId, category)
        .pipe(map(binaryData => binaryData))
        .subscribe(binaryData => {
          resolve(binaryData);
        }, err => {
          //reject(err);
          this.catErrMessage.push(category);
          resolve('Image Category '+ category +' not able to fetch');
        });
    });
  }

  getPsnbtriageImageByPsId(triageId, category){
    return new Promise((resolve, reject) => {
      this.powerSupplyService.getPsnbSdsTriageImageByCategoryAndTriageId(triageId, category)
        .pipe(map(binaryData => binaryData))
        .subscribe(binaryData => {
          resolve(binaryData);
        }, err => {
          //reject(err);
          this.catTriageErrMessage.push(category);
          resolve('Image Category '+ category +' not able to fetch');
        });
    });
  }




  /*Function to select the file  - Edit view File upload */
  onselectFile(event, uploadedId, imagedata): void {
    if (event.target.files[0] !== null && event.target.files[0] !== undefined) {
      this.file = event.target.files[0];
      let fileBlob = null;
      if (this.file !== null && this.file !== undefined) this.fileName = this.file.name;
      var uploadId = event.target.id;
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.ref.markForCheck();
        let index = this.detailedImage.indexOf(imagedata);
        imagedata.url = event.target.result;
        this.detailedImage[index] = imagedata;
        this.latestDateDetail[index].uploadedDate = new Date().toLocaleString();
        if (this.filearray.length > 0) {
          var blob = new Blob([this.file], { type: 'multipart/form-data' });
          fileBlob = new File([blob], this.fileName);
          const existing = this.filearray.find(x => x.id == uploadedId);
          if (existing) {
            let index = this.filearray.indexOf(existing);
            existing.file = this.file;
            existing.filedata = this.fileName;
            existing.fileblob = fileBlob;
            this.filearray[index] = existing;
          } else {
            this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });
          }
        } else {
          var blob = new Blob([this.file], { type: 'multipart/form-data' });
          fileBlob = new File([blob], this.fileName);
          this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });
        }
        if (this.vm.mandatoryImageInHouseCertification) {
          this.checkMandatoryImages();
        }
      }
      this.psSingleFileUpload(event.target.files[0], uploadedId);
    }
  }

  openAddEntryDialog(val) {
    this.createRendererComponent = this.dialog.open(PowersupplyCertWorkitemComponent, {
      panelClass: 'my-centered-dialog',
     // width: '600px',
      disableClose: val,
      data: {
        powerSupplyId: this.powerSupplyId,
        certId: this.certId,
        triageId:this.triageId
      }
    });
    this.createRendererComponent.afterClosed().subscribe(result => {
      // if (result === true) {
      //  /// this.refreshData();
      // }
      //workitem starts here
      let event = this.lastVisitInfoForm.value.typeOfVisit;
      let eventBP = (event !== undefined) ? event.startsWith("BP") : false;
      if(eventBP && !this.permissionValue && (this.triageId == null || this.triageId == undefined)) {
        this.powerSupplyService.getTriageWorkItemsBYPsCertID(this.certId,this.powerSupplyId, this.triageId).subscribe(res => {
         if(res && res.length > 0){
            this.lastVisitInfoForm.controls["workitem"].clearValidators();
            this.lastVisitInfoForm.controls["workitem"].updateValueAndValidity();
         }else{
            this.lastVisitInfoForm.controls["workitem"].setValidators(Validators.required);
           this.lastVisitInfoForm.controls["workitem"].updateValueAndValidity();
         }
         this.ref.detectChanges();
         this.ref.markForCheck();
        });
      }
    });
  }

  psSingleFileUpload(file, uploadedId) {
    this.openUploadDialog("Image Uploading..........");
    var uploadvalue = [];
    var categoryUploaded = [];
    var file = file;
    var categoryValue = uploadedId;
    let fileBlob = null;
    let fileName = null;
    let fileblobarray = [];
    if (file !== null && file !== undefined) fileName = file.name;
    var blob = new Blob([file], { type: 'multipart/form-data' });
    fileBlob = new File([blob], fileName);
    categoryUploaded.push(categoryValue);
    //var psId = 0;
    //if(this.permissionValue)
    //psId = this.powerSupplyId;
    let uploadObj = {
      powerSupplyId: this.powerSupplyId,
      powerSupplyName: null,
      macAddr: this.transponderInfoForm.value.activeMacAddress,
      nodeId: null,
      createDate: "",
      latestImage: "null",
      fileName: "",
      contentType: "",
      category: categoryValue,
    };
    const uploadBlob = new Blob([JSON.stringify(uploadObj)], { type: 'multipart/form-data' });
    uploadvalue.push(uploadBlob);
    fileblobarray.push(fileBlob);
    var triageId = null;
    if(!this.permissionValue)
      triageId = 0;
    return new Promise((resolve, reject) => {
      this.powerSupplyService.uploadSdsImage('Edit', triageId, fileblobarray, uploadvalue)
        .pipe(map(binaryData => binaryData))
        .subscribe(binaryData => {
          resolve(binaryData);
          const message = `PowerSupply Images Uploaded by: ${this.userName} at ${new Date().toISOString()} . Image categories are: ${categoryUploaded}`;
          const activity = 'PowerSupply Image Upload';
          this.commonService.loggerPost(message, activity, 3);
          this.dialog.closeAll();
          this.openDialog("Uploaded Successfully. Please save Power Supply.");
          //this.openCreatedDialog("Image Uploaded Successfully");
        }, err => {
          reject(err);
          this.showProgressBar = false;
          this.openErrorDialog("Unable to Upload Images");
        });
    });
  }
  getTelemetryThresholdsAlertProfileData() {
    this.powerSupplyService.getTelemetryThresholdsAlertProfile().subscribe((res) => {
      if(res != null && res.length > 0)
          this.telemetryThresholdProfileData = res;
    });
  }
  /*Function to save the multiple files  - Edit Section File upload*/
  // psFileUpload(powerSupply) {
  //   if (powerSupply.powerSupplyId != null && powerSupply.powerSupplyId != 0) {
  //     this.powerSupplyId = powerSupply.powerSupplyId;
  //     var uploadvalue = [];
  //     var categoryUploaded = [];
  //     for (let i = 0; i < this.filearray.length; i++) {
  //       var categoryValue = this.filearray[i]['id'];
  //       categoryUploaded.push(categoryValue);
  //       let uploadObj = {
  //         powerSupplyId: this.powerSupplyId,
  //         powerSupplyName: powerSupply.powerSupplyName,
  //         macAddr: powerSupply.macAddress,
  //         nodeId: powerSupply.nodeId,
  //         createDate: "",
  //         latestImage: "null",
  //         fileName: "",
  //         contentType: "",
  //         category: categoryValue,
  //       };
  //       const uploadBlob = new Blob([JSON.stringify(uploadObj)], { type: 'multipart/form-data' });
  //       uploadvalue.push(uploadBlob);
  //       this.fileblobarray.push(this.filearray[i]['fileblob']);
  //     }
  //     return new Promise((resolve, reject) => {
  //       this.powerSupplyService.uploadSdsImage(this.triageId, this.fileblobarray, uploadvalue)
  //         .pipe(map(binaryData => binaryData))
  //         .subscribe(binaryData => {
  //           resolve(binaryData);
  //           const message = `PowerSupply Images Uploaded by: ${this.userName} at ${new Date().toISOString()} . Image categories are: ${categoryUploaded}`;
  //           const activity = 'PowerSupply Image Upload';
  //           this.commonService.loggerPost(message, activity, 3);
  //           this.showProgressspinner = false;
  //           this.openSavedDialog(this.powerSupplyName);
  //         }, err => {
  //           reject(err);
  //           this.showProgressspinner = false;
  //           this.openErrorDialog("Unable to Upload Images");
  //         });
  //     });
  //   }
  // }


  /*Function to save the multiple file  - Edit view File upload save*/
  // psFileUploadnoncomcast(result, powerSupply) {
  //   if (powerSupply.powerSupplyId != null && powerSupply.powerSupplyId != 0) {
  //     this.powerSupplyId = powerSupply.powerSupplyId;
  //     this.triageId = result.triageId;
  //     var uploadvalue = [];
  //     var categoryUploaded = [];
  //     for (let i = 0; i < this.filearray.length; i++) {
  //       var categoryValue = this.filearray[i]['id'];
  //       categoryUploaded.push(categoryValue);
  //       let uploadObj = {
  //         powerSupplyId: this.powerSupplyId,
  //         powerSupplyName: powerSupply.powerSupplyName,
  //         macAddr: powerSupply.macAddress,
  //         nodeId: powerSupply.nodeId,
  //         createDate: "",
  //         latestImage: "null",
  //         fileName: "",
  //         contentType: "",
  //         category: categoryValue,
  //       };
  //       const uploadBlob = new Blob([JSON.stringify(uploadObj)], { type: 'multipart/form-data' });
  //       uploadvalue.push(uploadBlob);
  //       this.fileblobarray.push(this.filearray[i]['fileblob']);
  //     }
  //     return new Promise((resolve, reject) => {
  //       this.powerSupplyService.uploadSdsImage(this.triageId, this.fileblobarray, uploadvalue)
  //         .pipe(map(binaryData => binaryData))
  //         .subscribe(binaryData => {
  //           resolve(binaryData);
  //           const message = `PowerSupply Images Uploaded by: ${this.userName} at ${new Date().toISOString()} . Image categories are: ${categoryUploaded}`;
  //           const activity = 'PowerSupply Image Upload';
  //           this.commonService.loggerPost(message, activity, 3);
  //           this.openSavedDialog(this.powerSupplyName, true);
  //         }, err => {
  //           reject(err);
  //           this.openErrorDialog("Unable to Upload Images");
  //         });
  //       this.showProgressspinner = false;
  //     });
  //   }
  // }


  markAsTouched(formGroup: any): void {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const abstractControl = formGroup.get(key);
      if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
        this.markAsTouched(abstractControl);
      } else {
        abstractControl.markAsTouched();
        abstractControl.markAsDirty();
      }
    })
  }

  getForms() {
    this.apuVisitFormGroup = this.fb.group({
      apuinspectionDate: [''],
      apuVisitedTech: [(this.triageLogNt) ? this.triageLogNt : this.userName],
      apuBatteryManuType: [''],
      apuBatteryDateCode: [''],
      apuBatteryInstallDate: [''],
      apuBatteryVltgNoLoad: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryConductance: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryCon77deg: [''],
      apuBatteryTorque: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryTerminals: [''],
      apuStarter: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuCharger: ['', [NumberOnlyValidation.ValidateNumber()]],
      followup: [''],
      recordAsFoundAlarms: [''],
      apuTestRun: [''],
      checkOilLevel: [''],
      ifOilAdded: [''],
      oilFilterTight: [''],
      inspectGenerator: [''],
      inspectSparkPlug: [''],
      clearApuEventlog: [''],
      apuFrequency: [''],
      tank1: [''],
      tank2: [''],
      gasMeter: [''],
      gasMeterReading: [''],
      ngPressure: [''],
      airFilter: [''],
      rodentInsectDamage: [''],
      checkLamps: [''],
      clearWeeds: [''],
      checkRegrout: [''],
      ifGroundMount: [''],
      anyEnclosure: [''],
      cleanUpGarbage: [''],
      testOilPressure: [''],
      testhighTemp: [''],
      generatorDcBus: [''],
      checkForGas: [''],
      testCombustible: [''],
      testTamper: [''],
      testWaterIntrusion: [''],
      testPad: [''],
      comments: ['', [Validators.maxLength(225)]]
    });
    this.apuFormGroup = this.fb.group({
      apuMakeModel: ['',  this.inbuiltValue ? null : Validators.required],
      apuSerialNumber: ['',  this.inbuiltValue ? null : Validators.required],
      apuDeviceId: ['',  this.inbuiltValue ? null : Validators.required],
      apuRunTime: ['',  this.inbuiltValue ? null : Validators.required],
      ecmAcm: ['',  this.inbuiltValue ? null : Validators.required],
      dateApuInstalled: ['',  this.inbuiltValue ? null : Validators.required],
      apuOpVltgRating: ['',  this.inbuiltValue ? null : Validators.required],
      apuNoLoadVltg: ['', [ this.inbuiltValue ? null : Validators.required, NumberOnlyValidation.ValidateNumber()]],
      apuLoadVltg: ['', [ this.inbuiltValue ? null : Validators.required, NumberOnlyValidation.ValidateNumber()]],
      apuEnclosure: ['', this.inbuiltValue ? null : Validators.required],
      ngLp: ['', this.inbuiltValue ? null : Validators.required],
      ngProvider: ['', this.inbuiltValue ? null : Validators.required],
      lpTankCapacity: ['',  this.inbuiltValue ? null : Validators.required],
      noOfTanksInstalled: ['',[ this.inbuiltValue ? null : Validators.required,NumberOnlyValidation.ValidateNumber()]],
    });

    this.locationInfoForm = this.fb.group({
      locationInfoFormInput: [],
      houseNumberInput: [''],
      street: ['', Validators.required],
      crossStreet: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', [Validators.required,Validators.minLength(5),Validators.maxLength(5)]],
      primaryNode: [{ value: '', disabled: true }],
      prevNodeServed: [{ value: '', disabled: true }],
      mutliNodes: ['', Validators.required],
      latitude: ['', [Validators.required, GpsLatitudeValidation.ValidateDecimal(this.region), GpsLatitudeValidation.ValidateRange(this.region)]],
      longitude: ['', [Validators.required, GpsLongitudeValidation.ValidateDecimal(this.region), GpsLongitudeValidation.ValidateRange(this.region)]],
      calculatedRuntime: [{value: '', disabled: true}],
      powerNode: ['', Validators.required],
      spLocDetails: [''],
      areial: ['', Validators.required],
      // powerAccountType: [{value: '', disabled: true}],
      // pole: [''],
      // //powerCompany: ['', Validators.required],
      // powerCompany: [{ value:'', disabled: true}],
      // companyAccNum: [{value: '', disabled: true}],
      // companyContact: [{value: '', disabled: true}],
      // companyWebsite: [{value: '', disabled: true}],
      powerAccountType: [''],
      pole: [''],
      powerCompany: ['', Validators.required],
      companyAccNum: [''],
      companyContact: [''],
      companyWebsite: [''],
      nwtTeam: [{value: '', disabled: true}],
      nitroCompletionDate: [''],
      nitroReasonNotCompleted: [''],
      meter: [''],
      mapPageNumber: [''],
      pscreateddate:[{ value: '', disabled: true }],
      locationComments: ['', [Validators.maxLength(225)]],
      businessPartnerRestriction: [''],
    });
    this.transponderInfoForm = this.fb.group({
      transponderInfoFormInput: [],
      standByOpts: ['', Validators.required],
      activeMacAddress: [{ value: this.activeMacAddress }, [Validators.required, MACPlaceholderValidation.ValidateMac00(), MACPlaceholderValidation.ValidateEditMac()]],
      prevMacAddress: [{ value: '', disabled: true }],
      ip: ['', Validators.required],
      powerSupplyNum: ['', [Validators.required, PowerSupplyNumValidation.ValidatePowerSupplyNum(this.region)]],
      nextGenNode: [''],
      sfpMac: [{ value: '', disabled: true }],
      transponderVendor: ['', [Validators.required]],
      transponderModel: ['', Validators.required],
      powerSupplyModel: [''],
      powerSupplyType9360: [''],
      acInputVoltage: ['', [Validators.required]],
      acOutputVoltage: ['', [Validators.required]],
      // acInputVoltage: ['', [Validators.required, PowerSupplyNumValidation.ValidateacInputVoltage(this.inputVoltageRatings)]],
      // acOutputVoltage: ['', [Validators.required, PowerSupplyNumValidation.ValidateacOutputVoltage(this.outputVoltageRatings)]],
      currentAmp: ['', [Validators.required, PowerSupplyNumValidation.ValidatecurrentAmp(this.ampRatings)]],
      //currentAmpOutput: ['', [Validators.required, PowerSupplyNumValidation.ValidatecurrentAmpOutput()]],
      //currentAmpOutput: ['', [Validators.required]],
      powerSupplyAlertProfile: [{ value: this.powerSupplyAlertProfile, disabled: true }],
      serialNum: [''],
      //controlledCardType: ['', Validators.required],
      dcReady: [''],
      priority: [''],
      egisName: [''],
      externalSensor: [''],
      //globalidentifier: [''],
      globalidentifier: [{ value: '', disabled: true }],
      transponderComments: ['', [Validators.maxLength(225)]]
    }, {
      validator: TransponderFormValidator.ValidateVendorType
    });

    this.onChangeSysLocation();

    this.lastVisitInfoForm = this.fb.group({
      inspectionDate: [''],
      selftest: ['', Validators.required],
      selftestrunning: ['', Validators.required],
      typeOfVisit: [''],
      xocVerified: [''],
      visitStatus: [''],
      followUpReasons: [''],
      mobileno:['', this.permissionValue ? null : Validators.required],
      cleanDust: [''],
      tightenAll: [''],
      inspectWire: [''],
      inspectBattery: [''],
      meterPan: [''],
      powerCo: [''],
      batteryHeaterType: [''],
      batteryHeaterQuantity: [''],
      encloseSnow: [''],
      internalBreaker: [''],
      serviceEntrance: [''],
      receptacleType: [''],
      checkSeizure: [''],
      psIDLegibile: [''],
      checkLamps: [''],
      checkCircuitBreaker: [''],
      visualInspection: [''],
      cabinetLocked: [''],
      securityBar: [''],
      checkGround: [''],
      batteryStringFused1: [''],
      batteryStringFused2: [''],
      batteryStringFused3: [''],
      batteryStringFused4: [''],
      batteryStringFused5: [''],
      batteryStringFused6: [''],
      tamperInstalled: [''],
      checkLaps: [''],
      cabinetVendor: [''],
      cabinetBattery: [''],
      checkOperating: [''],
      followUp: [''],
      inputSurge: [''],
      outputSurge: [''],
      coaxTvss: [''],
      acIndicator: [''],
      lri: [''],
      lastVisitComments: [''],
      workitem: [''],
      checkAll:['']
    });

    this.batteryInfoForm = this.fb.group({
      batteryInfoFormInput: [],
      numberofBatteries: ['', Validators.required],
      batteriesReplaced: ['', Validators.required],
      //airTemperature: [''],
      batteryManagerModel: ['', Validators.required],
      batteryComments: ['', [Validators.maxLength(225)]]
    });

    this.nodesForm = this.fb.group({
      nodesFormInput: [],
      node: this.fb.array([])
    })

    this.batteryStringForm = this.fb.group({
      batteryStringFormInput: [],
      batteryString: this.fb.array([])
    });

    this.batteryBatteryForm = this.fb.group({
      batteryBatteryFormInput: [],
      batteryBatteries: this.fb.array([])
    });

    if (this.region === 'Boston Region') {
      this.showPSNumberInput = true;
      this.showPSNumberSelect = false;
    } else if (this.region === 'Freedom Region') {
      this.showPSNumberInput = false;
      this.showPSNumberSelect = true;
      this.PSNOptions = this.PSNFreedomOptions;
    } else if (this.region === 'Keystone Region') {
      if (this.hierarchyPath.includes('Keystone East')) {
        this.PSNOptions = this.PSKeyStoneEastOptions;
      } else if (this.hierarchyPath.includes('Keystone West')) {
        this.PSNOptions = this.PSKeyStoneWestOptions;
      }
    } else if (this.region === 'Beltway Region') {
      this.showPSNumberInput = false;
      this.showPSNumberSelect = true;
      this.PSNOptions = this.PSNOptionsOther;
    } else {
      this.showPSNumberInput = true;
      this.showPSNumberSelect = false;
    }
    this.showForms = true;
  }

  get nodesForms() {
    return this.nodesForm.get('node') as FormArray;
  }

  get batteryStringForms() {
    return this.batteryStringForm.get('batteryString') as FormArray;
  }

  get batteryBatteryForms() {
    return this.batteryBatteryForm.get('batteryBatteries') as FormArray;
  }

  onChangeFeedMultipleNodes(event: any) {
    this.node2 = '';
    this.node3 = '';
    this.node4 = '';
    this.node5 = '';
    this.onChangeSysLocation();
    if (event !== '' && event !== null && event !== undefined) {
      this.split = event.split(' - ');
      if (this.split[0] !== 'No') {
        const split: string[] = this.split[1].split(' ');
        let numOfNodes = (Number(split[0])) - 1;
        if (numOfNodes > this.prevNodes) {
          for (let i = this.prevNodes; i < numOfNodes; i++) this.addNodes();
        } else if (numOfNodes < this.prevNodes) {
          for (let i = this.prevNodes; i > numOfNodes; i--) this.removeNode(i);
        }
        this.prevNodes = numOfNodes;
      } else {
        this.clearFormArray(this.nodesForms);
        this.nodeValues = new Array<string>(33);
        this.nodesForms.controls.splice(0);
        this.prevNodes = 0;
      }
    } else {
      this.clearFormArray(this.nodesForms);
      this.nodeValues = new Array<string>(33);
      this.nodesForms.controls.splice(0);
      this.prevNodes = 0;
    }
  }

  // onClone() {
  //   let event = this.batteryInfoForm.value.numberofBatteries;

  //   for (let i = 1; i < (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).length; i++) {

  //     (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryManufacturer').
  //       patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryManufacturer').value);

  //     // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batterySerial').
  //     // patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batterySerial').value);

  //     (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryCode').
  //       patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryCode').value);

  //     (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryInstallDate').
  //       patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryInstallDate').value);

  //     (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryVoltageNoLoad').
  //       patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryVoltageNoLoad').value);

  //     (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryVoltageUnderLoad').
  //       patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryVoltageUnderLoad').value);

  //     (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryConductance').
  //       patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryConductance').value);

  //     (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryConductanceCorrected').
  //       patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryConductanceCorrected').value);

  //     (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('totalVoltage').
  //       patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('totalVoltage').value);

  //   }
  // }


  formatDateType(dateString) {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) {
      return 'Invalid'
    }
    const day = String(date.getDate()).padStart(2,'0')
    const month = String(date.getMonth() + 1).padStart(2,'0')
    const year = String(date.getFullYear())
    return `${day}-${month}-${year}`
  }

  onScannedData(k) {
    //this.information = "A027921C&D_BBG-220RT2023-12-01";
    //this.information = "A000001 C&D BBG-220RT 2023-04-05";
    if(this.information.indexOf('C&D') !== -1){
      if(this.information.indexOf('_C&D_') !== -1){
        let scannerDataSplit = this.information.split('_');
        //['A027921', '\r', 'C&D_BBG-220RT', '\r', '2023-12-01']
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[1]+'_'+scannerDataSplit[2];
        let scanSplit = this.formatDateType(scannerDataSplit[3]);
        let scanyearsplit = scanSplit.split('-');
        let scanYear = scanyearsplit[2];
        this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
      }else if(this.information.indexOf(' C&D ') !== -1){
        let scannerDataSplit = this.information.split(' ');
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[1]+' '+scannerDataSplit[2];
        let scanSplit = this.formatDateType(scannerDataSplit[3]);
        let scanyearsplit = scanSplit.split('-');
        let scanYear = scanyearsplit[2];
        this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
      }else{
         //C&D
        let scannerDataSplit = this.information.split(/(\s+)/);
        console.log(scannerDataSplit)
        //['A027921', '\r', 'C&D_BBG-220RT', '\r', '2023-12-01']
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[2];
        let scanSplit = this.formatDateType(scannerDataSplit[4]);
        let scanyearsplit = scanSplit.split('-');
        let scanYear = scanyearsplit[2];
        this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
      }
    }
    else if(this.information.indexOf('ALPHA 3.5 HP') !== -1){
      let scannerDataSplit = this.information.split(/\r?\n/);
      this.scanSerialNum = scannerDataSplit[0];
      this.scanBatteryModel = scannerDataSplit[1];
      let scanSplit = this.formatDateType(scannerDataSplit[2]);
      let scanyearsplit = scanSplit.split('-');
      let scanYear = scanyearsplit[2];
      this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
    }
    else if(this.information.indexOf('ALPHA 4.0 HP') !== -1){
      let scannerDataSplit = this.information.split(/(\s+)/);
      console.log(scannerDataSplit)
      // if ['MJ2973549440', '\r\n', 'ALPHA', ' ', '4.0', ' ', 'HP', '\r\n', '03-13-2023']
      // else ['2415330013', ' ', 'MFG', ' ', 'Date;', ' ', '06/01/24', ' ', '00:05', ' ', 'ALPHA', ' ', '4.0', ' ', 'HP']
      if(scannerDataSplit.indexOf('MFG') !== -1){
        //new scenario
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[10]+' '+scannerDataSplit[12]+' '+scannerDataSplit[14];
        let scanSplit = scannerDataSplit[6];
        let scanyearsplit = scanSplit.split('/');//06/01/24
        console.log(scanyearsplit)
        let scanYear = scanyearsplit[2];
        console.log(scanYear)
        this.scanManufactureDate = scanyearsplit[0]+scanYear //monthyear MMYY
      }else{
        //old scenario
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[2]+' '+scannerDataSplit[4]+' '+scannerDataSplit[6];
        let scanSplit = this.formatDateType(scannerDataSplit[8]);
        let scanyearsplit = scanSplit.split('-');
        let scanYear = scanyearsplit[2];
        this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
      }
    }
    this.zoomFlag[k] = false;
    this.scanCurrentDate = new Date();

    //check the battery type is exists in battery type or not
    if (!this.batteryManufactureres.includes(this.scanBatteryModel)) {
      this.batteryManufactureres.push(this.scanBatteryModel)
    }
    let event = this.batteryInfoForm.value.numberofBatteries;
    //for (let i = 0; i < (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).length; i++) {

       (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryManufacturer').
        patchValue(this.scanBatteryModel);

       (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batterySerial').
         patchValue(this.scanSerialNum);

      (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryCode').
        patchValue(this.scanManufactureDate);

      (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryInstallDate').
        patchValue(this.scanCurrentDate);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryVoltageNoLoad').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryVoltageNoLoad').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryVoltageUnderLoad').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryVoltageUnderLoad').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryConductance').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryConductance').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryConductanceCorrected').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryConductanceCorrected').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('totalVoltage').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('totalVoltage').value);

   // }
  }

  scanSuccessHandler($event: any,index) {
    this.information = $event;
    console.log('Testing')
    console.log(this.information)
    this.scannerEnabled[index] = !this.scannerEnabled;
    this.onScannedData(index)
  }

  enableScanner(index) {
    if(this.scannerEnabled[index]){
      this.zoomFlag[index] = false;
      this.scannerEnabled[index] = false;
      this.scannerEnabled[index] = !this.scannerEnabled;
    }else{
      this.zoomFlag[index] = true;
      this.scannerEnabled[index] = true;
      this.scannerEnabled[index] = this.scannerEnabled;
    }
  }
  onChangeNumberOfBatteries() {
    this.changePSAlertProfile();
    this.addbatteryfusedValidation();
    let event = this.batteryInfoForm.value.numberofBatteries;
    if (event !== '' && event !== null && event !== undefined) {
      const split: string[] = event.split(' ');
      if(event == this.lionBat){
        this.min = 0;
        this.max = 1;
        this.parallelBatt = false;
        this.lionBatt = true;
        this.noOfBatteriesFused = Array(Number(1)).fill(0).map((x, i) => i + 1);
        //if (Number(split[0]) !== 0) {
          let numberOfStrings = 1;
          this.noOfBatteries = 1;
          let batteries = 1;
          let b: Array<number[]> = new Array(numberOfStrings - 1);
          for (let z = 0; z <= numberOfStrings - 1; z++) {
            let a: number[] = new Array(batteries - 1);
            for (let k = 0; k <= batteries - 1; k++) {
              if (k >= this.min && k <= this.max) {
                a[k] = k;
              }
              else {
                a[k] = 50;
              }
            }
            b[z] = a;
            this.changeMinMax();
          }
          this.batteryGroup = b;
          if (this.prvString !== null && this.prvString !== undefined) {
            if (numberOfStrings !== this.prvString && numberOfStrings > this.prvString) {
              for (let i = this.prvString; i < numberOfStrings; i++) {
                this.addBatteries();
                this.clearValidationOnChange();
              }
            } else if (numberOfStrings !== this.prvString && numberOfStrings < this.prvString) {
              for (let i = this.prvString; i > numberOfStrings; i--) {
                this.removeString(i);
              }
            }
          }
          if (this.prvBattery !== null && this.prvBattery !== undefined && this.prvString !== null && this.prvString !== undefined) {
            let newArray: any = [];
            let preArray: any = [];
            let battArray: any = [];
            let temp = 0;
            let temp1 = 16;
            for (let i = 0; i < this.prvString; i++) {
              for (let j = 0; j < this.prvBattery; j++)
                preArray.push(i + '' + j)
            }
            for (let i = 0; i < numberOfStrings; i++) {
              for (let j = 0; j < this.noOfBatteries; j++)
                newArray.push(i + '' + j)
            }
            for (let i = 0; i < 6; i++) {
              for (let j = 0; j < 4; j++) {
                if (newArray.includes(i + '' + j) && preArray.includes(i + '' + j)) battArray.push(i + '' + j);
                else if (newArray.includes(i + '' + j) && !(preArray.includes(i + '' + j))) battArray.push('55');
                else if (!(newArray.includes(i + '' + j)) && preArray.includes(i + '' + j)) battArray.push('66');
                else battArray.push('x');
              }
            }
            for (let i = battArray.length - 1; i >= 0; i--) {
              if (battArray[i] == 66) {
                this.removeBattery(temp1);
              }
              temp1--;
            }
            for (let i = 0; i <= battArray.length - 1; i++) {
              if (battArray[i] !== '66' && battArray[i] !== 'x') {
                if (battArray[i] == 55) {
                  this.addBatteryBatteries(temp);
                }
                temp++;
              }
            }
          }
          this.prvString = numberOfStrings;
          this.prvBattery = this.noOfBatteries;
          this.markAsTouched(this.batteryStringForm);
          this.markAsTouched(this.batteryBatteryForm);
       // }
      }else if (split[0] == this.parallel) {
        this.parallelBatt = true;
        this.lionBatt = false;
        this.parallelBatteries = event;
        var numberofparallelBatteries = Number(split[1]);
        this.min = 0;
        this.max = Number(split[1]) - 1;
        this.noOfBatteries = numberofparallelBatteries;
        let parallelBatteriesArray: Array<number[]> = new Array(numberofparallelBatteries - 1);
        let numberOfStrings = 1;
        this.noOfBatteriesFused = Array(Number(split[1])).fill(0).map((x, i) => i + 1);
        for (let initialString = 0; initialString < 1; initialString++) {
          let arrayToHoldMultipleBatteriesInSameString: number[] = new Array(numberofparallelBatteries - 1);
          for (let k = 0; k <= numberofparallelBatteries - 1; k++) {
            if (k >= this.min && k <= this.max) {
              arrayToHoldMultipleBatteriesInSameString[k] = k;
            }
          }
          parallelBatteriesArray[initialString] = arrayToHoldMultipleBatteriesInSameString;
          this.changeMinMax();
          this.batteryGroup = parallelBatteriesArray;
        }

        //Logic Existing to be re-used
        if (this.prvString !== null && this.prvString !== undefined) {
          if (numberOfStrings !== this.prvString && numberOfStrings > this.prvString) {
            for (let i = this.prvString; i < numberOfStrings; i++) {
              this.addBatteries();
              this.clearValidationOnChange();
            }
          } else if (numberOfStrings !== this.prvString && numberOfStrings < this.prvString) {
            for (let i = this.prvString; i > numberOfStrings; i--) {
              this.removeString(i);
            }
          }
        }
        if (this.prvBattery !== null && this.prvBattery !== undefined && this.prvString !== null && this.prvString !== undefined) {
          let newArray: any = [];
          let preArray: any = [];
          let battArray: any = [];
          let temp = 0;
          let temp1 = 16;
          for (let i = 0; i < this.prvString; i++) {
            for (let j = 0; j < this.prvBattery; j++)
              preArray.push(i + '' + j)
          }
          for (let i = 0; i < numberOfStrings; i++) {
            for (let j = 0; j < this.noOfBatteries; j++)
              newArray.push(i + '' + j)
          }
          for (let i = 0; i < 1; i++) {
            for (let j = 0; j < 6; j++) {
              if (newArray.includes(i + '' + j) && preArray.includes(i + '' + j)) battArray.push(i + '' + j);
              else if (newArray.includes(i + '' + j) && !(preArray.includes(i + '' + j))) battArray.push('55');
              else if (!(newArray.includes(i + '' + j)) && preArray.includes(i + '' + j)) battArray.push('66');
              else battArray.push('x');
            }
          }
          for (let i = battArray.length - 1; i >= 0; i--) {
            if (battArray[i] == 66) {
              this.removeBattery(temp1);
            }
            temp1--;
          }
          for (let i = 0; i <= battArray.length - 1; i++) {
            if (battArray[i] !== '66' && battArray[i] !== 'x') {
              if (battArray[i] == 55) {
                this.addBatteryBatteries(temp);
              }
              temp++;
            }
          }
        }
        this.prvString = numberOfStrings;
        this.prvBattery = this.noOfBatteries;
        this.markAsTouched(this.batteryStringForm);
        this.markAsTouched(this.batteryBatteryForm);
      } else {
        this.min = 0;
        this.max = Number(split[3]) - 1;
        this.parallelBatt = false;
        this.lionBatt = false;
        this.noOfBatteriesFused = Array(Number(split[3])).fill(0).map((x, i) => i + 1);
        if (Number(split[0]) !== 0) {
          let numberOfStrings = Number(split[0]);
          this.noOfBatteries = Number(split[3]);
          let batteries = Number(split[0]) * Number(split[3]);
          let b: Array<number[]> = new Array(numberOfStrings - 1);
          for (let z = 0; z <= numberOfStrings - 1; z++) {
            let a: number[] = new Array(batteries - 1);
            for (let k = 0; k <= batteries - 1; k++) {
              if (k >= this.min && k <= this.max) {
                a[k] = k;
              }
              else {
                a[k] = 50;
              }
            }
            b[z] = a;
            this.changeMinMax();
          }
          this.batteryGroup = b;
          if (this.prvString !== null && this.prvString !== undefined) {
            if (numberOfStrings !== this.prvString && numberOfStrings > this.prvString) {
              for (let i = this.prvString; i < numberOfStrings; i++) {
                this.addBatteries();
                this.clearValidationOnChange();
              }
            } else if (numberOfStrings !== this.prvString && numberOfStrings < this.prvString) {
              for (let i = this.prvString; i > numberOfStrings; i--) {
                this.removeString(i);
              }
            }
          }
          if (this.prvBattery !== null && this.prvBattery !== undefined && this.prvString !== null && this.prvString !== undefined) {
            let newArray: any = [];
            let preArray: any = [];
            let battArray: any = [];
            let temp = 0;
            let temp1 = 24;
            for (let i = 0; i < this.prvString; i++) {
              for (let j = 0; j < this.prvBattery; j++)
                preArray.push(i + '' + j)
            }
            for (let i = 0; i < numberOfStrings; i++) {
              for (let j = 0; j < this.noOfBatteries; j++)
                newArray.push(i + '' + j)
            }
            for (let i = 0; i < 6; i++) {
              for (let j = 0; j < 4; j++) {
                if (newArray.includes(i + '' + j) && preArray.includes(i + '' + j)) battArray.push(i + '' + j);
                else if (newArray.includes(i + '' + j) && !(preArray.includes(i + '' + j))) battArray.push('55');
                else if (!(newArray.includes(i + '' + j)) && preArray.includes(i + '' + j)) battArray.push('66');
                else battArray.push('x');
              }
            }
            for (let i = battArray.length - 1; i >= 0; i--) {
              if (battArray[i] == 66) {
                this.removeBattery(temp1);
              }
              temp1--;
            }
            for (let i = 0; i <= battArray.length - 1; i++) {
              if (battArray[i] !== '66' && battArray[i] !== 'x') {
                if (battArray[i] == 55) {
                  this.addBatteryBatteries(temp);
                }
                temp++;
              }
            }
          }
          this.prvString = numberOfStrings;
          this.prvBattery = this.noOfBatteries;
          this.markAsTouched(this.batteryStringForm);
          this.markAsTouched(this.batteryBatteryForm);
        } else {
          this.clearFormArray(this.batteryStringForms);
          this.clearFormArray(this.batteryBatteryForms);
          this.batteryStringForms.controls.splice(0);
          this.batteryBatteryForms.controls.splice(0);
          this.prvString = 0;
          this.prvBattery = 0;
        }
      }
    }
    else {
      this.clearFormArray(this.batteryStringForms);
      this.clearFormArray(this.batteryBatteryForms);
      this.prvString = 0;
      this.prvBattery = 0;
      this.batteryStringForms.controls.splice(0);
      this.batteryBatteryForms.controls.splice(0);
    }
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  onChangeBatteriesReplaced() {
    let event = this.batteryInfoForm.value.batteriesReplaced;

    for (let i = 0; i < (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).length; i++) {
      const batteryManufacturer = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryManufacturer');
      const batterySerial = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batterySerial');
      const batteryCode = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryCode');
      const batteryInstallDate = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryInstallDate');
      const batteryVoltageNoLoad = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryVoltageNoLoad');

      if (event !== '' && event !== null && event !== undefined && event.toLowerCase() !== 'no') {
        batteryManufacturer.setValidators([Validators.required]);
        batterySerial.setValidators([Validators.required]);
        batteryCode.setValidators([Validators.required, BatteryDateCodeValidation.ValidateBatteryDateCode()]);
        batteryInstallDate.setValidators([Validators.required]);
        batteryVoltageNoLoad.setValidators([Validators.required]);

        batteryManufacturer.updateValueAndValidity();
        batterySerial.updateValueAndValidity();
        batteryCode.updateValueAndValidity();
        batteryInstallDate.updateValueAndValidity();
        batteryVoltageNoLoad.updateValueAndValidity();

        this.markAsTouched(this.batteryBatteryForm);
        this.asterisk = '*';
      } else {
        batteryManufacturer.setValidators(null);
        batterySerial.setValidators(null);
        batteryCode.setValidators([BatteryDateCodeValidation.ValidateBatteryDateCode()]);
        batteryInstallDate.setValidators(null);
        batteryVoltageNoLoad.setValidators(null);

        batteryManufacturer.updateValueAndValidity();
        batterySerial.updateValueAndValidity();
        batteryCode.updateValueAndValidity();
        batteryInstallDate.updateValueAndValidity();
        batteryVoltageNoLoad.updateValueAndValidity();
        this.asterisk = '';
      }
    }
  }
  onChangevisitStatus() {
    let event = this.lastVisitInfoForm.value.visitStatus;
    if (event != 'Complete') {
      // this.lastVisitInfoForm.controls["followUpReasons"].setValidators(Validators.required);
      // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["lastVisitComments"].setValidators(Validators.required);
      // this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
    else {
      // this.lastVisitInfoForm.controls["followUpReasons"].clearValidators();
      // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["lastVisitComments"].clearValidators();
      // this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
    if(event == '' || event == undefined || event == null){
      // this.lastVisitInfoForm.controls["followUpReasons"].clearValidators();
      // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["lastVisitComments"].clearValidators();
      // this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
  }

  onfollowUpReasons() {
    let event = this.lastVisitInfoForm.value.typeOfVisit;
    if (event != 'Complete') {
      // this.lastVisitInfoForm.controls["lastVisitComments"].setValidators(Validators.required);
      // this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
    else {
      // this.lastVisitInfoForm.controls["lastVisitComments"].clearValidators();
      // this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
  }
  lastVisitInfoFormValidation(){
    this.lastVisitInfoForm.controls["inspectionDate"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["inspectionDate"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["typeOfVisit"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["typeOfVisit"].updateValueAndValidity();
    if (!this.permissionValue) {
    this.lastVisitInfoForm.controls["mobileno"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["mobileno"].setValidators(Validators.required);
    }
    // this.lastVisitInfoForm.controls["xocVerified"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["xocVerified"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["visitStatus"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["visitStatus"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["followUpReasons"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["cleanDust"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["cleanDust"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["tightenAll"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["tightenAll"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["inspectWire"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["inspectWire"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["inspectBattery"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["inspectBattery"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["meterPan"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["meterPan"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["powerCo"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["powerCo"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["batteryHeaterType"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["batteryHeaterType"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["batteryHeaterQuantity"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["batteryHeaterQuantity"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["encloseSnow"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["encloseSnow"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["internalBreaker"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["internalBreaker"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["serviceEntrance"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["serviceEntrance"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["receptacleType"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["receptacleType"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["checkSeizure"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["checkSeizure"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["psIDLegibile"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["psIDLegibile"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["checkLamps"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["checkLamps"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["checkCircuitBreaker"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["checkCircuitBreaker"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["visualInspection"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["visualInspection"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["cabinetLocked"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["cabinetLocked"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["securityBar"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["securityBar"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["checkGround"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["checkGround"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["tamperInstalled"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["tamperInstalled"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["checkLaps"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["checkLaps"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["cabinetVendor"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["cabinetVendor"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["cabinetBattery"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["cabinetBattery"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["checkOperating"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["checkOperating"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["followUp"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["followUp"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["inputSurge"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["inputSurge"].updateValueAndValidity();
    this.lastVisitInfoForm.controls["outputSurge"].setValidators(Validators.required);
    this.lastVisitInfoForm.controls["outputSurge"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["coaxTvss"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["coaxTvss"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["acIndicator"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["acIndicator"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["lri"].setValidators(Validators.required);
    // this.lastVisitInfoForm.controls["lri"].updateValueAndValidity();
    //this.lastVisitInfoForm.controls["lastVisitComments"].setValidators(Validators.required);
    //this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
  //   this.lastVisitInfoForm.controls["batteryStringFused1"].clearValidators();
  //   this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
  //   this.lastVisitInfoForm.controls["batteryStringFused2"].clearValidators();
  //   this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
  //   this.lastVisitInfoForm.controls["batteryStringFused3"].clearValidators();
  //   this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
  //   this.lastVisitInfoForm.controls["batteryStringFused4"].clearValidators();
  //   this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
  //   this.lastVisitInfoForm.controls["batteryStringFused5"].clearValidators();
  //   this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
  //   this.lastVisitInfoForm.controls["batteryStringFused6"].clearValidators();
  //   this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
  //   for (let i = 0; i < this.noOfBatteries; i++) {
  //   if (i == 0) {
  //   this.lastVisitInfoForm.controls["batteryStringFused1"].setValidators(Validators.required);
  //   this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
  //   } else if (i == 1) {
  //   this.lastVisitInfoForm.controls["batteryStringFused2"].setValidators(Validators.required);
  //   this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
  //   } else if (i == 2) {
  //   this.lastVisitInfoForm.controls["batteryStringFused3"].setValidators(Validators.required);
  //   this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
  //   } else if (i == 3) {
  //   this.lastVisitInfoForm.controls["batteryStringFused4"].setValidators(Validators.required);
  //   this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
  //   } else if (i == 4) {
  //     this.lastVisitInfoForm.controls["batteryStringFused5"].setValidators(Validators.required);
  //     this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
  //   } else if (i == 5) {
  //     this.lastVisitInfoForm.controls["batteryStringFused6"].setValidators(Validators.required);
  //     this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
  //   }
  // }
    this.lastVisitInfoForm.markAllAsTouched();
  }


  apuFormGroupValidation(){
    this.apuFormGroup.controls["apuMakeModel"].setValidators(Validators.required);
    this.apuFormGroup.controls["apuMakeModel"].updateValueAndValidity();
    this.apuFormGroup.controls["apuSerialNumber"].setValidators(Validators.required);
    this.apuFormGroup.controls["apuSerialNumber"].updateValueAndValidity();
    this.apuFormGroup.controls["apuDeviceId"].setValidators(Validators.required);
    this.apuFormGroup.controls["apuDeviceId"].updateValueAndValidity();
    this.apuFormGroup.controls["apuRunTime"].setValidators(Validators.required);
    this.apuFormGroup.controls["apuRunTime"].updateValueAndValidity();
    this.apuFormGroup.controls["ecmAcm"].setValidators(Validators.required);
    this.apuFormGroup.controls["ecmAcm"].updateValueAndValidity();
    this.apuFormGroup.controls["dateApuInstalled"].setValidators(Validators.required);
    this.apuFormGroup.controls["dateApuInstalled"].updateValueAndValidity();
    this.apuFormGroup.controls["apuOpVltgRating"].setValidators(Validators.required);
    this.apuFormGroup.controls["apuOpVltgRating"].updateValueAndValidity();
    this.apuFormGroup.controls["apuNoLoadVltg"].setValidators(Validators.required);
    this.apuFormGroup.controls["apuNoLoadVltg"].updateValueAndValidity();
    this.apuFormGroup.controls["apuLoadVltg"].setValidators(Validators.required);
    this.apuFormGroup.controls["apuLoadVltg"].updateValueAndValidity();
    this.apuFormGroup.controls["apuEnclosure"].setValidators(Validators.required);
    this.apuFormGroup.controls["apuEnclosure"].updateValueAndValidity();
    this.apuFormGroup.controls["ngLp"].setValidators(Validators.required);
    this.apuFormGroup.controls["ngLp"].updateValueAndValidity();
    this.apuFormGroup.controls["ngProvider"].setValidators(Validators.required);
    this.apuFormGroup.controls["ngProvider"].updateValueAndValidity();
    this.apuFormGroup.controls["lpTankCapacity"].setValidators(Validators.required);
    this.apuFormGroup.controls["lpTankCapacity"].updateValueAndValidity();
    this.apuFormGroup.controls["noOfTanksInstalled"].setValidators(Validators.required);
    this.apuFormGroup.controls["noOfTanksInstalled"].updateValueAndValidity();
  }

  saveApuChanges() {
    this.showProgressBar = true;
    const jsonApu: Apu = {};
    jsonApu.apuMakeModel = this.apuFormGroup.value.apuMakeModel;
    jsonApu.apuSerialNumber = this.apuFormGroup.value.apuSerialNumber;
    jsonApu.apuDeviceId = this.apuFormGroup.value.apuDeviceId;
    jsonApu.apuRunTime = this.apuFormGroup.value.apuRunTime;
    jsonApu.ecmAcm = this.apuFormGroup.value.ecmAcm;
    if (this.apuFormGroup.value.dateApuInstalled != null) {
      let date = new Date(this.apuFormGroup.value.dateApuInstalled);
      jsonApu.dateApuInstalled = date.getTime();
    } else jsonApu.dateApuInstalled = null;
    jsonApu.apuOutputVoltageRating = this.apuFormGroup.value.apuOpVltgRating;
    jsonApu.apuNoLoadVoltage = this.apuFormGroup.value.apuNoLoadVltg;
    jsonApu.apuLoadVoltage = this.apuFormGroup.value.apuLoadVltg
    jsonApu.apuEnclosureMake = this.apuFormGroup.value.apuEnclosure;
    jsonApu.ngLp = this.apuFormGroup.value.ngLp;
    jsonApu.ngProvider = this.apuFormGroup.value.ngProvider;
    jsonApu.lpTankCapacity = this.apuFormGroup.value.lpTankCapacity;
    jsonApu.numberOfTanks = this.apuFormGroup.value.noOfTanksInstalled;
    jsonApu.powerSupplyId = this.powerSupplyId;


    if (this.apu_id == 0 || this.apu_id==undefined||this.apu_id=='') {
      this.powerSupplyResourceService.createApu(jsonApu).subscribe(res => {
        //this.showProgressBar = false;
        if (res.success === true) {
          const activity = 'PowerSupply Edit - APU Save Certification';
          const message = 'PowerSupply APU Create Certification Success. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 3);

        } else {
          const activity = 'PowerSupply Edit - APU Save Certification - Error';
          const message = 'PowerSupply APU Create Certification Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
        }
      },
        err => {
          const activity = 'PowerSupply Edit - APU Save Certification - Error';
          const message = 'PowerSupply APU Create Certification Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
          this.showProgressBar = false;
        });
    } else {
      jsonApu.id = this.apu_id;
      this.powerSupplyResourceService.updateApu(jsonApu).subscribe(res => {
        //this.showProgressBar = false;
        if (res.success === true) {
          const activity = 'PowerSupply Edit Certification - APU Save';
          const message = 'PowerSupply APU Update Certification Success. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 3);
        } else {
          const activity = 'PowerSupply Edit Certification - APU Save - Error';
          const message = 'PowerSupply APU Update Certification Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
        }
      },
        err => {
          const activity = 'PowerSupply Edit Certification - APU Save - Error';
          const message = 'PowerSupply APU Update Certification Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
          this.showProgressBar = false;
        });
    }
  }

  saveApuChangesCertificationTriage(triageId) {
    this.showProgressBar = true;
    const jsonApu: ApuTriageCertifications = {};
    jsonApu.apuId=this.apu_id_cert;
    jsonApu.triageId = triageId;
    jsonApu.powerSupplyId = this.powerSupplyId;
    jsonApu.psCertificationId = (this.certId != null) ? this.certId : 0;
    jsonApu.apuMakeModel = this.apuFormGroup.value.apuMakeModel;
    jsonApu.apuSerialNumber = this.apuFormGroup.value.apuSerialNumber;
    jsonApu.apuDeviceId = this.apuFormGroup.value.apuDeviceId;
    jsonApu.apuRunTime = this.apuFormGroup.value.apuRunTime;
    jsonApu.ecmAcm = this.apuFormGroup.value.ecmAcm;
    if (this.apuFormGroup.value.dateApuInstalled != null) {
      let date = new Date(this.apuFormGroup.value.dateApuInstalled);
      jsonApu.dateApuInstalled = date.getTime();
    } else jsonApu.dateApuInstalled = null;
    jsonApu.apuOutputVoltageRating = this.apuFormGroup.value.apuOpVltgRating;
    jsonApu.apuNoLoadVoltage = this.apuFormGroup.value.apuNoLoadVltg;
    jsonApu.apuLoadVoltage = this.apuFormGroup.value.apuLoadVltg
    jsonApu.apuEnclosureMake = this.apuFormGroup.value.apuEnclosure;
    jsonApu.ngLp = this.apuFormGroup.value.ngLp;
    jsonApu.ngProvider = this.apuFormGroup.value.ngProvider;
    jsonApu.lpTankCapacity = this.apuFormGroup.value.lpTankCapacity;
    jsonApu.numberTanksInstalled = this.apuFormGroup.value.noOfTanksInstalled;
      this.powerSupplyResourceService.saveTriageAPUCertificate(jsonApu).subscribe(res => {
        //this.showProgressBar = false;
        if (res.success === true) {
          const activity = 'PowerSupply Edit - APU Save Certification';
          const message = 'PowerSupply APU Create Certification Success. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 3);
        } else {
          const activity = 'PowerSupply Edit - APU Save Certification - Error';
          const message = 'PowerSupply APU Create Certification Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
        }
      },
        err => {
          const activity = 'PowerSupply Edit - APU Save Certification - Error';
          const message = 'PowerSupply APU Create Certification Error. Data: ' + JSON.stringify(jsonApu);
          this.commonService.loggerPost(message, activity, 5);
          this.showProgressBar = false;
      });
    }
//save the record into APU_VISIT table
saveApuVisitChanges() {
  this.showProgressBar = true;
  const jsonApuShowVisit: ApuShowVisit = {};
  if (this.apuVisitFormGroup.value.apuinspectionDate != null) {
    let date = new Date(this.apuVisitFormGroup.value.apuinspectionDate);
    jsonApuShowVisit.inspectionDate =  date.getTime();
  } else jsonApuShowVisit.inspectionDate = null;
  jsonApuShowVisit.apuCompletedBy = this.apuVisitFormGroup.value.apuVisitedTech;
  jsonApuShowVisit.apuBatteryManufactureType = this.apuVisitFormGroup.value.apuBatteryManuType;
  jsonApuShowVisit.apuBatteryDateCode = this.apuVisitFormGroup.value.apuBatteryDateCode;
  if (this.apuVisitFormGroup.value.apuBatteryInstallDate != null) {
    let date = new Date(this.apuVisitFormGroup.value.apuBatteryInstallDate);
    jsonApuShowVisit.apuBatteryInstallDate = date.getTime();
  } else jsonApuShowVisit.apuBatteryInstallDate = null;
  jsonApuShowVisit.apuBatteryVoltageNoLoad = this.apuVisitFormGroup.value.apuBatteryVltgNoLoad;
  jsonApuShowVisit.apuBatteryConductance = this.apuVisitFormGroup.value.apuBatteryConductance;
  jsonApuShowVisit.apuBatteryConductanceCrrctd = this.apuVisitFormGroup.value.apuBatteryCon77deg;
  jsonApuShowVisit.apuBatteryTorque = this.apuVisitFormGroup.value.apuBatteryTorque;
  jsonApuShowVisit.apuBatteryTerminalsCleaned = this.apuVisitFormGroup.value.apuBatteryTerminals;
  jsonApuShowVisit.apuStarterBatteryChrgrVlt = this.apuVisitFormGroup.value.apuStarter;
  jsonApuShowVisit.apuChargerCurrentAmps = this.apuVisitFormGroup.value.apuCharger;
  jsonApuShowVisit.followUpaAtionNeeded = this.apuVisitFormGroup.value.followup;
  jsonApuShowVisit.recordAsFoundAlarms = this.apuVisitFormGroup.value.recordAsFoundAlarms;
  jsonApuShowVisit.apuTestRun = this.apuVisitFormGroup.value.apuTestRun;
  jsonApuShowVisit.checkOilLevel = this.apuVisitFormGroup.value.checkOilLevel;
  jsonApuShowVisit.oilAddedAmount = this.apuVisitFormGroup.value.ifOilAdded;
  jsonApuShowVisit.oilFilterTight = this.apuVisitFormGroup.value.oilFilterTight;
  jsonApuShowVisit.inspectGeneratorAirFilter = this.apuVisitFormGroup.value.inspectGenerator;
  jsonApuShowVisit.inspectSparkPlug = this.apuVisitFormGroup.value.inspectSparkPlug;
  jsonApuShowVisit.clearApuEventLog = this.apuVisitFormGroup.value.clearApuEventlog;
  jsonApuShowVisit.apuFrequency = this.apuVisitFormGroup.value.apuFrequency;
  jsonApuShowVisit.tankOneLevel = this.apuVisitFormGroup.value.tank1;
  jsonApuShowVisit.tankTwoLevel = this.apuVisitFormGroup.value.tank2;
  jsonApuShowVisit.gasMeterNumber = this.apuVisitFormGroup.value.gasMeter;
  jsonApuShowVisit.gasMeterReading = this.apuVisitFormGroup.value.gasMeterReading;
  jsonApuShowVisit.ngPressure = this.apuVisitFormGroup.value.ngPressure;
  jsonApuShowVisit.changeCleanenClosureAirFilter = this.apuVisitFormGroup.value.airFilter;
  jsonApuShowVisit.checkForRodentDamage = this.apuVisitFormGroup.value.rodentInsectDamage;
  jsonApuShowVisit.checkLampsLed = this.apuVisitFormGroup.value.checkLamps;
  jsonApuShowVisit.clearWeeds = this.apuVisitFormGroup.value.clearWeeds;
  jsonApuShowVisit.checkRegroutPadConduit = this.apuVisitFormGroup.value.checkRegrout;
  jsonApuShowVisit.groundMountPadUndermining = this.apuVisitFormGroup.value.ifGroundMount;
  jsonApuShowVisit.enclosureDamageVandalism = this.apuVisitFormGroup.value.anyEnclosure;
  jsonApuShowVisit.cleanupGarbage = this.apuVisitFormGroup.value.cleanUpGarbage;
  jsonApuShowVisit.testOilPressureAlarm = this.apuVisitFormGroup.value.testOilPressure;
  jsonApuShowVisit.testHighTempAlarm = this.apuVisitFormGroup.value.testhighTemp;
  jsonApuShowVisit.generatorDcBusFunction = this.apuVisitFormGroup.value.generatorDcBus;
  jsonApuShowVisit.checkForGasLeaks = this.apuVisitFormGroup.value.checkForGas;
  jsonApuShowVisit.testCombustibleGasAlarm = this.apuVisitFormGroup.value.testCombustible;
  jsonApuShowVisit.testTamperAlarm = this.apuVisitFormGroup.value.testTamper;
  jsonApuShowVisit.testWaterIntrusionAlarm = this.apuVisitFormGroup.value.testWaterIntrusion;
  jsonApuShowVisit.testPadsShearAlarm = this.apuVisitFormGroup.value.testPad;
  jsonApuShowVisit.apuVisitComments = this.apuVisitFormGroup.value.comments;
  jsonApuShowVisit.powerSupplyId = this.powerSupplyId;

  if (this.id == 0) {
    this.powerSupplyService.createApuVisit(jsonApuShowVisit).subscribe(res => {
      //this.showProgressBar = false;
      if (res.success === true) {
        const activity = 'PowerSupply Edit - APU Visit Certification Save';
        const message = 'PowerSupply APU Visit Create Certification Success. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 3);
      } else {
        const activity = 'PowerSupply Edit - APU Visit Save Certification - Error';
        const message = 'PowerSupply APU Visit Create Certification Error. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 5);
      }
    },
    err => {
        const activity = 'PowerSupply Edit - APU Visit Save Certification - Error';
        const message = 'PowerSupply APU Visit Create Certification Error. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 5);
        this.showProgressBar = false;
    });
  } else {
    jsonApuShowVisit.id = this.id;
    this.powerSupplyService.updateApuVisit(jsonApuShowVisit).subscribe(res => {
      //this.showProgressBar = false;
      if (res.success === true) {
        const activity = 'PowerSupply Edit - APU Visit Certification Save';
        const message = 'PowerSupply APU Visit Update Certification Success. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 3);
      } else {
        const activity = 'PowerSupply Edit - APU Visit Certification Save - Error';
        const message = 'PowerSupply APU Visit Update Certification Error. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 5);
      }
    },
    err => {
        const activity = 'PowerSupply Edit - APU Visit Certification Save - Error';
        const message = 'PowerSupply APU Visit Update Certification Error. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 5);
        this.showProgressBar = false;
    });
  }
}
saveApuVisitCertificationTriage(triageId) {
  this.showProgressBar = true;
  const jsonApuShowVisit: ApuShowVisitTriageCertifications = {};
  if (this.apuVisitFormGroup.value.apuinspectionDate != null) {
    let date = new Date(this.apuVisitFormGroup.value.apuinspectionDate);
    jsonApuShowVisit.inspectionDate =  date.getTime();
  } else jsonApuShowVisit.inspectionDate = null;
  jsonApuShowVisit.id=this.apuvisit_id_cert;
  jsonApuShowVisit.triageId = triageId;
  jsonApuShowVisit.psCertificationId = this.certId;
  jsonApuShowVisit.powerSupplyId = this.powerSupplyId;
  jsonApuShowVisit.apuCompletedBy = this.apuVisitFormGroup.value.apuVisitedTech;
  jsonApuShowVisit.apuBatteryManufacturerType = this.apuVisitFormGroup.value.apuBatteryManuType;
  jsonApuShowVisit.apuBatteryDateCode = this.apuVisitFormGroup.value.apuBatteryDateCode;
  if (this.apuVisitFormGroup.value.apuBatteryInstallDate != null) {
    let date = new Date(this.apuVisitFormGroup.value.apuBatteryInstallDate);
    jsonApuShowVisit.apuBatteryInstallDate = date.getTime();
  } else jsonApuShowVisit.apuBatteryInstallDate = null;
  jsonApuShowVisit.apuBatteryVoltageNoLoad = this.apuVisitFormGroup.value.apuBatteryVltgNoLoad;
  jsonApuShowVisit.apuBatteryConductance = this.apuVisitFormGroup.value.apuBatteryConductance;
  jsonApuShowVisit.apuBatteryConductanceCrrctd = this.apuVisitFormGroup.value.apuBatteryCon77deg;
  jsonApuShowVisit.apuBatteryTorque = this.apuVisitFormGroup.value.apuBatteryTorque;
  jsonApuShowVisit.apuBatteryTerminalsCleaned = this.apuVisitFormGroup.value.apuBatteryTerminals;
  jsonApuShowVisit.apuStarterBatteryChrgrVlt = this.apuVisitFormGroup.value.apuStarter;
  jsonApuShowVisit.apuChargerCurrentAmps = this.apuVisitFormGroup.value.apuCharger;
  jsonApuShowVisit.followUpActionNeeded = this.apuVisitFormGroup.value.followup;
  jsonApuShowVisit.recordAsFoundAlarms = this.apuVisitFormGroup.value.recordAsFoundAlarms;
  jsonApuShowVisit.apuTestRun = this.apuVisitFormGroup.value.apuTestRun;
  jsonApuShowVisit.checkOilLevel = this.apuVisitFormGroup.value.checkOilLevel;
  jsonApuShowVisit.oilAddedAmount = this.apuVisitFormGroup.value.ifOilAdded;
  jsonApuShowVisit.oilFilterTight = this.apuVisitFormGroup.value.oilFilterTight;
  jsonApuShowVisit.inspectGeneratorAirFilter = this.apuVisitFormGroup.value.inspectGenerator;
  jsonApuShowVisit.inspectSparkPlug = this.apuVisitFormGroup.value.inspectSparkPlug;
  jsonApuShowVisit.clearApuEventLog = this.apuVisitFormGroup.value.clearApuEventlog;
  jsonApuShowVisit.apuFrequency = this.apuVisitFormGroup.value.apuFrequency;
  jsonApuShowVisit.tankOneLevel = this.apuVisitFormGroup.value.tank1;
  jsonApuShowVisit.tankTwoLevel = this.apuVisitFormGroup.value.tank2;
  jsonApuShowVisit.gasMeterNumber = this.apuVisitFormGroup.value.gasMeter;
  jsonApuShowVisit.gasMeterReading = this.apuVisitFormGroup.value.gasMeterReading;
  jsonApuShowVisit.ngPressure = this.apuVisitFormGroup.value.ngPressure;
  jsonApuShowVisit.changeCleanenClosureAirFilter = this.apuVisitFormGroup.value.airFilter;
  jsonApuShowVisit.checkForRodentDamage = this.apuVisitFormGroup.value.rodentInsectDamage;
  jsonApuShowVisit.checkLampsLed = this.apuVisitFormGroup.value.checkLamps;
  jsonApuShowVisit.clearWeeds = this.apuVisitFormGroup.value.clearWeeds;
  jsonApuShowVisit.checkRegroutPadConduit = this.apuVisitFormGroup.value.checkRegrout;
  jsonApuShowVisit.groundMountPadUndermining = this.apuVisitFormGroup.value.ifGroundMount;
  jsonApuShowVisit.enclosureDamageVandalism = this.apuVisitFormGroup.value.anyEnclosure;
  jsonApuShowVisit.cleanupGarbage = this.apuVisitFormGroup.value.cleanUpGarbage;
  jsonApuShowVisit.testOilPressureAlarm = this.apuVisitFormGroup.value.testOilPressure;
  jsonApuShowVisit.testHighTempAlarm = this.apuVisitFormGroup.value.testhighTemp;
  jsonApuShowVisit.generatorDcBusFunction = this.apuVisitFormGroup.value.generatorDcBus;
  jsonApuShowVisit.checkForGasLeaks = this.apuVisitFormGroup.value.checkForGas;
  jsonApuShowVisit.testCombustibleGasAlarm = this.apuVisitFormGroup.value.testCombustible;
  jsonApuShowVisit.testTamperAlarm = this.apuVisitFormGroup.value.testTamper;
  jsonApuShowVisit.testWaterIntrusionAlarm = this.apuVisitFormGroup.value.testWaterIntrusion;
  jsonApuShowVisit.testPadShearAlarm = this.apuVisitFormGroup.value.testPad;
  jsonApuShowVisit.apuVisitComments = this.apuVisitFormGroup.value.comments;
    this.powerSupplyService.saveTriageAPUShowVisitCertificate(jsonApuShowVisit).subscribe(res => {
      //this.showProgressBar = false;
      if (res.success === true) {
        const activity = 'PowerSupply Edit - APU Visit Certification Save';
        const message = 'PowerSupply APU Visit Create Certification Success. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 3);
      } else {
        const activity = 'PowerSupply Edit - APU Visit Save Certification - Error';
        const message = 'PowerSupply APU Visit Create Certification Error. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 5);
      }
    },
    err => {
        const activity = 'PowerSupply Edit - APU Visit Save Certification - Error';
        const message = 'PowerSupply APU Visit Create Certification Error. Data: ' + JSON.stringify(jsonApuShowVisit);
        this.commonService.loggerPost(message, activity, 5);
        this.showProgressBar = false;
    });
}

  saveSFPTriage(triageID) {
    // this.powerSupplyService.getPowerSupplySfpTriageByPsId(this.powerSupplyId, null).subscribe(res1 => {
    //   if (res1 && res1.id != null) {
    //   //res1.forEach(element => {
    //     res1.triageId = triageID;
    //   //});
    //   this.powerSupplyService.updatePowerSupplySfpTriage(res1).subscribe(result => {
    //   });
    //   }
    // });
    if(this.triageId){
      this.powerSupplyService.getPowerSupplySfpTriageByPsId(this.powerSupplyId,this.triageId).subscribe(res1 => {
        if (res1 && res1.id != null) {
        //res1.forEach(element => {
          res1.triageId=triageID;
        //});
        this.powerSupplyService.updatePowerSupplySfpTriage(res1).subscribe(result => {
        });
      }
      });
    }else{
      this.powerSupplyService.getPowerSupplySfpTriageByPsId(this.powerSupplyId,null).subscribe(res1 => {
        if (res1 && res1.id != null) {
        //res1.forEach(element => {
          res1.triageId=triageID;
        //});
        this.powerSupplyService.updatePowerSupplySfpTriage(res1).subscribe(result => {
        });
      }
      });
    }

  }


  saveworkitemsTriage(triageID) {
    this.powerSupplyService.getTriageWorkItemsBYPsCertID(this.certId, this.powerSupplyId, null).subscribe(res => {
      if (res == null) {
        this.powerSupplyService.getTriageWorkItemsBYPsCertID(this.certId, this.powerSupplyId, triageID).subscribe(res1 => {
          res = res1;
          res.forEach(element => {
            element.triageId = triageID;
          });
          this.powerSupplyService.updateTriageIDWorkItem(res).subscribe(result => {
          });
        });
      } else {
        res.forEach(element => {
          element.triageId = triageID;
        });
        this.powerSupplyService.updateTriageIDWorkItem(res).subscribe(result => {
        });
      }
    });

    this.powerSupplyService.getTriageMaterialItemsBYPsCertID(this.certId, this.powerSupplyId, null).subscribe(resmat => {
      if (resmat == null) {
        this.powerSupplyService.getTriageMaterialItemsBYPsCertID(this.certId, this.powerSupplyId, triageID).subscribe(res1mat => {
          resmat = res1mat;
          resmat.forEach(element => {
            element.triageId = triageID;
          });
          this.powerSupplyService.updateTriageMaterialItem(resmat).subscribe(result => {
          });
        });

      } else {
        resmat.forEach(element => {
          element.triageId = triageID;
        });
        this.powerSupplyService.updateTriageMaterialItem(resmat).subscribe(result => {
        });
      }
    });
  }
//some additinal fields for save certification
saveCertification(powerSupply) {
  const powerSupplyCertificationsReqResponse : PowerSupplyCertificationsReqResponse = {};
  const certPowerSupply: PowerSupplyCertifications = {};
  const apuCertifications: ApuCertifications = {};
  const apuShowVisitCertifications: ApuShowVisitCertifications = {};
  const powerSupplyCertsAlarm: PowerSupplyCertsAlarm = {};
  const powerSupplyCertsTelemetryConfig: PowerSupplyCertsTelemetryConfig = {};
  certPowerSupply.psCertificationId = this.certId;
  if(powerSupply.inspectionDate == this.certInsPDate){
    this.insFlag = false;
    certPowerSupply.certificationDate = this.certCertDate;
  }else{
    this.insFlag = true;
    certPowerSupply.certificationDate = new Date().toISOString();
  }
  // if(this.certtechnicianName == null || this.certtechnicianName == undefined){
  //   certPowerSupply.technicianName = this.userName;
  // }else{
  //   certPowerSupply.technicianName = this.certtechnicianName;
  // }

  if((this.certtechnicianName == null || this.certtechnicianName == undefined) || this.insFlag){
    certPowerSupply.technicianName = this.userName.toUpperCase();
  }else{
    //when there is active certificate and no change in certification
    certPowerSupply.technicianName = this.certtechnicianName.toUpperCase();
  }

  //certPowerSupply.certificationDate = new Date().toISOString();
  //certPowerSupply.photoUploadedDate = new Date().toISOString();
  //certPowerSupply.technicianName = this.userName;
  certPowerSupply.technicianNtUserName = this.userName;
  certPowerSupply.technicianNumber = (this.lastVisitInfoForm.value.mobileno)?this.lastVisitInfoForm.value.mobileno:null;
  certPowerSupply.submittedBy = powerSupply.logName;
  certPowerSupply.powerSupplyId = powerSupply.powerSupplyId;
  certPowerSupply.powerSupplyName = powerSupply.powerSupplyName;



  certPowerSupply.houseNumber = powerSupply.houseNumber;
  certPowerSupply.powerSupplyAddress = powerSupply.powerSupplyAddress;
  //certPowerSupply.streetNumber = powerSupply.powerSupplyAddress;
  certPowerSupply.crossStreet = powerSupply.crossStreet;
  certPowerSupply.city = powerSupply.city;
  certPowerSupply.state = powerSupply.state;
  certPowerSupply.zip = powerSupply.zip;
  certPowerSupply.feedsMultipleNodes = powerSupply.feedsMultipleNodes;
  certPowerSupply.gpsLatitude = powerSupply.gpsLatitude;
  certPowerSupply.gpsLongitude = powerSupply.gpsLongitude;
  certPowerSupply.powersNode = powerSupply.powersNode;
  certPowerSupply.specialLocationDetails = powerSupply.specialLocationDetails;
  certPowerSupply.powerAccountType = powerSupply.powerAccountType;
  certPowerSupply.aerialUnderground = powerSupply.aerialUnderground;
  certPowerSupply.poleNumber = powerSupply.poleNumber;
  certPowerSupply.utilityProvider = powerSupply.utilityProvider;
  certPowerSupply.companyAccountNumber = powerSupply.companyAccountNumber;
  certPowerSupply.powerCompanyContactNumber = powerSupply.powerCompanyContactNumber;
  certPowerSupply.powerCompanyWebsite = powerSupply.powerCompanyWebsite;
  certPowerSupply.nwtTeam = powerSupply.nwtTeam;
  certPowerSupply.nitroReasonNotCompleted = powerSupply.nitroReasonNotCompleted;
  certPowerSupply.nitroCompletionDate = powerSupply.nitroCompletionDate;
  certPowerSupply.electricMeterNumber =  powerSupply.electricMeterNumber
  certPowerSupply.mapNumber = powerSupply.mapNumber;
  certPowerSupply.businessPartnerRestriction = powerSupply.businessPartnerRestriction;
  certPowerSupply.locationComments = powerSupply.locationComments;


  //Transponder Info
  certPowerSupply.powerSupplyType = powerSupply.powerSupplyType;
  certPowerSupply.standByOperation = this.transponderInfoForm.value.standByOpts;
  certPowerSupply.macAddress = powerSupply.macAddress;
  certPowerSupply.macAddressPrevious = powerSupply.macAddressPrevious;
  certPowerSupply.ip = powerSupply.ip;
  certPowerSupply.powerSupplyNumber = powerSupply.powerSupplyNumber;
  certPowerSupply.transponderVendor = powerSupply.transponderVendor;
  certPowerSupply.transponderModel = powerSupply.transponderModel;
  //certPowerSupply.powerSupplyVendor = powerSupply.transponderVendor;
  certPowerSupply.powerSupplyModel = powerSupply.powerSupplyModel;
  certPowerSupply.acInputVoltage = powerSupply.acInputVoltage;
  certPowerSupply.outputVoltage = powerSupply.outputVoltage;
  certPowerSupply.inputCurrent = powerSupply.inputCurrent;
  //certPowerSupply.currentAmpOutput = powerSupply.currentAmpOutput;
  certPowerSupply.serialNumber = powerSupply.serialNumber;
  // certPowerSupply.controllerCardType = powerSupply.controllerCardType;
  certPowerSupply.dcReady = powerSupply.dcReady;
  certPowerSupply.priority = powerSupply.priority;
  certPowerSupply.egisName = powerSupply.egisName;
  certPowerSupply.externalSensor = powerSupply.externalSensor;
  certPowerSupply.globalId = this.transponderInfoForm.controls['globalidentifier'].value;
  certPowerSupply.transponderComments = powerSupply.transponderComments;
  if (this.transponderInfoForm.value.powerSupplyType9360 !== null && this.transponderInfoForm.value.powerSupplyType9360 !== undefined) {
    certPowerSupply.powerSupplyType9360 = powerSupply.powerSupplyType9360;
  }


  //BatteryInfo
  certPowerSupply.numberOfBatteries = powerSupply.numberOfBatteries;
  certPowerSupply.batteriesReplaced = powerSupply.batteriesReplaced;
  //certPowerSupply.airTemperature = powerSupply.airTemperature;
  certPowerSupply.batteryBalancerString = powerSupply.batteryBalancerString;

  let preArray: any = [];
  let battArray: Array<number> = [];
  let k = 0;
  for (let i = 0; i < this.batteryStringForms.length; i++) {
    if (i == 0) {
      //certPowerSupply.batteryBalancerString1 = this.batteryStringForms.value[0].batteryManagerModel;
      //certPowerSupply.batterySeparatorPresent14 = this.batteryStringForms.value[0].batterySeparator;
    } else if (i == 1) {
      //certPowerSupply.batteryBalancerString2 = this.batteryStringForms.value[0].batteryManagerModel;
      //certPowerSupply.batterySeparatorPresent24 = this.batteryStringForms.value[0].batterySeparator;
    } else if (i == 2) {
      //certPowerSupply.batteryBalancerString3 = this.batteryStringForms.value[0].batteryManagerModel;
      //certPowerSupply.batterySeparatorPresent34 = this.batteryStringForms.value[0].batterySeparator;
    } else if (i == 3) {
      //certPowerSupply.batteryBalancerString4 = this.batteryStringForms.value[0].batteryManagerModel;
      //certPowerSupply.batterySeparatorPresent44 = this.batteryStringForms.value[0].batterySeparator;
    } else if (i == 4) {
      //certPowerSupply.batteryBalancerString5 = this.batteryStringForms.value[0].batteryManagerModel;
      //certPowerSupply.batterySeparatorPresent54 = this.batteryStringForms.value[0].batterySeparator;
    } else if (i == 5) {
      //certPowerSupply.batteryBalancerString6 = this.batteryStringForms.value[0].batteryManagerModel;
      //certPowerSupply.batterySeparatorPresent64 = this.batteryStringForms.value[0].batterySeparator;
    }
  }
  for (let i = 0; i < this.prvString; i++) {
    for (let j = 0; j < this.prvBattery; j++)
      preArray.push(i + '' + j)
  }
   //Logic for Parallel Batteries for Create PS
    let battStringCount = 1;
    let parallelBattsInString = 6;
    if (this.parallelBatt) {
      for (let i = 0; i < battStringCount; i++) {
        for (let j = 0; j < parallelBattsInString; j++) {
          if (preArray.includes(i + '' + j)) {
            battArray.push(1);
          }
          else battArray.push(0);
        }
      }
      if (battArray[0] == 1) {
        certPowerSupply.type11 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial11 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate11 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage11 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload11 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance11 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected11 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString11 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate11 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[1] == 1) {
        certPowerSupply.type12 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial12 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate12 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage12 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload12 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance12 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected12 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString12 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate12 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[2] == 1) {
        certPowerSupply.type13 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial13 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate13 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage13 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload13 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance13 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected13 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate13 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[3] == 1) {
        certPowerSupply.type14 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial14 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate14 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage14 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload14 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance14 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected14 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate14 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[4] == 1) {
        certPowerSupply.type15 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial15 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate15 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage15 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload15 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance15 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected15 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        //powerSupply.totalVoltageString15 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate15 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[5] == 1) {
        certPowerSupply.type16 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial16 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate16 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage16 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload16 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance16 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected16 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        //powerSupply.totalVoltageString16 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate16 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }

    } else {
      for (let i = 0; i < 6; i++) {
        for (let j = 0; j < 4; j++) {
          if (preArray.includes(i + '' + j)) {
            battArray.push(1);
          }
          else battArray.push(0);
        }
      }

      if (battArray[0] == 1) {
        certPowerSupply.type11 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial11 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate11 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage11 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload11 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance11 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected11 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString11 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate11 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[1] == 1) {
        certPowerSupply.type12 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial12 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate12 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage12 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload12 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance12 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected12 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString12 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate12 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[2] == 1) {
        certPowerSupply.type13 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial13 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate13 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage13 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload13 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance13 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected13 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate13 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[3] == 1) {
        certPowerSupply.type14 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial14 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate14 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage14 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload14 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance14 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected14 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate14 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[4] == 1) {
        certPowerSupply.type21 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial21 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate21 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage21 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload21 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance21 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected21 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString21 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate21 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[5] == 1) {
        certPowerSupply.type22 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial22 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate22 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage22 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload22 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance22 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected22 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString22 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate22 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[6] == 1) {
        certPowerSupply.type23 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial23 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate23 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage23 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload23 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance23 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected23 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate23 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[7] == 1) {
        certPowerSupply.type24 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial24 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate24 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage24 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload24 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance24 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected24 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate24 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[8] == 1) {
        certPowerSupply.type31 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial31 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate31 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage31 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload31 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance31 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected31 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString31 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate31 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[9] == 1) {
        certPowerSupply.type32 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial32 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate32 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage32 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload32 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance32 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected32 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString32 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate32 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[10] == 1) {
        certPowerSupply.type33 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial33 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate33 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage33 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload33 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance33 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected33 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate33 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[11] == 1) {
        certPowerSupply.type34 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial34 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate34 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage34 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload34 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance34 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected34 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate34 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[12] == 1) {
        certPowerSupply.type41 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial41 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate41 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage41 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload41 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance41 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected41 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString41 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate41 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[13] == 1) {
        certPowerSupply.type42 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial42 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate42 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage42 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload42 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance42 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected42 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString42 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate42 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[14] == 1) {
        certPowerSupply.type43 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial43 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate43 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage43 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload43 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance43 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected43 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate43 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[15] == 1) {
        certPowerSupply.type44 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial44 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate44 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage44 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload44 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance44 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected44 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate44 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }

      if (battArray[16] == 1) {
        certPowerSupply.type51 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial51 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate51 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage51 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload51 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance51 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected51 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString51 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate51 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[17] == 1) {
        certPowerSupply.type52 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial52 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate52 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage52 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload52 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance52 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected52 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString52 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate52 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[18] == 1) {
        certPowerSupply.type53 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial53 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate53 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage53 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload53 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance53 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected53 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString53 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate53 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[19] == 1) {
        certPowerSupply.type54 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial54 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate54 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage54 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload54 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance54 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected54 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString54 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate54 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[20] == 1) {
        certPowerSupply.type61 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial61 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate61 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage61 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload61 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance61 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected61 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString61 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate61 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[21] == 1) {
        certPowerSupply.type62 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial62 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate62 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage62 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload62 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance62 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected62 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString62 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate62 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[22] == 1) {
        certPowerSupply.type63 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial63 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate63 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage63 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload63 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance63 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected63 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString63 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate63 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
      if (battArray[23] == 1) {
        certPowerSupply.type64 = this.batteryBatteryForms.value[k].batteryManufacturer;
        certPowerSupply.batterySerial64 = this.batteryBatteryForms.value[k].batterySerial;
        certPowerSupply.manufactureDate64 = this.batteryBatteryForms.value[k].batteryCode;
        certPowerSupply.voltage64 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
        certPowerSupply.batteryVoltageUnderload64 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
        certPowerSupply.batteryConductance64 = this.batteryBatteryForms.value[k].batteryConductance;
        certPowerSupply.batteryConductanceCorrected64 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
        certPowerSupply.totalVoltageString64 = this.batteryBatteryForms.value[k].totalVoltage;
        if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
          const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
          certPowerSupply.installDate64 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }
        k++;
      }
    }
  certPowerSupply.batteryComments = powerSupply.batteryComments;

  //LastVistInfo
  certPowerSupply.inspectionDate = powerSupply.inspectionDate;
  certPowerSupply.typeOfVisit = powerSupply.typeOfVisit;
  certPowerSupply.visitStatus = powerSupply.visitStatus;
  certPowerSupply.followUpReason = powerSupply.followUpReason;
  certPowerSupply.xocVerified = powerSupply.xocVerified;
  certPowerSupply.cleanEnclosure = powerSupply.cleanEnclosure;
  certPowerSupply.tightenHardware = powerSupply.tightenHardware;
  certPowerSupply.inspectConnectors = powerSupply.inspectConnectors;
  certPowerSupply.inspectProbes = powerSupply.inspectProbes ;
  certPowerSupply.meterPanCondition = powerSupply.meterPanCondition;
  certPowerSupply.powerCoRiserCondition = powerSupply.powerCoRiserCondition;
  certPowerSupply.batteryHeaterMatType = powerSupply.batteryHeaterMatType;
  certPowerSupply.batteryHeaterMatQuantity = powerSupply.batteryHeaterMatQuantity;
  certPowerSupply.enclosureSnowShield = powerSupply.enclosureSnowShield;
  certPowerSupply.internalBreaker = powerSupply.internalBreaker;
  certPowerSupply.serviceEntrance = powerSupply.serviceEntrance;
  certPowerSupply.receptacleType = powerSupply.receptacleType;
  certPowerSupply.checkSeizureAltBox = powerSupply.checkSeizureAltBox;
  certPowerSupply.powerSupplyIdLegible = powerSupply.powerSupplyIdLegible;
  certPowerSupply.checkLampsLeds = powerSupply.checkLampsLeds;
  certPowerSupply.checkMagneticBreaker = powerSupply.checkMagneticBreaker;
  certPowerSupply.visualCabinetInspection = powerSupply.visualCabinetInspection;
  certPowerSupply.cabinetLocked = powerSupply.cabinetLocked;
  certPowerSupply.securityBarPresent = powerSupply.securityBarPresent;
  certPowerSupply.checkGroundCabinet =  powerSupply.checkGroundCabinet;
  certPowerSupply.batteryString1Fused = powerSupply.batteryString1Fused;
  certPowerSupply.batteryString2Fused = powerSupply.batteryString2Fused;
  certPowerSupply.batteryString3Fused = powerSupply.batteryString3Fused;
  certPowerSupply.batteryString4Fused = powerSupply.batteryString4Fused;
  certPowerSupply.batteryString5Fused = powerSupply.batteryString5Fused;
  certPowerSupply.batteryString6Fused = powerSupply.batteryString6Fused;
  certPowerSupply.tamperInstalledFunctioning = powerSupply.tamperInstalledFunctioning;
  certPowerSupply.checkLaps = powerSupply.checkLaps;
  certPowerSupply.cabinetVendor = powerSupply.cabinetVendor;
  certPowerSupply.cabinetBatteryCapacity = powerSupply.cabinetBatteryCapacity;
  certPowerSupply.checkOperatingLights = powerSupply.checkOperatingLights;
  certPowerSupply.followUpNeeded = powerSupply.followUpNeeded;
  certPowerSupply.inputSurgeArrestor = powerSupply.inputSurgeArrestor;
  certPowerSupply.outputSurgeArrestor = powerSupply.outputSurgeArrestor;
  certPowerSupply.coaxTvssPresent = powerSupply.coaxTvssPresent;
  certPowerSupply.acIndicatorGreenLight = powerSupply.acIndicatorGreenLight;
  certPowerSupply.localRemoteIndicator = powerSupply.localRemoteIndicator;
  certPowerSupply.comments = powerSupply.comments;


certPowerSupply.nodesServed = powerSupply.nodesServed;
certPowerSupply.logNt = this.authService.getUserDetails.userName;
certPowerSupply.logName = this.authService.getUserDetails.lastName + ', ' + this.authService.getUserDetails.firstName;
certPowerSupply.logDate = new Date().toISOString();
certPowerSupply.temperature = powerSupply.temperature;
certPowerSupply.alertProfile = powerSupply.alertProfile;
certPowerSupply.sysLocation = powerSupply.sysLocation;
certPowerSupply.sysContact = powerSupply.sysContact;


certPowerSupply.psAlertProfile = powerSupply.psAlertProfile;
certPowerSupply.alertProfileException = powerSupply.alertProfileException;
certPowerSupply.powerSupplyType9360 = powerSupply.powerSupplyType9360;
certPowerSupply.calculatedRuntime = this.calcRuntime;

 certPowerSupply.nextGenNode = powerSupply.nextGenNode;
 certPowerSupply.prevNodeServed = powerSupply.prevNodeServed;

 certPowerSupply.powerAccountType = powerSupply.powerAccountType;
 certPowerSupply.visitStatus = this.lastVisitInfoForm.value.visitStatus;
 certPowerSupply.followUpReason = powerSupply.followUpReason;


  certPowerSupply.status = this.status;
  certPowerSupply.testDuration = this.testduration;
  certPowerSupply.testStartDate = this.teststartdate;
  certPowerSupply.testEndDate = this.testenddate;

 if(powerSupply.powerSupplyType == 'Built In Generator'){
//APU certification
apuCertifications.apuId = (this.certData && this.certData.apuCertifications)?this.certData.apuCertifications.apuId:null;
apuCertifications.powerSupplyId = powerSupply.powerSupplyId;
apuCertifications.psCertificationId = this.certId;
apuCertifications.apuMakeModel = this.apuFormGroup.value.apuMakeModel;
apuCertifications.apuSerialNumber = this.apuFormGroup.value.apuSerialNumber;
apuCertifications.apuDeviceId = this.apuFormGroup.value.apuDeviceId;
apuCertifications.apuRunTime = this.apuFormGroup.value.apuRunTime;
apuCertifications.ecmAcm = this.apuFormGroup.value.ecmAcm;
apuCertifications.dateApuInstalled =  this.apuFormGroup.value.dateApuInstalled;
apuCertifications.apuOutputVoltageRating = this.apuFormGroup.value.apuOpVltgRating;
apuCertifications.apuNoLoadVoltage = this.apuFormGroup.value.apuNoLoadVltg;
apuCertifications.apuLoadVoltage = this.apuFormGroup.value.apuLoadVltg
apuCertifications.apuEnclosureMake = this.apuFormGroup.value.apuEnclosure;
apuCertifications.ngLp = this.apuFormGroup.value.ngLp;
apuCertifications.ngProvider = this.apuFormGroup.value.ngProvider;
apuCertifications.lpTankCapacity = this.apuFormGroup.value.lpTankCapacity;
apuCertifications.numberTanksInstalled = this.apuFormGroup.value.noOfTanksInstalled;
apuCertifications.lastUpdatedBy = this.userName;
apuCertifications.lastUpdated = new Date().toISOString();

//Apu show visit
apuShowVisitCertifications.id = (this.certData && this.certData.apuShowVisitCertifications)?this.certData.apuShowVisitCertifications.id : null;
apuShowVisitCertifications.psCertificationId = this.certId;
apuShowVisitCertifications.powerSupplyId = powerSupply.powerSupplyId;
apuShowVisitCertifications.inspectionDate =  this.apuVisitFormGroup.value.apuinspectionDate;
apuShowVisitCertifications.apuCompletedBy = this.apuVisitFormGroup.value.apuVisitedTech;
apuShowVisitCertifications.apuBatteryManufacturerType = this.apuVisitFormGroup.value.apuBatteryManuType;
apuShowVisitCertifications.apuBatteryDateCode = this.apuVisitFormGroup.value.apuBatteryDateCode;
apuShowVisitCertifications.apuBatteryInstallDate = this.apuVisitFormGroup.value.apuBatteryInstallDate;
apuShowVisitCertifications.apuBatteryVoltageNoLoad = this.apuVisitFormGroup.value.apuBatteryVltgNoLoad;
apuShowVisitCertifications.apuBatteryConductance = this.apuVisitFormGroup.value.apuBatteryConductance;
apuShowVisitCertifications.apuBatteryConductanceCrrctd = this.apuVisitFormGroup.value.apuBatteryCon77deg;
apuShowVisitCertifications.apuBatteryTorque = this.apuVisitFormGroup.value.apuBatteryTorque;
apuShowVisitCertifications.apuBatteryTerminalsCleaned = this.apuVisitFormGroup.value.apuBatteryTerminals;
apuShowVisitCertifications.apuStarterBatteryChrgrVlt = this.apuVisitFormGroup.value.apuStarter;
apuShowVisitCertifications.apuChargerCurrentAmps = this.apuVisitFormGroup.value.apuCharger;
apuShowVisitCertifications.followUpActionNeeded = this.apuVisitFormGroup.value.followup;
apuShowVisitCertifications.recordAsFoundAlarms = this.apuVisitFormGroup.value.recordAsFoundAlarms;
apuShowVisitCertifications.apuTestRun = this.apuVisitFormGroup.value.apuTestRun;
apuShowVisitCertifications.checkOilLevel = this.apuVisitFormGroup.value.checkOilLevel;
apuShowVisitCertifications.oilAddedAmount = this.apuVisitFormGroup.value.ifOilAdded;
apuShowVisitCertifications.oilFilterTight = this.apuVisitFormGroup.value.oilFilterTight;
apuShowVisitCertifications.inspectGeneratorAirFilter = this.apuVisitFormGroup.value.inspectGenerator;
apuShowVisitCertifications.inspectSparkPlug = this.apuVisitFormGroup.value.inspectSparkPlug;
apuShowVisitCertifications.clearApuEventLog = this.apuVisitFormGroup.value.clearApuEventlog;
apuShowVisitCertifications.apuFrequency = this.apuVisitFormGroup.value.apuFrequency;
apuShowVisitCertifications.tankOneLevel = this.apuVisitFormGroup.value.tank1;
apuShowVisitCertifications.tankTwoLevel = this.apuVisitFormGroup.value.tank2;
apuShowVisitCertifications.gasMeterNumber = this.apuVisitFormGroup.value.gasMeter;
apuShowVisitCertifications.gasMeterReading = this.apuVisitFormGroup.value.gasMeterReading;
apuShowVisitCertifications.ngPressure = this.apuVisitFormGroup.value.ngPressure;
apuShowVisitCertifications.changeCleanenClosureAirFilter = this.apuVisitFormGroup.value.airFilter;
apuShowVisitCertifications.checkForRodentDamage = this.apuVisitFormGroup.value.rodentInsectDamage;
apuShowVisitCertifications.checkLampsLed = this.apuVisitFormGroup.value.checkLamps;
apuShowVisitCertifications.clearWeeds = this.apuVisitFormGroup.value.clearWeeds;
apuShowVisitCertifications.checkRegroutPadConduit = this.apuVisitFormGroup.value.checkRegrout;
apuShowVisitCertifications.groundMountPadUndermining = this.apuVisitFormGroup.value.ifGroundMount;
apuShowVisitCertifications.enclosureDamageVandalism = this.apuVisitFormGroup.value.anyEnclosure;
apuShowVisitCertifications.cleanupGarbage = this.apuVisitFormGroup.value.cleanUpGarbage;
apuShowVisitCertifications.testOilPressureAlarm = this.apuVisitFormGroup.value.testOilPressure;
apuShowVisitCertifications.testHighTempAlarm = this.apuVisitFormGroup.value.testhighTemp;
apuShowVisitCertifications.generatorDcBusFunction = this.apuVisitFormGroup.value.generatorDcBus;
apuShowVisitCertifications.checkForGasLeaks = this.apuVisitFormGroup.value.checkForGas;
apuShowVisitCertifications.testCombustibleGasAlarm = this.apuVisitFormGroup.value.testCombustible;
apuShowVisitCertifications.testTamperAlarm = this.apuVisitFormGroup.value.testTamper;
apuShowVisitCertifications.testWaterIntrusionAlarm = this.apuVisitFormGroup.value.testWaterIntrusion;
apuShowVisitCertifications.testPadShearAlarm = this.apuVisitFormGroup.value.testPad;
apuShowVisitCertifications.apuVisitComments = this.apuVisitFormGroup.value.comments;
apuShowVisitCertifications.lastUpdatedBy = this.userName;
apuShowVisitCertifications.lastUpdated = new Date().toISOString();
}

//powersupply certs Alaram
powerSupplyCertsAlarm.id = (this.certData && this.certData.powerSupplyCertsAlarm)?this.certData.powerSupplyCertsAlarm.id : null;
powerSupplyCertsAlarm.powerSupplyId = this.powerSupplyId;
powerSupplyCertsAlarm.psCertificationId = this.certId;
powerSupplyCertsAlarm.mac = powerSupply.macAddress;
powerSupplyCertsAlarm.psName =  powerSupply.powerSupplyName;
powerSupplyCertsAlarm.alertLevel =  '';

//certs telemetry config
powerSupplyCertsTelemetryConfig.id =  (this.certData && this.certData.certsTelemetryConfig)?this.certData.certsTelemetryConfig.id : null;
powerSupplyCertsTelemetryConfig.powerSupplyId = powerSupply.powerSupplyId;
powerSupplyCertsTelemetryConfig.psCertificationId = this.certId;
powerSupplyCertsTelemetryConfig.mac = powerSupply.macAddress;
powerSupplyCertsTelemetryConfig.swRev = '';
powerSupplyCertsTelemetryConfig.hwRev = '';
powerSupplyCertsTelemetryConfig.bootFile = '';
powerSupplyCertsTelemetryConfig.configFile = '';
powerSupplyCertsTelemetryConfig.sysDescr = '';
powerSupplyCertsTelemetryConfig.bootR = '';
powerSupplyCertsTelemetryConfig.sysName = '';


let apuCert:ApuCertifications = null;
let apuSVCert:ApuShowVisitCertifications = null;
powerSupplyCertificationsReqResponse.powerSupplyCertifications = certPowerSupply;
powerSupplyCertificationsReqResponse.apuCertifications =  (apuCertifications!= null && apuCertifications.psCertificationId != null)?apuCertifications:apuCert;
powerSupplyCertificationsReqResponse.apuShowVisitCertifications =   (apuShowVisitCertifications != null && apuShowVisitCertifications.psCertificationId != null)?apuShowVisitCertifications:apuSVCert;
powerSupplyCertificationsReqResponse.powerSupplyCertsAlarm = powerSupplyCertsAlarm;
powerSupplyCertificationsReqResponse.certsTelemetryConfig = powerSupplyCertsTelemetryConfig;

  this.powerSupplyService.savePSCertificate(powerSupplyCertificationsReqResponse)
  .subscribe(result => {
    if (result.success === true) {
      const activity = 'PowerSupply Edit Save';
      const message = `PowerSupply Edit Save Success. MAC Address: ${this.macAddress}`;
      this.commonService.loggerPost(message, activity, 3);
      this.showApu = true;
      this.inbuiltValue = true;
    } else {
      const activity = 'PowerSupply Edit Save - Error';
      const message = `PowerSupply Edit Save Error. Error: ${result.message}. MAC Address: ${this.macAddress}`;
      this.commonService.loggerPost(message, activity, 5);
    }
  }, err => {
    this.showProgressBar = false;
    this.openErrorDialog("Something went wrong. Please try later !!");
  });
}
  apuVisitFormGroupValidation(){
    this.apuVisitFormGroup.controls["apuinspectionDate"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuinspectionDate"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuVisitedTech"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuVisitedTech"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuBatteryManuType"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuBatteryManuType"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuBatteryDateCode"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuBatteryDateCode"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuBatteryInstallDate"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuBatteryInstallDate"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuBatteryVltgNoLoad"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuBatteryVltgNoLoad"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuBatteryConductance"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuBatteryConductance"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuBatteryCon77deg"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuBatteryCon77deg"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuBatteryTorque"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuBatteryTorque"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuBatteryTerminals"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuBatteryTerminals"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuStarter"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuStarter"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuCharger"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuCharger"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["followup"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["followup"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["recordAsFoundAlarms"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["recordAsFoundAlarms"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuTestRun"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuTestRun"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["checkOilLevel"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["checkOilLevel"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["ifOilAdded"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["ifOilAdded"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["oilFilterTight"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["oilFilterTight"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["inspectGenerator"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["inspectGenerator"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["inspectSparkPlug"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["inspectSparkPlug"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["clearApuEventlog"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["clearApuEventlog"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["apuFrequency"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["apuFrequency"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["tank1"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["tank1"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["tank2"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["tank2"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["gasMeter"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["gasMeter"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["gasMeterReading"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["gasMeterReading"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["ngPressure"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["ngPressure"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["airFilter"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["airFilter"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["rodentInsectDamage"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["rodentInsectDamage"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["checkLamps"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["checkLamps"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["clearWeeds"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["clearWeeds"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["checkRegrout"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["checkRegrout"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["ifGroundMount"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["ifGroundMount"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["anyEnclosure"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["anyEnclosure"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["cleanUpGarbage"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["cleanUpGarbage"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["testOilPressure"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["testOilPressure"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["testhighTemp"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["testhighTemp"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["generatorDcBus"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["generatorDcBus"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["checkForGas"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["checkForGas"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["testCombustible"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["testCombustible"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["testTamper"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["testTamper"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["testWaterIntrusion"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["testWaterIntrusion"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["testPad"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["testPad"].updateValueAndValidity();
    this.apuVisitFormGroup.controls["comments"].setValidators(Validators.required);
    this.apuVisitFormGroup.controls["comments"].updateValueAndValidity();
    this.markAsTouched(this.apuVisitFormGroup);
    this.lastVisitInfoFormValidation();
  }
  clearValidationOnChange(){
  //   for (let i = 0; i < (<FormArray>this.batteryStringForms).length; i++) {
  //   if(i == 0){
  //   }else if (i == 1) {
  //     const batteryManufacturer = <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer.clearValidators();
  //     batteryManufacturer.updateValueAndValidity();
  //   }else if (i == 2) {
  //     const batteryManufacturer1 = <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer1.clearValidators();
  //     batteryManufacturer1.updateValueAndValidity();
  //   }else if (i == 3) {
  //     const batteryManufacturer2= <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer2.clearValidators();
  //     batteryManufacturer2.updateValueAndValidity();
  //   }else if (i == 4) {
  //     const batteryManufacturer3 = <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer3.clearValidators();
  //     batteryManufacturer3.updateValueAndValidity();
  //   }else if (i == 5) {
  //     const batteryManufacturer4 = <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer4.clearValidators();
  //     batteryManufacturer4.updateValueAndValidity();
  // }
  // }
}

  onChangevisit(){
    let event = this.lastVisitInfoForm.value.typeOfVisit;
    if (event && event.indexOf('Cert Required') !== -1) {
      this.lastVisitInfoForm.controls['followUpReasons'].patchValue('N/A');
      this.followUpActionData = 'N/A';
    }else{
      this.followUpActionData = '';
    }
  }

  public onUserSelectVisitType(): void {
    const currentDate: Date = new Date();
    const year: number = currentDate.getFullYear();
    const month: string = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day: string = String(currentDate.getDate()).padStart(2, '0');
    this.psCreationDate = `${year}-${month}-${day}`;
    this.onChangevisitType();
  }

  onChangevisitType() {
    let event = this.lastVisitInfoForm.value.typeOfVisit;
    let standby = this.transponderInfoForm.value.standByOpts;
    if(event == '' || event == undefined || event == null){
      setTimeout(() => {
        this.lastVisitInfoForm.controls["typeOfVisit"].setValidators(Validators.required);
        this.lastVisitInfoForm.controls["typeOfVisit"].updateValueAndValidity();
      });
      if (this.isCheckedCheck || !this.isCheckedCheck) {
        //this.disableSaveButton = true;
      }
    }

    //check the value is having Cert Required or not
    if(event && event.indexOf('Cert Required') !== -1){
      const certificationDate: Date = new Date(this.psCreationDate);
      const isInvalidDate: boolean =
        isUndefinedOrNullOrEmpty(this.psCreationDate) ||
        isNaN(certificationDate.getTime());
      if (isInvalidDate || certificationDate > this.compareDateForCertification) {
        // Prevent duplicate mandatory image check/dialog
        if (/Inhouse/.test(event) && /Cert Required/.test(event)) {
          this.vm.mandatoryImageInHouseCertification = true;
          if (!this.vm.mandatoryImageCheckInProgress) {
            this.vm.mandatoryImageCheckInProgress = true;
            // Check if all mandatory images are available for this power supply
            this.powerSupplyService.getPsnbSdsImageDetailByPsId(this.getPowerSupplyId)
              .pipe(take(1))
              .subscribe((images: PowerSupplyImageMetaData[]): void => {
                const missingMandatory: boolean = this.mandatoryImageCategoryIds.some(
                  (id: number): boolean =>
                    !images.some(
                      (img: PowerSupplyImageMetaData): boolean =>
                        Number(img.category) === id
                    )
                );
                if (missingMandatory) {
                  this.vm.mandatoryImagesMissing = true;
                  this.openDialog('Some mandatory images are missing. Please upload all required images.');
                } else {
                  this.vm.mandatoryImagesMissing = false;
                }
                this.vm.mandatoryImageCheckInProgress = false;
                this.ref.detectChanges();
              }, (): void => {
                this.vm.mandatoryImageCheckInProgress = false;
              });
            this.ref.detectChanges();
          }
        } else {
          this.vm.mandatoryImageInHouseCertification = false;
          this.vm.mandatoryImagesMissing = false;
          this.ref.detectChanges();
        }
      }
      this.certRequiredValue = true;
      if(this.psData.checkSeizureAltBox === 'Ok' && this.psData.powerCoRiserCondition === 'Good' && this.psData.checkMagneticBreaker === 'Ok' &&
      this.psData.checkLaps === 'Ok' && this.psData.visualCabinetInspection === 'Ok' && this.psData.inspectConnectors === 'Yes' &&
      this.psData.checkLampsLeds === 'Ok' && this.psData.inspectProbes === 'Yes' && this.psData.xocVerified === 'Yes'
      && this.psData.checkOperatingLights === 'Ok'  && this.psData.acIndicatorGreenLight === 'Ok'
      && this.psData.serviceEntrance === null && this.psData.powerSupplyIdLegible === 'Yes'  && this.psData.localRemoteIndicator === 'Yes'){
        this.isCheckedCheck = true;
        setTimeout(() => {
          this.lastVisitInfoForm.controls["checkAll"].clearValidators();
          this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
        });
        this.ref.detectChanges()
        this.SaveFlag = true;
      }else{
        // setTimeout(() => {
        //   this.lastVisitInfoForm.controls["checkAll"].setValidators(Validators.required);
        //   this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
        // });
        // this.ref.detectChanges()
        // this.isCheckedCheck = false;
        setTimeout(() => {
          this.lastVisitInfoForm.controls["checkAll"].setValidators(Validators.required);
          this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
        });
        this.isCheckedCheck = false;
        //this.disableSaveButton = false;
        this.SaveFlag = false;
        let event = this.psData.typeOfVisit;
        if (event && event.indexOf('Cert Required') !== -1) {
          //cert required
          //this.disableSaveButton = true;
          this.SaveFlag = true;
        }
        else {
          //cert not required or empty case
          //this.disableSaveButton = false;
          this.SaveFlag = false;
        }
      }
      if(this.lastVisitInfoForm.controls['inspectionDate'].value == null){
        this.lastVisitInfoForm.controls['inspectionDate'].setValue(new Date());
        this.insFlag =true;
      }
      // this.refresh();
     }else{
      this.vm.mandatoryImageInHouseCertification = false;
      this.vm.mandatoryImagesMissing = false;
      this.ref.detectChanges();
      if (this.psData.checkSeizureAltBox === 'Ok' && this.psData.powerCoRiserCondition === 'Good' && this.psData.checkMagneticBreaker === 'Ok' &&
        this.psData.checkLaps === 'Ok' && this.psData.visualCabinetInspection === 'Ok' && this.psData.inspectConnectors === 'Yes' &&
        this.psData.checkLampsLeds === 'Ok' && this.psData.inspectProbes === 'Yes' && this.psData.xocVerified === 'Yes'
        && this.psData.checkOperatingLights === 'Ok' && this.psData.acIndicatorGreenLight === 'Ok'
        && this.psData.serviceEntrance === null && this.psData.powerSupplyIdLegible === 'Yes' && this.psData.localRemoteIndicator === 'Yes') {
        this.isCheckedCheck = true;
        this.SaveFlag = true;
        this.certRequiredValue = false;
      } else {
        this.SaveFlag = false;
        this.isCheckedCheck = false;
        this.certRequiredValue = false;
      }
      this.lastVisitInfoForm.controls['inspectionDate'].setValue(this.insDate);
      // if(this.interval) clearInterval(this.interval)
     }

    // if ((event == 'Preventive Maintenance/Certification (Cert Required)' ||
    // event == 'Device Upgrade (Cert Required)' ||
    // event == 'Alarm (Cert Required)' ||
    // event == 'Other (Cert Required)' ||
    // event == 'Return Visit')) {
    if(this.certRequiredValue || event == 'Return Visit' ){
      this.certificateFlag = true;
      if(this.insFlag){
        //if inspection date is changes
        var selectedDate = this.lastVisitInfoForm.value.inspectionDate;
        let inspectionDate = formatDate(new Date(selectedDate), 'MM/dd/yyyy', 'en-US')
        this.getPSCertificationID(this.powerSupplyIdval,inspectionDate);
      }else{
        if(!this.permissionValue){
          //BP user - pass inspection date to get new certificate
          this.getPSCertificationID(this.powerSupplyIdval,this.triageInfoFlag);
        }else{
          //Non BP user - don't pass inspection
          this.getPSCertificationID(this.powerSupplyIdval,null);
        }
      }
    }else{
      this.certificateFlag = false;
    }
    // if ((event == 'Preventive Maintenance/Certification (Cert Required)' ||
    // event == 'Device Upgrade (Cert Required)' ||
    // event == 'Alarm (Cert Required)' ||
    // event == 'Other (Cert Required)' ||
    // event == 'Return Visit') && standby == 'Built In Generator') {
    if((this.certRequiredValue || event == 'Return Visit') && standby == 'Built In Generator'){
    this.apuFormGroupValidation();
    this.certFlag = true;
     // this.transponderInfoForm.controls['standByOpts'].patchValue('Built In Generator');
    setTimeout(() => {
      this.showApu = true;
      this.apuTab = true;
      //Apu and Apu Show visit
     // this.apuFormGroupValidation();

      this.apuTab = true;
      this.apuEnclosures = this.cabinetVendors;
      this.naturalGasProviderService.getAllNaturalGasProviderFromService().subscribe(res => {
        this.ngProvideres = res;
      });
      this.powerSupplyAputypesService.getAllApuTypesFromService().subscribe(res => {
        this.apuMakeModels = res;
      });
      if(!this.triageId) {
      if (this.powerSupplyId != null && this.powerSupplyId != 0) {
        this.powerSupplyResourceService.getApuByPowerSupplyId(this.powerSupplyId).subscribe((res: any) => {
          if (res.id != 0 && res.id != null) {
            this.apu_id = res.id;
            let date: Date = null;
            if (res.dateApuInstalled != null && res.dateApuInstalled != 0) date = new Date(res.dateApuInstalled);
            setTimeout(() => {
              this.apuFormGroup.patchValue({
                apuMakeModel: res.apuMakeModel,
                apuSerialNumber: res.apuSerialNumber,
                apuDeviceId: res.apuDeviceId,
                apuRunTime: res.apuRunTime,
                ecmAcm: res.ecmAcm,
                dateApuInstalled: date,
                apuOpVltgRating: res.apuOutputVoltageRating,
                apuNoLoadVltg: res.apuNoLoadVoltage,
                apuLoadVltg: res.apuLoadVoltage,
                apuEnclosure: res.apuEnclosureMake,
                ngLp: res.ngLp,
                ngProvider: res.ngProvider,
                lpTankCapacity: res.lpTankCapacity,
                noOfTanksInstalled: res.numberOfTanks
              });
            });

          } else this.apu_id = 0;
          //this.showProgressBar = false;
        }, err => {
         // this.showProgressBar = false;
        });
      }


      this.apuVisitFormGroupValidation();
      //alert(this.moremonth)
      if (this.powerSupplyId != null && this.powerSupplyId != 0 && (this.moremonth == false || this.moremonth == undefined)) {
        this.powerSupplyService.getApuVisitByPowerSupplyId(this.powerSupplyId).subscribe(res => {
          if (res.id != 0 && res.id != null) {
            this.id = res.id;
            let inspecDate: Date = null;
            let apuBatteryInstallDate: Date = null;
            if (res.inspectionDate != null && res.inspectionDate != 0) inspecDate = new Date(res.inspectionDate);
            if (res.apuBatteryInstallDate != null && res.apuBatteryInstallDate != 0) apuBatteryInstallDate = new Date(res.apuBatteryInstallDate);
            this.apuVisitFormGroup.patchValue({
              apuinspectionDate: inspecDate,
              apuVisitedTech: res.apuCompletedBy,
              apuBatteryManuType: res.apuBatteryManufactureType,
              apuBatteryDateCode: res.apuBatteryDateCode,
              apuBatteryInstallDate: apuBatteryInstallDate,
              apuBatteryVltgNoLoad: res.apuBatteryVoltageNoLoad,
              apuBatteryConductance: res.apuBatteryConductance,
              apuBatteryCon77deg: res.apuBatteryConductanceCrrctd,
              apuBatteryTorque: res.apuBatteryTorque,
              apuBatteryTerminals: res.apuBatteryTerminalsCleaned,
              apuStarter: res.apuStarterBatteryChrgrVlt,
              apuCharger: res.apuChargerCurrentAmps,
              followup: res.followUpaAtionNeeded,
              recordAsFoundAlarms: res.recordAsFoundAlarms,
              apuTestRun: res.apuTestRun,
              checkOilLevel: res.checkOilLevel,
              ifOilAdded: res.oilAddedAmount,
              oilFilterTight: res.oilFilterTight,
              inspectGenerator: res.inspectGeneratorAirFilter,
              inspectSparkPlug: res.inspectSparkPlug,
              clearApuEventlog: res.clearApuEventLog,
              apuFrequency: res.apuFrequency,
              tank1: res.tankOneLevel,
              tank2: res.tankTwoLevel,
              gasMeter: res.gasMeterNumber,
              gasMeterReading: res.gasMeterReading,
              ngPressure: res.ngPressure,
              airFilter: res.changeCleanenClosureAirFilter,
              rodentInsectDamage: res.checkForRodentDamage,
              checkLamps: res.checkLampsLed,
              clearWeeds: res.clearWeeds,
              checkRegrout: res.checkRegroutPadConduit,
              ifGroundMount: res.groundMountPadUndermining,
              anyEnclosure: res.enclosureDamageVandalism,
              cleanUpGarbage: res.cleanupGarbage,
              testOilPressure: res.testOilPressureAlarm,
              testhighTemp: res.testHighTempAlarm,
              generatorDcBus: res.generatorDcBusFunction,
              checkForGas: res.checkForGasLeaks,
              testCombustible: res.testCombustibleGasAlarm,
              testTamper: res.testTamperAlarm,
              testWaterIntrusion: res.testWaterIntrusionAlarm,
              testPad: res.testPadsShearAlarm,
              comments:res.apuVisitComments
            });
          } else this.id = 0;
          this.ref.detectChanges();
          this.showProgressBar = false;
        }, err => {
          this.showProgressBar = false;
        });
      }
      } else {//Assigning Id from master data
        this.apuVisitFormGroupValidation();
          this.powerSupplyResourceService.getApuByPowerSupplyId(this.powerSupplyId).subscribe((res: any) => {
            if (res.id != 0 && res.id != null) {
              this.apu_id = res.id;
            }
          });
          this.powerSupplyService.getApuVisitByPowerSupplyId(this.powerSupplyId).subscribe(res => {
            if (res.id != 0 && res.id != null) {
              this.id = res.id;
            }
          });
      }
     // this.lastVisitInfoFormValidation();

    //   this.lastVisitInfoForm.controls["inspectionDate"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["inspectionDate"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["typeOfVisit"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["typeOfVisit"].updateValueAndValidity();
    //   if (!this.permissionValue) {
    //     this.lastVisitInfoForm.controls["mobileno"].updateValueAndValidity();
    //     this.lastVisitInfoForm.controls["mobileno"].setValidators(Validators.required);
    //   }
    //   this.lastVisitInfoForm.controls["xocVerified"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["xocVerified"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["visitStatus"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["visitStatus"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["followupReason"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["followupReason"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["cleanDust"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["cleanDust"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["tightenAll"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["tightenAll"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["inspectWire"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["inspectWire"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["inspectBattery"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["inspectBattery"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["meterPan"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["meterPan"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["powerCo"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["powerCo"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["batteryHeaterType"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["batteryHeaterType"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["batteryHeaterQuantity"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["batteryHeaterQuantity"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["encloseSnow"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["encloseSnow"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["internalBreaker"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["internalBreaker"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["serviceEntrance"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["serviceEntrance"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["receptacleType"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["receptacleType"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["checkSeizure"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["checkSeizure"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["psIDLegibile"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["psIDLegibile"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["checkLamps"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["checkLamps"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["checkCircuitBreaker"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["checkCircuitBreaker"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["visualInspection"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["visualInspection"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["cabinetLocked"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["cabinetLocked"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["securityBar"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["securityBar"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["checkGround"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["checkGround"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["tamperInstalled"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["tamperInstalled"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["checkLaps"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["checkLaps"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["cabinetVendor"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["cabinetVendor"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["cabinetBattery"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["cabinetBattery"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["checkOperating"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["checkOperating"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["followUp"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["followUp"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["inputSurge"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["inputSurge"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["outputSurge"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["outputSurge"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["coaxTvss"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["coaxTvss"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["acIndicator"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["acIndicator"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["lri"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["lri"].updateValueAndValidity();
    //   this.lastVisitInfoForm.controls["lastVisitComments"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    //   //this.addbatteryfusedValidation();
    // this.lastVisitInfoForm.controls["batteryStringFused1"].clearValidators();
    // this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["batteryStringFused2"].clearValidators();
    // this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["batteryStringFused3"].clearValidators();
    // this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
    // this.lastVisitInfoForm.controls["batteryStringFused4"].clearValidators();
    // this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
    // for (let i = 0; i < this.noOfBatteries; i++) {
    //   if (i == 0) {
    //     this.lastVisitInfoForm.controls["batteryStringFused1"].setValidators(Validators.required);
    //     this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
    //   } else if (i == 1) {
    //     this.lastVisitInfoForm.controls["batteryStringFused2"].setValidators(Validators.required);
    //     this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
    //   } else if (i == 2) {
    //     this.lastVisitInfoForm.controls["batteryStringFused3"].setValidators(Validators.required);
    //     this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
    //   } else if (i == 3) {
    //     this.lastVisitInfoForm.controls["batteryStringFused4"].setValidators(Validators.required);
    //     this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
    //   }
    // }
    //   this.asterisk = '*';
    });
    this.ref.markForCheck()
    this.lastCert = true;
    //this.locationInfoForm.controls["houseNumberInput"].setValidators(Validators.required);
    //this.locationInfoForm.controls["houseNumberInput"].updateValueAndValidity();
    this.locationInfoForm.controls["crossStreet"].setValidators(Validators.required);
    this.locationInfoForm.controls["crossStreet"].updateValueAndValidity();
    //this.transponderInfoForm.controls["prevMacAddress"].setValidators(Validators.required);
    //this.transponderInfoForm.controls["prevMacAddress"].updateValueAndValidity();
    this.transponderInfoForm.controls["powerSupplyAlertProfile"].setValidators(Validators.required);
    this.transponderInfoForm.controls["powerSupplyAlertProfile"].updateValueAndValidity();
    this.transponderInfoForm.controls["serialNum"].setValidators(Validators.required);
    this.transponderInfoForm.controls["serialNum"].updateValueAndValidity();
    this.transponderInfoForm.controls["dcReady"].setValidators(Validators.required);
    this.transponderInfoForm.controls["dcReady"].updateValueAndValidity();
    this.transponderInfoForm.controls["transponderComments"].setValidators(Validators.required);
    this.transponderInfoForm.controls["transponderComments"].updateValueAndValidity();
    //alert(this.transponderInfoForm.value.standByOpts)
    // let standby = this.transponderInfoForm.value.standByOpts;
    // if ((event == 'Preventive Maintenance/Certification (Cert Required)' ||
    //   event == 'Device Upgrade (Cert Required)' ||
    //   event == 'Alarm (Cert Required)' ||
    //   event == 'Other (Cert Required)') && standby == 'Built In Generator') {
    //   this.apuVisitFormGroupValidation();
    //   this.markAsTouched(this.apuVisitFormGroup);
    //   if (this.powerSupplyId != null && this.powerSupplyId != 0 && (this.moremonth == false || this.moremonth == undefined)) {
    //     this.powerSupplyService.getApuVisitByPowerSupplyId(this.powerSupplyId).subscribe(res => {
    //       if (res.id != 0 && res.id != null) {
    //         this.id = res.id;
    //         let inspecDate: Date = null;
    //         let apuBatteryInstallDate: Date = null;
    //         if (res.inspectionDate != null && res.inspectionDate != 0) inspecDate = new Date(res.inspectionDate);
    //         if (res.apuBatteryInstallDate != null && res.apuBatteryInstallDate != 0) apuBatteryInstallDate = new Date(res.apuBatteryInstallDate);
    //         this.apuVisitFormGroup.patchValue({
    //           apuinspectionDate: inspecDate,
    //           apuVisitedTech: res.apuCompletedBy,
    //           apuBatteryManuType: res.apuBatteryManufactureType,
    //           apuBatteryDateCode: res.apuBatteryDateCode,
    //           apuBatteryInstallDate: apuBatteryInstallDate,
    //           apuBatteryVltgNoLoad: res.apuBatteryVoltageNoLoad,
    //           apuBatteryConductance: res.apuBatteryConductance,
    //           apuBatteryCon77deg: res.apuBatteryConductanceCrrctd,
    //           apuBatteryTorque: res.apuBatteryTorque,
    //           apuBatteryTerminals: res.apuBatteryTerminalsCleaned,
    //           apuStarter: res.apuStarterBatteryChrgrVlt,
    //           apuCharger: res.apuChargerCurrentAmps,
    //           followup: res.followUpaAtionNeeded,
    //           recordAsFoundAlarms: res.recordAsFoundAlarms,
    //           apuTestRun: res.apuTestRun,
    //           checkOilLevel: res.checkOilLevel,
    //           ifOilAdded: res.oilAddedAmount,
    //           oilFilterTight: res.oilFilterTight,
    //           inspectGenerator: res.inspectGeneratorAirFilter,
    //           inspectSparkPlug: res.inspectSparkPlug,
    //           clearApuEventlog: res.clearApuEventLog,
    //           apuFrequency: res.apuFrequency,
    //           tank1: res.tankOneLevel,
    //           tank2: res.tankTwoLevel,
    //           gasMeter: res.gasMeterNumber,
    //           gasMeterReading: res.gasMeterReading,
    //           ngPressure: res.ngPressure,
    //           airFilter: res.changeCleanenClosureAirFilter,
    //           rodentInsectDamage: res.checkForRodentDamage,
    //           checkLamps: res.checkLampsLed,
    //           clearWeeds: res.clearWeeds,
    //           checkRegrout: res.checkRegroutPadConduit,
    //           ifGroundMount: res.groundMountPadUndermining,
    //           anyEnclosure: res.enclosureDamageVandalism,
    //           cleanUpGarbage: res.cleanupGarbage,
    //           testOilPressure: res.testOilPressureAlarm,
    //           testhighTemp: res.testHighTempAlarm,
    //           generatorDcBus: res.generatorDcBusFunction,
    //           checkForGas: res.checkForGasLeaks,
    //           testCombustible: res.testCombustibleGasAlarm,
    //           testTamper: res.testTamperAlarm,
    //           testWaterIntrusion: res.testWaterIntrusionAlarm,
    //           testPad: res.testPadsShearAlarm,
    //           comments:res.apuVisitComments
    //         });
    //       } else this.id = 0;
    //       this.ref.detectChanges();
    //       this.showProgressBar = false;
    //     }, err => {
    //       this.showProgressBar = false;
    //     });
    //   }
    // } else {
    //   Object.keys(this.apuVisitFormGroup.controls).forEach((key: string) => {
    //     const abstractControl = this.apuVisitFormGroup.get(key);
    //     abstractControl.clearValidators();
    //     abstractControl.updateValueAndValidity();
    //   })
    // }

  } else {
    Object.keys(this.apuVisitFormGroup.controls).forEach((key: string) => {
        const abstractControl = this.apuVisitFormGroup.get(key);
        abstractControl.clearValidators();
        abstractControl.updateValueAndValidity();
    })
    this.certFlag = false;
    this.lastCert = false;
    //this.showApu = false;
    //this.apuVisitFormGroupValidation();
    // this.locationInfoForm.controls["houseNumberInput"].clearValidators();
    // this.locationInfoForm.controls["houseNumberInput"].updateValueAndValidity();
    this.locationInfoForm.controls["crossStreet"].clearValidators();
    this.locationInfoForm.controls["crossStreet"].updateValueAndValidity();
    //this.transponderInfoForm.controls["prevMacAddress"].clearValidators();
    //this.transponderInfoForm.controls["prevMacAddress"].updateValueAndValidity();
    this.transponderInfoForm.controls["powerSupplyAlertProfile"].clearValidators();
    this.transponderInfoForm.controls["powerSupplyAlertProfile"].updateValueAndValidity();
    this.transponderInfoForm.controls["serialNum"].clearValidators();
    this.transponderInfoForm.controls["serialNum"].updateValueAndValidity();
    this.transponderInfoForm.controls["dcReady"].clearValidators();
    this.transponderInfoForm.controls["dcReady"].updateValueAndValidity();
    this.transponderInfoForm.controls["transponderComments"].clearValidators();
    this.transponderInfoForm.controls["transponderComments"].updateValueAndValidity();
  }
    if ((event === 'Annual Inspection' || event === 'Maintenance' || event === 'Repair')) {
      this.lastVisitInfoForm.controls["inspectionDate"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["inspectionDate"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["typeOfVisit"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["typeOfVisit"].updateValueAndValidity();
      if(!this.permissionValue){
        this.lastVisitInfoForm.controls["mobileno"].updateValueAndValidity();
        this.lastVisitInfoForm.controls["mobileno"].setValidators(Validators.required);
      }
      this.lastVisitInfoForm.controls["xocVerified"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["xocVerified"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["cleanDust"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["cleanDust"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["tightenAll"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["tightenAll"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["inspectWire"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["inspectWire"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["inspectBattery"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["inspectBattery"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["meterPan"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["meterPan"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["powerCo"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["powerCo"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryHeaterType"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["batteryHeaterType"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryHeaterQuantity"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["batteryHeaterQuantity"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["encloseSnow"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["encloseSnow"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["internalBreaker"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["internalBreaker"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["serviceEntrance"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["serviceEntrance"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["receptacleType"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["receptacleType"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkSeizure"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkSeizure"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["psIDLegibile"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["psIDLegibile"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkLamps"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkLamps"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkCircuitBreaker"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkCircuitBreaker"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["visualInspection"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["visualInspection"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["cabinetLocked"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["cabinetLocked"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["securityBar"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["securityBar"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkGround"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkGround"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["tamperInstalled"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["tamperInstalled"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkLaps"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkLaps"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["cabinetVendor"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["cabinetVendor"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["cabinetBattery"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["cabinetBattery"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkOperating"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkOperating"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["followUp"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["followUp"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["inputSurge"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["inputSurge"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["outputSurge"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["outputSurge"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["coaxTvss"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["coaxTvss"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["acIndicator"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["acIndicator"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["lri"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["lri"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["followUpReasons"].setValidators(Validators.required);
      // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["visitStatus"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["visitStatus"].updateValueAndValidity();
      this.addbatteryfusedValidation();
      this.asterisk = '*';
    }
    // else if(event == 'Preventive Maintenance/Certification (Cert Required)' ||
    //          event == 'Device Upgrade (Cert Required)' ||
    //          event == 'Alarm (Cert Required)' ||
    //          event == 'Other (Cert Required)' ||
    //          event == 'Return Visit') {
    else if(this.certRequiredValue || event == 'Return Visit'){
               this.lastVisitInfoFormValidation();
    }else {
      Object.keys(this.lastVisitInfoForm.controls).forEach((key: string) => {
        //mobile no mandatory for all the fields
        if(key == 'mobileno' && !this.permissionValue){
          this.lastVisitInfoForm.controls["mobileno"].updateValueAndValidity();
          this.lastVisitInfoForm.controls["mobileno"].setValidators(Validators.required);
        }else{
          const abstractControl = this.lastVisitInfoForm.get(key);
          abstractControl.clearValidators();
          abstractControl.updateValueAndValidity();
        }
      })
      this.asterisk = '';
    }
    //workitem required based on the BP workitem selection
    // let eventBP = (event !== undefined) ? event.startsWith("BP") : false;
    // // alert(eventBP)
    // // alert(this.workitemFlag)
    // if((eventBP && !this.workitemFlag) ){
    //   this.lastVisitInfoForm.controls["workitem"].setValidators(Validators.required);
    //   this.lastVisitInfoForm.controls["workitem"].updateValueAndValidity();
    // }else{
    //   this.lastVisitInfoForm.controls["workitem"].clearValidators();
    //   this.lastVisitInfoForm.controls["workitem"].updateValueAndValidity();
    // }
  }

  addbatteryfusedValidation() {
    let batevent = this.batteryInfoForm.value.numberofBatteries;
    if (this.batteryInfoForm.value.numberofBatteries != undefined) {
      const splits: string[] = batevent.split(' ');
      if (splits[0] == this.parallel) {
        this.noOfBatteries = Number(splits[1]);
      } else {
        this.noOfBatteries = Number(splits[3]);
      }
    }

    let event = this.lastVisitInfoForm.value.typeOfVisit;
    if(event && event.indexOf('Cert Required') !== -1){
      this.certRequiredValue = true;
    }else{
      this.certRequiredValue = false;
    }
    if (event == 'Annual Inspection' || event == 'Maintenance' || event == 'Repair' || this.certRequiredValue) {
      this.lastVisitInfoForm.controls["batteryStringFused1"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused2"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused3"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused4"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused5"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused6"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
      // for (let i = 0; i < this.noOfBatteries; i++) {
      //   if (i == 0) {
      //     this.lastVisitInfoForm.controls["batteryStringFused1"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
      //   } else if (i == 1) {
      //     this.lastVisitInfoForm.controls["batteryStringFused2"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
      //   } else if (i == 2) {
      //     this.lastVisitInfoForm.controls["batteryStringFused3"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
      //   } else if (i == 3) {
      //     this.lastVisitInfoForm.controls["batteryStringFused4"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
      //   }
      //   else if (i == 4) {
      //     this.lastVisitInfoForm.controls["batteryStringFused5"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
      //   } else if (i == 5) {
      //     this.lastVisitInfoForm.controls["batteryStringFused6"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
      //   }
      // }
    } else if(this.certRequiredValue){
      // for (let i = 0; i < this.noOfBatteries; i++) {
      //   if (i == 0) {
      //     this.lastVisitInfoForm.controls["batteryStringFused1"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
      //   } else if (i == 1) {
      //     this.lastVisitInfoForm.controls["batteryStringFused2"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
      //   } else if (i == 2) {
      //     this.lastVisitInfoForm.controls["batteryStringFused3"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
      //   } else if (i == 3) {
      //     this.lastVisitInfoForm.controls["batteryStringFused4"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
      //   }
      //   else if (i == 4) {
      //     this.lastVisitInfoForm.controls["batteryStringFused5"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
      //   } else if (i == 5) {
      //     this.lastVisitInfoForm.controls["batteryStringFused6"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
      //   }
      // }
    } else {
      // this.lastVisitInfoForm.controls["batteryStringFused1"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused2"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused3"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused4"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused5"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused6"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
    }

  }


  addNodes() {
    const node = this.fb.group({
      node:['', Validators.required]
    })
    this.nodesForms.push(node);
    this.markAsTouched(this.nodesForm);
    this.manageNameControl(this.nodesForms.length - 1);
    this.ref.detectChanges();
  }

  manageNameControl(index) {
    this.nodesForms.at(index).get('node')
      .valueChanges
      //.pipe(debounceTime(600))
      .pipe(debounceTime(100),
      tap(() => {
         this.isLoadingdata = true;
      }),
      )
      .subscribe(searchWord => {
        if (this.validateFN){
          if(this.validationFlag){
            this.nodesForms.at(index).get('node').setErrors({ required: true });
            this.ref.detectChanges();
          }
          this.filterNodeOptions[index] = this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(searchWord).pipe(shareReplay({refCount:true,bufferSize:1}),map(res => res));
        }else{
          this.nodesForms.at(index).get('node').setErrors({ required: true });
          this.ref.detectChanges();
          this.filterNodeOptions[index] = this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(searchWord).pipe(shareReplay({refCount:true,bufferSize:1}),map(res => res.filter((item: JsonAdvancedSearchResult) => item.nodeCommunintyServed === this.communityServed)));
        }
        this.validationFlag = false;
        this.filterNodeOptions[index].subscribe(nodes => {
          if (nodes.length > 0 && nodes.find(x => x.node.toUpperCase() == searchWord.toUpperCase())) {
            this.nodesForms.at(index).get('node').setErrors(null);
            this.updateForm(searchWord, index);
            this.isLoadingdata = false;
          } else {
            // this.nodesForms.at(index).get('node').markAsDirty();
            // this.nodesForms.at(index).get('node').markAsTouched();
            // this.nodesForms.at(index).get('node').setErrors({ nodeError: true });
            // this.isLoadingdata = false;
            this.nodesForms.at(index).get('node').markAsDirty();
            this.nodesForms.at(index).get('node').markAsTouched();
           if(this.node2_id == null && index == 0){
              setTimeout(() => {
                 this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node3_id == null && index == 1){
              setTimeout(() => {
               this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node4_id == null && index == 2){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node5_id == null && index == 3){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node6_id == null && index == 4){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node7_id == null && index == 5){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node8_id == null && index == 6){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node9_id == null && index == 7){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node10_id == null && index == 8){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node11_id == null && index == 9){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node12_id == null && index == 10){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node13_id == null && index == 11){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }else if(this.node14_id == null && index == 12){
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node15_id == null && index == 13) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node16_id == null && index == 14) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node17_id == null && index == 15) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node18_id == null && index == 16) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node19_id == null && index == 17) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node20_id == null && index == 18) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node21_id == null && index == 19) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node22_id == null && index == 20) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node23_id == null && index == 21) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node24_id == null && index == 22) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node25_id == null && index == 23) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node26_id == null && index == 24) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node27_id == null && index == 25) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node28_id == null && index == 26) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node29_id == null && index == 27) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node30_id == null && index == 28) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node31_id == null && index == 29) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node32_id == null && index == 30) {
              setTimeout(() => {
                this.nodesForms.at(index).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }
            else{
              this.nodesForms.at(index).get('node').markAsDirty();
              this.nodesForms.at(index).get('node').markAsTouched();
              this.nodesForms.at(index).get('node').setErrors({ nodeError: true });
            }
            this.isLoadingdata = false;
          }
        });
      });
  }

  removeNode(index) {
    const control = <FormArray>this.nodesForms;
    control.removeAt(index - 1);
    this.filterNodeOptions.splice(index - 1, 1);
    this.nodeValues.splice(index -1,1);
  }

  addBatteries() {
    const batteryString = this.fb.group({
      //batteryManagerModel: ['', Validators.required],
      //batterySeparator: ['']
    });
    this.batteryStringForms.push(batteryString);
    this.ref.detectChanges();
  }

  addBatteryBatteries(index) {
    let batteriesReplaced: string = this.batteryInfoForm.value.batteriesReplaced;
    let batteryBattery;
    if (batteriesReplaced == undefined || batteriesReplaced == '' || batteriesReplaced.toLowerCase() == 'no') {
      batteryBattery = this.fb.group({
        batteryManufacturer: [''],
        batterySerial:[''],
        batteryCode: ['', [BatteryDateCodeValidation.ValidateBatteryDateCode()]],
        batteryInstallDate: [''],
        batteryVoltageNoLoad: [''],
        batteryVoltageUnderLoad: [''],
        batteryConductance: [''],
        batteryConductanceCorrected: [''],
        totalVoltage: ['']
      });
      this.asterisk = '';
    } else {
      batteryBattery = this.fb.group({
        batteryManufacturer: ['', Validators.required],
        batterySerial: ['', Validators.required],
        batteryCode: ['', [Validators.required, BatteryDateCodeValidation.ValidateBatteryDateCode()]],
        batteryInstallDate: ['', Validators.required],
        batteryVoltageNoLoad: ['', Validators.required],
        batteryVoltageUnderLoad: [''],
        batteryConductance: [''],
        batteryConductanceCorrected: [''],
        totalVoltage: ['']
      });
      this.asterisk = '*';
    }
    this.batteryBatteryForms.insert(index, batteryBattery);
    this.ref.detectChanges();
  }

  removeString(index) {
    const control = <FormArray>this.batteryStringForms;
    control.removeAt(index - 1);
  }

  removeBattery(index) {
    const control = <FormArray>this.batteryBatteryForms;
    control.removeAt(index - 1);
  }

  changeMinMax() {
    const temp = this.max - this.min;
    this.max = this.max + temp + 1;
    this.min = this.min + temp + 1;
  }

  IsTrue(i, j) {
    if (this.batteryGroup[i] != undefined && this.batteryGroup[i] != null && this.batteryGroup[i][j] === j) {
      return true;
    }
    else {
      return false;
    }
  }

  changePowerSupplyModel(result) {
    if (result.value == null || result.value == '' || result.value == undefined || result.value.toUpperCase() !== 'AM COMMUNICATIONS') {
      this.showPowerSupplyModel = true;
      this.showPowerSupplyType9360 = false;
      if (this.transponderInfoForm.controls['powerSupplyModel'].value === null
        || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined
        || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
        setTimeout(() => {
          this.transponderInfoForm.controls['powerSupplyModel'].patchValue(undefined);
          this.transponderInfoForm.controls['powerSupplyModel'].setErrors({ validatePowerSupplyModel: true });
          this.transponderInfoForm.controls['powerSupplyModel'].markAsDirty();
          this.transponderInfoForm.controls['powerSupplyModel'].markAsTouched();
          this.transponderInfoForm.controls['powerSupplyModel'].updateValueAndValidity();
          this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
          this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
        });
      } else {
        this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null);
      }
    }
    else {
      this.showPowerSupplyModel = false;
      this.showPowerSupplyType9360 = true;
      if (this.transponderInfoForm.controls['powerSupplyType9360'].value === null
        || this.transponderInfoForm.controls['powerSupplyType9360'].value === undefined
        || this.transponderInfoForm.controls['powerSupplyType9360'].value === '') {
        setTimeout(() => {
          this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
          this.transponderInfoForm.controls['powerSupplyType9360'].setErrors({ validatePowerSupply9360: true });
          this.transponderInfoForm.controls['powerSupplyType9360'].markAsDirty();
          this.transponderInfoForm.controls['powerSupplyType9360'].markAsTouched();
          this.transponderInfoForm.controls['powerSupplyType9360'].updateValueAndValidity();
          this.transponderInfoForm.controls['powerSupplyModel'].patchValue('');
          this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null);
        });
      }
    }
  }
  changePowerSupplyModelValidation() {
    //if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
      if ((this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined
      || this.transponderInfoForm.controls['powerSupplyModel'].value === '') && this.transponderInfoForm.controls['transponderVendor'].value !== 'AM COMMUNICATIONS') {
     this.transponderInfoForm.controls['powerSupplyModel'].setErrors({ validatePowerSupplyModel: true });
    } else {
      this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null);
    }
  }

  onMacChange(result) {
    if (result !== null && result !== undefined) {
      if (result.length === 17 && this.transponderInfoForm.controls['activeMacAddress'].status === 'VALID') this.pullTransponderButton = true;
      else this.pullTransponderButton = false;
      if (this.originalMac.toUpperCase() !== result.toUpperCase())
        this.transponderInfoForm.controls['prevMacAddress'].patchValue(this.originalMac);
      // else this.transponderInfoForm.controls['prevMacAddress'].patchValue('');
    } else this.pullTransponderButton = true;
  }

  onPullTransponder() {
    this.showPowerSupplyType9360 = false;//added for hiding the ps type on edit page load
    let mac: string = this.transponderInfoForm.controls['activeMacAddress'].value;
    if (mac !== null && mac.length === 17) {
      if (mac.substring(0, 2) == 'aa' || mac.substring(0, 2) == 'bb' || mac.substring(0, 2) == 'cc' || mac.substring(0, 2) == 'dd' || mac.substring(0, 2) == 'ee') {
        this.transponderInfoForm.controls['activeMacAddress'].patchValue(mac);
        this.transponderInfoForm.controls['ip'].patchValue('0.0.0.0');
        this.transponderInfoForm.controls['transponderVendor'].patchValue('Unknown');
        this.transponderInfoForm.controls['transponderModel'].patchValue('Unknown');
        this.showPowerSupplyModel = true;
        this.showPowerSupplyType9360 = false;
        if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
          this.transponderInfoForm.controls['powerSupplyModel'].patchValue('Unknown');
          this.transponderInfoForm.controls['powerSupplyModel'].setErrors({ validatePowerSupplyModel: true });
        } else {
          this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null);
        }
      } else {
        this.showProgressBar = true;
        const ip: IP = {};
        ip.macAddress = mac;
        ip.nodeId = this.nodeId;
        if (environment.pullTransponderUseGenome) {
          // this.powerSupplyService.pullTransponderByMacAddress(mac)
          //   .subscribe(result => {
            this.powerSupplyService.pullTransponder(ip)
            .subscribe(result => {
              if (result !== null) {
                if(result.transponderVendor !== null){
                  if(!this.transponderVendors.includes(result.transponderVendor)){
                    this.transponderVendors.push(result.transponderVendor)
                  }
                }else{
                  this.transponderInfoForm.controls['transponderVendor'].patchValue('')
                }
                if(result.transponderModel !== null){
                  if(!this.transponderModels.includes(result.transponderModel)){
                    this.transponderModels.push(result.transponderModel);
                    this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel);
                    this.ref.detectChanges()
                  }else{
                    //if same data is avaliable in dropdown select the genome call value
                    this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel);
                  }
                }else{
                  this.transponderInfoForm.controls['transponderModel'].patchValue('')
                }
                if(result.powerSupplyModel !== null){
                  if(!this.powerSupplyModels.includes(result.powerSupplyModel)){
                    this.powerSupplyModels.push(result.powerSupplyModel);
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue(result.powerSupplyModel);
                    this.ref.detectChanges()
                  }else{
                    //if same data is avaliable in dropdown select the genome call value
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue(result.powerSupplyModel);
                  }
                }else{
                  this.transponderInfoForm.controls['powerSupplyModel'].patchValue('');
                }
                if(result.transponderVendor !== null){
                  if (this.transponderVendors.includes(result.transponderVendor)) {
                    this.transponderInfoForm.controls['transponderVendor'].patchValue(result.transponderVendor);
                  } else if (this.transponderVendors.includes(result.transponderVendor.toUpperCase())) {
                    this.transponderInfoForm.controls['transponderVendor'].patchValue(result.transponderVendor.toUpperCase());
                  } else {
                    this.transponderInfoForm.controls['transponderVendor'].patchValue(this.titleCase(result.transponderVendor));
                  }
                }
                if(result.macAddress !== null){
                  this.transponderInfoForm.controls['activeMacAddress'].patchValue(result.macAddress);
                }

                if(result.ipAddress !== null){
                  this.transponderInfoForm.controls['ip'].patchValue(result.ipAddress);
                }else{
                  this.transponderInfoForm.controls['ip'].patchValue('0.0.0.0');
                }
                if(result.transponderModel !== null){
                  this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel.toString());
                }

                this.originalMac = result.macAddress;
                if(result.transponderVendor !== null){
                if (result.transponderVendor.toUpperCase() === 'AM COMMUNICATIONS') {
                  this.showPowerSupplyModel = false;
                  this.showPowerSupplyType9360 = true;
                  if (this.transponderInfoForm.controls['powerSupplyType9360'].value === null || this.transponderInfoForm.controls['powerSupplyType9360'].value === undefined || this.transponderInfoForm.controls['powerSupplyType9360'].value === '') {
                    this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors({ validatePowerSupply9360: true });
                  } else {
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
                    this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null)
                  }
                } else {
                  this.showPowerSupplyModel = true;
                  this.showPowerSupplyType9360 = false;
                  if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue('Unknown');
                  } else {
                    this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
                    this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null)
                  }
                }


              } else {
                if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '')
                  this.transponderInfoForm.controls['powerSupplyModel'].setErrors({ validatePowerSupplyModel: true });
                else
                  this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null);
              }
            }
              this.showProgressBar = false;
            });
        } else {
          this.powerSupplyService.pullTransponder(ip)
            .subscribe(result => {
              if (result !== null) {
                if (result.transponderVendor.toUpperCase() === 'AM COMMUNICATIONS') {
                  this.transponderInfoForm.controls['activeMacAddress'].patchValue(result.macAddress);
                  this.transponderInfoForm.controls['ip'].patchValue(result.ipAddress);
                  this.transponderInfoForm.controls['transponderVendor'].patchValue(result.transponderVendor.toUpperCase());
                  this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel.toString());
                  this.originalMac = result.macAddress;
                  this.showPowerSupplyModel = false;
                  this.showPowerSupplyType9360 = true;
                  if (this.transponderInfoForm.controls['powerSupplyType9360'].value === null || this.transponderInfoForm.controls['powerSupplyType9360'].value === undefined || this.transponderInfoForm.controls['powerSupplyType9360'].value === '') {
                    this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors({ validatePowerSupply9360: true });
                  } else {
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
                    this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null)
                  }
                } else {
                  this.transponderInfoForm.controls['activeMacAddress'].patchValue(result.macAddress);
                  this.transponderInfoForm.controls['ip'].patchValue(result.ipAddress);
                  this.transponderInfoForm.controls['transponderVendor'].patchValue(result.transponderVendor);
                  this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel);
                  this.originalMac = result.macAddress;
                  this.showPowerSupplyModel = true;
                  this.showPowerSupplyType9360 = false;
                  if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue('Unknown');
                  } else {
                    this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
                    this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null)
                  }
                }
                // if (result.tranponderInvCmts) {
                //   this.openPopUp(true);
                // }
              }
              this.showProgressBar = false;
            });
        }
      }
    } else this.pullTransponderButton = true;
  }

  openPopUp(tranponderInvCmts: boolean) {
    this.bottomSheet.open(BottomSheetComponent, {
      data: tranponderInvCmts
    });
  }

  changePSAlertProfile() {
    let acInputVoltage = this.transponderInfoForm.value.acInputVoltage;
    let outputVoltage = this.transponderInfoForm.value.acOutputVoltage;
    let inputCurrent = this.transponderInfoForm.value.currentAmp;
    //let currentAmpOutput = this.transponderInfoForm.value.currentAmpOutput;
    let numberOfBatteries = this.batteryInfoForm.value.numberofBatteries;
    this.powerSupplyAlertProfile = this.commonService.getUnifiedPSAlertProfile(acInputVoltage,
      outputVoltage, inputCurrent, numberOfBatteries, this.division);
  }

  onClickGenerateMac() {
    this.powerSupplyService.generateMacAddress(this.region)
      .subscribe(result => {
        if (result !== null) {
          this.enablephotoStatus = false;
          this.activeMacAddresscopy = result.mac;
          this.transponderInfoForm.controls['activeMacAddress'].patchValue(result.mac);
          this.transponderInfoForm.controls['ip'].patchValue(result.ipAddress);
          this.transponderInfoForm.controls['transponderVendor'].patchValue(result.vendor);
          this.transponderInfoForm.controls['transponderModel'].patchValue(result.model);
          if (result.mac.length === 17) this.pullTransponderButton = true;
        }
      });
  }

  onClickGenerateIP() {
    if (this.transponderInfoForm.value.activeMacAddress !== undefined && this.transponderInfoForm.value.activeMacAddress !== null) {
      const ip: IP = {};
      ip.macAddress = this.transponderInfoForm.value.activeMacAddress;
      ip.nodeId = this.nodeId;
      this.powerSupplyService.generateIpAddress(ip)
        .subscribe(result => {
          if (result.success === true) {
            this.ipAddress=result.message;
            this.transponderInfoForm.controls['ip'].patchValue(result.message);
          }
        });
    }
  }

  updateFormId(nodeValue: any, index: number) {
    if (nodeValue !== null) {
      this.nodeIdValues[index] = nodeValue.nodeId;
      this.updateForm(nodeValue.node, index);
    }
    else {
      this.nodeIdValues[index] = null;
    }
    switch (index) {
      case 0:
        this.node2_id = this.nodeIdValues[0];
        break;
      case 1:
        this.node3_id = this.nodeIdValues[1];
        break;
      case 2:
        this.node4_id = this.nodeIdValues[2];
        break;
      case 3:
        this.node5_id = this.nodeIdValues[3];
        break;
      case 4:
        this.node6_id = this.nodeIdValues[4];
        break;
      case 5:
        this.node7_id = this.nodeIdValues[5];
        break;
      case 6:
        this.node8_id = this.nodeIdValues[6];
        break;
      case 7:
        this.node9_id = this.nodeIdValues[7];
        break;
      case 8:
        this.node10_id = this.nodeIdValues[8];
        break;
      case 9:
        this.node11_id = this.nodeIdValues[9];
        break;
      case 10:
        this.node12_id = this.nodeIdValues[10];
        break;
      case 11:
        this.node13_id = this.nodeIdValues[11];
        break;
      case 12:
        this.node14_id = this.nodeIdValues[12];
        break;
      case 13:
        this.node15_id = this.nodeIdValues[13];
        break;
      case 14:
        this.node16_id = this.nodeIdValues[14];
        break;
      case 15:
        this.node17_id = this.nodeIdValues[15];
        break;
      case 16:
        this.node18_id = this.nodeIdValues[16];
        break;
      case 17:
        this.node19_id = this.nodeIdValues[17];
        break;
      case 18:
        this.node20_id = this.nodeIdValues[18];
        break;
      case 19:
        this.node21_id = this.nodeIdValues[19];
        break;
      case 20:
        this.node22_id = this.nodeIdValues[20];
        break;
      case 21:
        this.node23_id = this.nodeIdValues[21];
        break;
      case 22:
        this.node24_id = this.nodeIdValues[22];
        break;
      case 23:
        this.node25_id = this.nodeIdValues[23];
        break;
      case 24:
        this.node26_id = this.nodeIdValues[24];
        break;
      case 25:
        this.node27_id = this.nodeIdValues[25];
        break;
      case 26:
        this.node28_id = this.nodeIdValues[26];
        break;
      case 27:
        this.node29_id = this.nodeIdValues[27];
        break;
      case 28:
        this.node30_id = this.nodeIdValues[28];
        break;
      case 29:
        this.node31_id = this.nodeIdValues[29];
        break;
      case 30:
        this.node32_id = this.nodeIdValues[30];
        break;
      default:
        return;
    }
  }


  updateForm(node: string, index: number) {
    if (node !== undefined && node !== '') {
      this.nodeValues[index] = node;
    }
    else {
      this.nodeValues[index] = null;
    }
    if (this.nodeValues[0] === undefined || this.nodeValues[0] === '' || this.nodeValues[0] === null) {
      this.node2 = '';
    } else this.node2 = this.nodeValues[0];

    if (this.nodeValues[1] === undefined || this.nodeValues[1] === '' || this.nodeValues[1] === null) {
      this.node3 = '';
    } else this.node3 = this.nodeValues[1];

    if (this.nodeValues[2] === undefined || this.nodeValues[2] === '' || this.nodeValues[2] === null) {
      this.node4 = '';
    } else this.node4 = this.nodeValues[2];

    if (this.nodeValues[3] === undefined || this.nodeValues[3] === '' || this.nodeValues[3] === null) {
      this.node5 = '';
    } else this.node5 = this.nodeValues[3];

    if (this.nodeValues[4] === undefined || this.nodeValues[4] === '' || this.nodeValues[4] === null) {
      this.node6 = '';
    } else this.node6 = this.nodeValues[4];

    if (this.nodeValues[5] === undefined || this.nodeValues[5] === '' || this.nodeValues[5] === null) {
      this.node7 = '';
    } else this.node7 = this.nodeValues[5];

    if (this.nodeValues[6] === undefined || this.nodeValues[6] === '' || this.nodeValues[6] === null) {
      this.node8 = '';
    } else this.node8 = this.nodeValues[6];

    if (this.nodeValues[7] === undefined || this.nodeValues[7] === '' || this.nodeValues[7] === null) {
      this.node9 = '';
    } else this.node9 = this.nodeValues[3];

    if (this.nodeValues[8] === undefined || this.nodeValues[8] === '' || this.nodeValues[8] === null) {
      this.node10 = '';
    } else this.node10 = this.nodeValues[8];

    if (this.nodeValues[9] === undefined || this.nodeValues[9] === '' || this.nodeValues[9] === null) {
      this.node11 = '';
    } else this.node11 = this.nodeValues[9];

    if (this.nodeValues[10] === undefined || this.nodeValues[10] === '' || this.nodeValues[10] === null) {
      this.node12 = '';
    } else this.node12 = this.nodeValues[10];

    if (this.nodeValues[11] === undefined || this.nodeValues[11] === '' || this.nodeValues[11] === null) {
      this.node13 = '';
    } else this.node13 = this.nodeValues[11];

    if (this.nodeValues[12] === undefined || this.nodeValues[12] === '' || this.nodeValues[12] === null) {
      this.node14 = '';
    } else this.node14 = this.nodeValues[12];

    if (this.nodeValues[13] === undefined || this.nodeValues[13] === '' || this.nodeValues[13] === null) {
      this.node15 = '';
    } else this.node15 = this.nodeValues[13];

    if (this.nodeValues[14] === undefined || this.nodeValues[14] === '' || this.nodeValues[14] === null) {
      this.node16 = '';
    } else this.node16 = this.nodeValues[14];

    if (this.nodeValues[15] === undefined || this.nodeValues[15] === '' || this.nodeValues[15] === null) {
      this.node17 = '';
    } else this.node17 = this.nodeValues[15];

    if (this.nodeValues[16] === undefined || this.nodeValues[16] === '' || this.nodeValues[16] === null) {
      this.node18 = '';
    } else this.node18 = this.nodeValues[16];

    if (this.nodeValues[17] === undefined || this.nodeValues[17] === '' || this.nodeValues[17] === null) {
      this.node19 = '';
    } else this.node19 = this.nodeValues[17];

    if (this.nodeValues[18] === undefined || this.nodeValues[18] === '' || this.nodeValues[18] === null) {
      this.node20 = '';
    } else this.node20 = this.nodeValues[18];

    if (this.nodeValues[19] === undefined || this.nodeValues[19] === '' || this.nodeValues[20] === null) {
      this.node21 = '';
    } else this.node21 = this.nodeValues[19];

    if (this.nodeValues[20] === undefined || this.nodeValues[20] === '' || this.nodeValues[20] === null) {
      this.node22 = '';
    } else this.node22 = this.nodeValues[20];

    if (this.nodeValues[21] === undefined || this.nodeValues[21] === '' || this.nodeValues[21] === null) {
      this.node23 = '';
    } else this.node23 = this.nodeValues[21];

    if (this.nodeValues[22] === undefined || this.nodeValues[22] === '' || this.nodeValues[22] === null) {
      this.node24 = '';
    } else this.node24 = this.nodeValues[22];

    if (this.nodeValues[23] === undefined || this.nodeValues[23] === '' || this.nodeValues[23] === null) {
      this.node25 = '';
    } else this.node25 = this.nodeValues[23];

    if (this.nodeValues[24] === undefined || this.nodeValues[24] === '' || this.nodeValues[24] === null) {
      this.node26 = '';
    } else this.node26 = this.nodeValues[24];

    if (this.nodeValues[25] === undefined || this.nodeValues[25] === '' || this.nodeValues[25] === null) {
      this.node27 = '';
    } else this.node27 = this.nodeValues[25];

    if (this.nodeValues[26] === undefined || this.nodeValues[26] === '' || this.nodeValues[26] === null) {
      this.node28 = '';
    } else this.node28 = this.nodeValues[26];

    if (this.nodeValues[27] === undefined || this.nodeValues[27] === '' || this.nodeValues[27] === null) {
      this.node29 = '';
    } else this.node29 = this.nodeValues[27];

    if (this.nodeValues[28] === undefined || this.nodeValues[28] === '' || this.nodeValues[28] === null) {
      this.node30 = '';
    } else this.node30 = this.nodeValues[28];

    if (this.nodeValues[29] === undefined || this.nodeValues[29] === '' || this.nodeValues[29] === null) {
      this.node31 = '';
    } else this.node31 = this.nodeValues[29];

    if (this.nodeValues[30] === undefined || this.nodeValues[30] === '' || this.nodeValues[30] === null) {
      this.node32 = '';
    } else this.node32 = this.nodeValues[30];


    this.onChangeSysLocation();
  }


  onChangeSysLocation() {

    if (this.locationInfoForm.value.mapPageNumber !== undefined && this.locationInfoForm.value.mapPageNumber !== null) {
      this.mapNumber = this.locationInfoForm.value.mapPageNumber;
    }

    if (this.locationInfoForm.value.latitude !== undefined && this.locationInfoForm.value.latitude !== null) {
      this.gpsLatitude = this.locationInfoForm.value.latitude;
    }

    if (this.locationInfoForm.value.longitude !== undefined && this.locationInfoForm.value.longitude !== null) {
      this.gpsLongitude = this.locationInfoForm.value.longitude;
    }

    if (this.locationInfoForm.value.powerNode !== undefined && this.locationInfoForm.value.powerNode !== null) {
      this.powersNode = this.locationInfoForm.value.powerNode;
    }

    if (this.locationInfoForm.value.spLocDetails !== undefined && this.locationInfoForm.value.spLocDetails !== null) {
      this.desc = this.locationInfoForm.value.spLocDetails.trim();
    }
    if (this.locationInfoForm.value.businessPartnerRestriction !== undefined && this.locationInfoForm.value.businessPartnerRestriction !== null) {
      this.businessPartnerRestriction = this.locationInfoForm.value.businessPartnerRestriction;
      if (this.locationInfoForm.value.businessPartnerRestriction === "Other") {

        this.locationInfoForm.controls["locationComments"].setValidators(Validators.required);
        this.locationInfoForm.controls["locationComments"].updateValueAndValidity();
      }
      else {
        this.locationInfoForm.controls["locationComments"].clearValidators();
        this.locationInfoForm.controls["locationComments"].updateValueAndValidity();

      }
    }
    if (this.transponderInfoForm.value.priority !== undefined && this.transponderInfoForm.value.priority !== null) {
      this.priority = this.transponderInfoForm.value.priority.trim();
    }
    this.sysLocation = "NODES#" + this.nodeName + "-" + this.node2 + "-" + this.node3 + "-" + this.node4 + "-" + this.node5 + "_MAP#" + this.mapNumber + "_LAT#" + this.gpsLatitude + "_LONG#" + this.gpsLongitude + "_DETAILS#" + this.desc + "_RUNS NODE#" + this.powersNode + "_PRIORITY " + this.priority;




  }
  locationInfoFormstatus;
  onChangeSysContact() {
    if (this.locationInfoForm.value.pole !== undefined && this.locationInfoForm.value.pole !== null) {
      this.poleNumber = this.locationInfoForm.value.pole;
    }
    if (this.locationInfoForm.value.houseNumberInput !== undefined && this.locationInfoForm.value.houseNumberInput !== null) {
      this.houseNumber = this.locationInfoForm.value.houseNumberInput;
    }
    if (this.locationInfoForm.value.street !== undefined && this.locationInfoForm.value.street !== null) {
      this.street = this.locationInfoForm.value.street;
    }
    if (this.locationInfoForm.value.crossStreet !== undefined && this.locationInfoForm.value.crossStreet !== null) {
      this.crossStreet = this.locationInfoForm.value.crossStreet;
    }
    if (this.locationInfoForm.value.city !== undefined && this.locationInfoForm.value.city !== null) {
      this.city = this.locationInfoForm.value.city;
    }
    if (this.locationInfoForm.value.state !== undefined && this.locationInfoForm.value.state !== null) {
      if (this.locationInfoForm.value.state != this.state) {
        this.standByOptions = [];
        if(this.locationInfoForm.value.state != 'CA' && this.transponderInfoForm.value.standByOpts == 'CPUC - StandBy')
          this.transponderInfoForm.controls.standByOpts.setValue('');
        this.powerSupplyService.getStandByOptionsByState(this.locationInfoForm.value.state).subscribe(res => {
          res.forEach(result => this.standByOptions.push(result.standbyOptions));
        });
      }
      this.state = this.locationInfoForm.value.state;
      if((this.nodeName != '' || this.nodeName != null) && this.state != ''){
        this.powerSupplyService.getNWTTeams(this.nodeName,this.state).subscribe(resultdata => {
          this.nwtTeamData = resultdata['nwtTeam'];
          this.locationInfoForm.controls['nwtTeam'].patchValue(this.nwtTeamData);
        });
      }
    }
    if (this.region == 'Boston Region') {
      if (this.crossStreet !== '') {
        this.sysContact = "POLE#" + this.poleNumber + "_" + this.houseNumber + " " + this.street + " X " + this.crossStreet + "_" + this.city + ", " + this.state;
      }
      else this.sysContact = "POLE#" + this.poleNumber + "_" + this.houseNumber + " " + this.street + "_" + this.city + ", " + this.state;
    } else this.sysContact = this.houseNumber + " " + this.street + " X " + this.crossStreet + "_" + this.city + ", " + this.state;
  }

  onChangePowerSupplyNum() {
    let psn = '';
    if (this.transponderInfoForm.value.powerSupplyNum !== ''
      && this.transponderInfoForm.value.powerSupplyNum !== undefined
      && this.transponderInfoForm.value.powerSupplyNum !== null) {
      psn = '-' + this.transponderInfoForm.value.powerSupplyNum.trim();
    }
    if (psn === '') psn = '-' + '';
    this.powerSupplyName = this.basePowerSupplyName + psn;
  }

  selectNext(index) {
    index.selectedIndex += 1;
  }

  checkValidProfile(): boolean{
    return this.telemetryThresholdProfileData.includes(this.powerSupplyAlertProfile);
  }

  selectedTabIndex = 0;
  //PUT Call
  save() {

    let cat1 = localStorage.getItem('cat1')
    let cat2 = localStorage.getItem('cat2')
    let cat3 = localStorage.getItem('cat3')
    let cat4 = localStorage.getItem('cat4')
    let cat5 = localStorage.getItem('cat5')
    let cat6 = localStorage.getItem('cat6')
    let cat7 = localStorage.getItem('cat7')
    let cat8 = localStorage.getItem('cat8')
    let cat9 = localStorage.getItem('cat9')
    let cat10 = localStorage.getItem('cat10')
    let cat11 = localStorage.getItem('cat11')
    if(cat1 != null || cat2 != null || cat3 != null || cat4 != null || cat5 != null
    || cat6 != null || cat7 != null || cat8 != null || cat9 != null || cat10 != null
    || cat11 != null ){
      this.submitFlag = true;
    }
    this.ref.markForCheck();
    //show dialog and tab for reminding the user
    let event = this.lastVisitInfoForm.value.typeOfVisit;
    if (event == 'Annual Inspection' || event == 'Maintenance' || event == 'Repair') {
      if (this.reminderflag == 0) {
        this.selectedTabIndex = 3;
        this.reminderflag = 1;
        this.data.editsaveEnabledMessage('locform', "false");
        this.openDialog("Please make sure the Last Visit Info has latest value before saving");
        return false;
      }
    }
    if(event == 'Annual Inspection'){
      if(this.filearray.length < 11){
        this.data.editsaveEnabledMessage('locform', "false");
        this.openDialog("Please make sure to upload all categories latest Power Supply image before saving");
        return false;
      }
    }

    if (!this.checkValidProfile()) {
      this.transponderInfoForm.patchValue({
        acInputVoltage: null,
        acOutputVoltage: null,
        currentAmp: null,
        //currentAmpOutput: null
      });
      this.powerSupplyAlertProfile = '';
      let errMessage = "Power Supply Alert Profile is Invalid.";
      this.openDialog(errMessage);
      return false;
    }
    this.showProgressspinner = true;
    const powerSupply: PowerSupply = {};
    const node: Node = {};
    powerSupply.powerSupplyName = this.powerSupplyName;
    //Location Info
    powerSupply.houseNumber = this.locationInfoForm.value.houseNumberInput;
    powerSupply.powerSupplyAddress = this.locationInfoForm.value.street;
    powerSupply.crossStreet = this.locationInfoForm.value.crossStreet;
    powerSupply.city = this.locationInfoForm.value.city;
    powerSupply.state = this.locationInfoForm.value.state;
    powerSupply.zip = this.locationInfoForm.value.zip;
    powerSupply.feedsMultipleNodes = this.locationInfoForm.value.mutliNodes;
    if (this.nodesForms.at(0) != null) {
      powerSupply.node2 = this.nodesForms.at(0).get('node').value;
      powerSupply.node2_id = this.node2_id;
    }
    if (this.nodesForms.at(1) != null) {
      powerSupply.node3 = this.nodesForms.at(1).get('node').value;
      powerSupply.node3_id = this.node3_id;
    }
    if (this.nodesForms.at(2) != null) {
      powerSupply.node4 = this.nodesForms.at(2).get('node').value;
      powerSupply.node4_id = this.node4_id;
    }
    if (this.nodesForms.at(3) != null) {
      powerSupply.node5 = this.nodesForms.at(3).get('node').value;
      powerSupply.node5_id = this.node5_id;
    }
    if (this.nodesForms.at(4) != null) {
      powerSupply.node6 = this.nodesForms.at(4).get('node').value;
      powerSupply.node6_id = this.node6_id;
    }
    if (this.nodesForms.at(5) != null) {
      powerSupply.node7 = this.nodesForms.at(5).get('node').value;
      powerSupply.node7_id = this.node7_id;
    }
    if (this.nodesForms.at(6) != null) {
      powerSupply.node8 = this.nodesForms.at(6).get('node').value;
      powerSupply.node8_id = this.node8_id;
    }
    if (this.nodesForms.at(7) != null) {
      powerSupply.node9 = this.nodesForms.at(7).get('node').value;
      powerSupply.node9_id = this.node9_id;
    }
    if (this.nodesForms.at(8) != null) {
      powerSupply.node10 = this.nodesForms.at(8).get('node').value;
      powerSupply.node10_id = this.node10_id;
    }
    if (this.nodesForms.at(9) != null) {
      powerSupply.node11 = this.nodesForms.at(9).get('node').value;
      powerSupply.node11_id = this.node11_id;
    }
    if (this.nodesForms.at(10) != null) {
      powerSupply.node12 = this.nodesForms.at(10).get('node').value;
      powerSupply.node12_id = this.node12_id;
    }
    if (this.nodesForms.at(11) != null) {
      powerSupply.node13 = this.nodesForms.at(11).get('node').value;
      powerSupply.node13_id = this.node13_id;
    }
    if (this.nodesForms.at(12) != null) {
      powerSupply.node14 = this.nodesForms.at(12).get('node').value;
      powerSupply.node14_id = this.node14_id;
    }
    if (this.nodesForms.at(13) != null) {
      powerSupply.node15 = this.nodesForms.at(13).get('node').value;
      powerSupply.node15_id = this.node15_id;
    }

      if (this.nodesForms.at(14) != null) {
        powerSupply.node16 = this.nodesForms.at(14).get('node').value;
        powerSupply.node16_id = this.node16_id;
      }
      if (this.nodesForms.at(15) != null) {
        powerSupply.node17 = this.nodesForms.at(15).get('node').value;
        powerSupply.node17_id = this.node17_id;
      }
      if (this.nodesForms.at(16) != null) {
        powerSupply.node18 = this.nodesForms.at(16).get('node').value;
        powerSupply.node18_id = this.node18_id;
      }
      if (this.nodesForms.at(17) != null) {
        powerSupply.node19 = this.nodesForms.at(17).get('node').value;
        powerSupply.node19_id = this.node19_id;
      }
      if (this.nodesForms.at(18) != null) {
        powerSupply.node20 = this.nodesForms.at(18).get('node').value;
        powerSupply.node20_id = this.node20_id;
      }
      if (this.nodesForms.at(19) != null) {
        powerSupply.node21 = this.nodesForms.at(19).get('node').value;
        powerSupply.node21_id = this.node21_id;
      }
      if (this.nodesForms.at(20) != null) {
        powerSupply.node22 = this.nodesForms.at(20).get('node').value;
        powerSupply.node22_id = this.node22_id;
      }
      if (this.nodesForms.at(21) != null) {
        powerSupply.node23 = this.nodesForms.at(21).get('node').value;
        powerSupply.node23_id = this.node23_id;
      }
      if (this.nodesForms.at(22) != null) {
        powerSupply.node24 = this.nodesForms.at(22).get('node').value;
        powerSupply.node24_id = this.node24_id;
      }
      if (this.nodesForms.at(23) != null) {
        powerSupply.node25 = this.nodesForms.at(23).get('node').value;
        powerSupply.node25_id = this.node25_id;
      }
      if (this.nodesForms.at(24) != null) {
        powerSupply.node26 = this.nodesForms.at(24).get('node').value;
        powerSupply.node26_id = this.node26_id;
      }
      if (this.nodesForms.at(25) != null) {
        powerSupply.node27 = this.nodesForms.at(25).get('node').value;
        powerSupply.node27_id = this.node27_id;
      }
      if (this.nodesForms.at(26) != null) {
        powerSupply.node28 = this.nodesForms.at(26).get('node').value;
        powerSupply.node28_id = this.node28_id;
      }
      if (this.nodesForms.at(27) != null) {
        powerSupply.node29 = this.nodesForms.at(27).get('node').value;
        powerSupply.node29_id = this.node29_id;
      }
      if (this.nodesForms.at(28) != null) {
        powerSupply.node30 = this.nodesForms.at(28).get('node').value;
        powerSupply.node30_id = this.node30_id;
      }
      if (this.nodesForms.at(29) != null) {
        powerSupply.node31 = this.nodesForms.at(29).get('node').value;
        powerSupply.node31_id = this.node31_id;
      }
      if (this.nodesForms.at(30) != null) {
        powerSupply.node32 = this.nodesForms.at(30).get('node').value;
        powerSupply.node32_id = this.node32_id;
      }

    powerSupply.gpsLatitude = Number(this.locationInfoForm.value.latitude);
    powerSupply.gpsLongitude = Number(this.locationInfoForm.value.longitude);
    //powerSupply.calculatedRuntime = this.locationInfoForm.value.calculatedRuntime;
    powerSupply.powersNode = this.locationInfoForm.value.powerNode;
    powerSupply.specialLocationDetails = this.locationInfoForm.value.spLocDetails;
    powerSupply.aerialUnderground = this.locationInfoForm.value.areial;
    powerSupply.powerAccountType = this.locationInfoForm.controls['powerAccountType'].value;
    powerSupply.poleNumber = this.locationInfoForm.value.pole;
    powerSupply.utilityProvider = this.locationInfoForm.controls['powerCompany'].value;
    powerSupply.companyAccountNumber = this.locationInfoForm.controls['companyAccNum'].value;
    powerSupply.powerCompanyContactNumber = this.locationInfoForm.controls['companyContact'].value;
    powerSupply.powerCompanyWebsite = this.locationInfoForm.controls['companyWebsite'].value;
    //powerSupply.nwtTeam = this.locationInfoForm.value.nwtTeam;
    powerSupply.nwtTeam = this.nwtTeamData;
    powerSupply.nitroReasonNotCompleted = this.locationInfoForm.value.nitroReasonNotCompleted;
    powerSupply.nitroCompletionDate = this.locationInfoForm.value.nitroCompletionDate;
    powerSupply.electricMeterNumber = this.locationInfoForm.controls['meter'].value;
    powerSupply.mapNumber = this.locationInfoForm.value.mapPageNumber;
    powerSupply.locationComments = this.locationInfoForm.value.locationComments;
    powerSupply.businessPartnerRestriction = this.locationInfoForm.value.businessPartnerRestriction;
    //Transponder Info
    powerSupply.powerSupplyType = this.transponderInfoForm.value.standByOpts;
    powerSupply.macAddress = this.transponderInfoForm.value.activeMacAddress;
    powerSupply.macAddressPrevious = this.transponderInfoForm.controls['prevMacAddress'].value;
    powerSupply.ip = this.transponderInfoForm.value.ip;
    powerSupply.powerSupplyNumber = this.transponderInfoForm.value.powerSupplyNum;
    powerSupply.nextGenNode = this.transponderInfoForm.value.nextGenNode;
    powerSupply.transponderVendor = this.transponderInfoForm.value.transponderVendor;
    powerSupply.transponderModel = this.transponderInfoForm.value.transponderModel;
    powerSupply.powerSupplyModel = this.transponderInfoForm.value.powerSupplyModel;
    powerSupply.acInputVoltage = this.transponderInfoForm.value.acInputVoltage;
    powerSupply.outputVoltage = this.transponderInfoForm.value.acOutputVoltage;
    powerSupply.inputCurrent = this.transponderInfoForm.value.currentAmp;
    //powerSupply.currentAmpOutput = this.transponderInfoForm.value.currentAmpOutput;
    powerSupply.serialNumber = this.transponderInfoForm.value.serialNum;
    //powerSupply.controllerCardType = this.transponderInfoForm.value.controlledCardType;
    powerSupply.dcReady = this.transponderInfoForm.value.dcReady;
    powerSupply.priority = this.transponderInfoForm.value.priority;
    powerSupply.egisName = this.transponderInfoForm.controls['egisName'].value;
    powerSupply.externalSensor = this.transponderInfoForm.controls['externalSensor'].value;
    powerSupply.globalId = this.transponderInfoForm.controls['globalidentifier'].value;
    powerSupply.transponderComments = this.transponderInfoForm.value.transponderComments;
    if (this.transponderInfoForm.value.powerSupplyType9360 !== null && this.transponderInfoForm.value.powerSupplyType9360 !== undefined) powerSupply.powerSupplyType9360 = this.transponderInfoForm.value.powerSupplyType9360.id;

    //BatteryInfo
    powerSupply.numberOfBatteries = this.batteryInfoForm.value.numberofBatteries;
    powerSupply.batteriesReplaced = this.batteryInfoForm.value.batteriesReplaced;
    //powerSupply.airTemperature = this.batteryInfoForm.value.airTemperature;
    powerSupply.batteryBalancerString = this.batteryInfoForm.value.batteryManagerModel;
    powerSupply.batteryComments = this.batteryInfoForm.value.batteryComments;

    let preArray: any = [];
    let battArray: Array<number> = [];
    let k = 0;
    for (let i = 0; i < this.batteryStringForms.length; i++) {
      if (i == 0) {
        //powerSupply.batteryBalancerString1 = this.batteryStringForms.value[0].batteryManagerModel;
        //powerSupply.batterySeparatorPresent14 = this.batteryStringForms.value[0].batterySeparator;
      } else if (i == 1) {
        //powerSupply.batteryBalancerString2 = this.batteryStringForms.value[0].batteryManagerModel;
        //powerSupply.batterySeparatorPresent24 = this.batteryStringForms.value[0].batterySeparator;
      } else if (i == 2) {
        //powerSupply.batteryBalancerString3 = this.batteryStringForms.value[0].batteryManagerModel;
        //powerSupply.batterySeparatorPresent34 = this.batteryStringForms.value[0].batterySeparator;
      } else if (i == 3) {
        //powerSupply.batteryBalancerString4 = this.batteryStringForms.value[0].batteryManagerModel;
        //powerSupply.batterySeparatorPresent44 = this.batteryStringForms.value[0].batterySeparator;
      } else if (i == 4) {
        //powerSupply.batteryBalancerString5 = this.batteryStringForms.value[0].batteryManagerModel;
        //powerSupply.batterySeparatorPresent54 = this.batteryStringForms.value[0].batterySeparator;
      } else if (i == 5) {
        //powerSupply.batteryBalancerString6 = this.batteryStringForms.value[0].batteryManagerModel;
        //powerSupply.batterySeparatorPresent64 = this.batteryStringForms.value[0].batterySeparator;
      }
    }
    for (let i = 0; i < this.prvString; i++) {
      for (let j = 0; j < this.prvBattery; j++)
        preArray.push(i + '' + j)
    }
    //Logic for Parallel Batteries for Create PS
      let battStringCount = 1;
      let parallelBattsInString = 6;
      if (this.parallelBatt) {
        for (let i = 0; i < battStringCount; i++) {
          for (let j = 0; j < parallelBattsInString; j++) {
            if (preArray.includes(i + '' + j)) {
              battArray.push(1);
            }
            else battArray.push(0);
          }
        }
        if (battArray[0] == 1) {
          powerSupply.type11 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial11 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate11 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage11 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload11 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance11 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected11 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString11 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate11 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[1] == 1) {
          powerSupply.type12 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial12 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate12 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage12 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload12 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance12 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected12 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString12 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate12 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[2] == 1) {
          powerSupply.type13 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial13 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate13 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage13 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload13 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance13 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected13 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate13 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[3] == 1) {
          powerSupply.type14 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial14 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate14 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage14 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload14 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance14 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected14 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate14 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[4] == 1) {
          powerSupply.type15 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial15 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate15 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage15 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload15 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance15 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected15 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          //powerSupply.totalVoltageString15 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate15 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[5] == 1) {
          powerSupply.type16 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial16 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate16 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage16 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload16 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance16 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected16 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          //powerSupply.totalVoltageString16 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate16 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }

      }
      else {
        for (let i = 0; i < 6; i++) {
          for (let j = 0; j < 4; j++) {
            if (preArray.includes(i + '' + j)) {
              battArray.push(1);
            }
            else battArray.push(0);
          }
        }
        if (battArray[0] == 1) {
          powerSupply.type11 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial11 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate11 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage11 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload11 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance11 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected11 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString11 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate11 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[1] == 1) {
          powerSupply.type12 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial12 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate12 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage12 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload12 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance12 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected12 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString12 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate12 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[2] == 1) {
          powerSupply.type13 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial13 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate13 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage13 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload13 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance13 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected13 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate13 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[3] == 1) {
          powerSupply.type14 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial14 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate14 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage14 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload14 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance14 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected14 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate14 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[4] == 1) {
          powerSupply.type21 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial21 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate21 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage21 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload21 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance21 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected21 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString21 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate21 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[5] == 1) {
          powerSupply.type22 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial22 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate22 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage22 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload22 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance22 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected22 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString22 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate22 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[6] == 1) {
          powerSupply.type23 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial23 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate23 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage23 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload23 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance23 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected23 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate23 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[7] == 1) {
          powerSupply.type24 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial24 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate24 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage24 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload24 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance24 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected24 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate24 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[8] == 1) {
          powerSupply.type31 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial31 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate31 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage31 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload31 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance31 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected31 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString31 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate31 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[9] == 1) {
          powerSupply.type32 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial32 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate32 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage32 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload32 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance32 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected32 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString32 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate32 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[10] == 1) {
          powerSupply.type33 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial33 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate33 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage33 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload33 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance33 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected33 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate33 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[11] == 1) {
          powerSupply.type34 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial34 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate34 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage34 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload34 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance34 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected34 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate34 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[12] == 1) {
          powerSupply.type41 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial41 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate41 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage41 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload41 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance41 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected41 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString41 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate41 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[13] == 1) {
          powerSupply.type42 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial42 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate42 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage42 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload42 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance42 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected42 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString42 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate42 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[14] == 1) {
          powerSupply.type43 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial43 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate43 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage43 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload43 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance43 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected43 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate43 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[15] == 1) {
          powerSupply.type44 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial44 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate44 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage44 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload44 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance44 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected44 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate44 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[16] == 1) {
          powerSupply.type51 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial51 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate51 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage51 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload51 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance51 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected51 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring51 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate51 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[17] == 1) {
          powerSupply.type52 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial52 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate52 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage52 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload52 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance52 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected52 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring52 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate52 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[18] == 1) {
          powerSupply.type53 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial53 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate53 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage53 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload53 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance53 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected53 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring53 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate53 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[19] == 1) {
          powerSupply.type54 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial54 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate54 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage54 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload54 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance54 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected54 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring54 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate54 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[20] == 1) {
          powerSupply.type61 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial61 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate61 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage61 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload61 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance61 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected61 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring61 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate61 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[21] == 1) {
          powerSupply.type62 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial62 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate62 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage62 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload62 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance62 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected62 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring62 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate62 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[22] == 1) {
          powerSupply.type63 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial63 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate63 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage63 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload63 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance63 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected63 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring63 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate63 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[23] == 1) {
          powerSupply.type64 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial64 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate64 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage64 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload64 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance64 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected64 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring64 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate64 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
      }
    //LastVistInfo
    if (this.lastVisitInfoForm.value.inspectionDate !== '' && this.lastVisitInfoForm.value.inspectionDate !== null && this.lastVisitInfoForm.value.inspectionDate !== undefined) {
      const date = new Date(this.lastVisitInfoForm.value.inspectionDate);
      powerSupply.inspectionDate = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
    }
    powerSupply.typeOfVisit = this.lastVisitInfoForm.value.typeOfVisit;
    //powerSupply.xocVerified = this.lastVisitInfoForm.value.xocVerified;
    powerSupply.xocVerified = (this.SaveFlag) ? "Yes" : '';
    powerSupply.visitStatus = this.lastVisitInfoForm.value.visitStatus;
    powerSupply.followUpReason = (this.lastVisitInfoForm.value.followUpReasons) ? this.lastVisitInfoForm.value.followUpReasons : this.followUpActionData;
    powerSupply.cleanEnclosure = this.lastVisitInfoForm.value.cleanDust;
    powerSupply.tightenHardware = this.lastVisitInfoForm.value.tightenAll;
    //powerSupply.inspectConnectors = this.lastVisitInfoForm.value.inspectWire;
    powerSupply.inspectConnectors = (this.SaveFlag) ? "Yes" : '';
    //powerSupply.inspectProbes = this.lastVisitInfoForm.value.inspectBattery;
    powerSupply.inspectProbes = (this.SaveFlag) ? "Yes" : '';
    powerSupply.meterPanCondition = this.lastVisitInfoForm.value.meterPan;
    //powerSupply.powerCoRiserCondition = this.lastVisitInfoForm.value.powerCo;
    powerSupply.powerCoRiserCondition = (this.SaveFlag) ? "Good" : '';
    // powerSupply.batteryHeaterMatType = this.lastVisitInfoForm.value.batteryHeaterType;
    // powerSupply.batteryHeaterMatQuantity = this.lastVisitInfoForm.value.batteryHeaterQuantity;
    // powerSupply.enclosureSnowShield = this.lastVisitInfoForm.value.encloseSnow;
    // powerSupply.internalBreaker = this.lastVisitInfoForm.value.internalBreaker;
    // powerSupply.serviceEntrance = this.lastVisitInfoForm.value.serviceEntrance;
    powerSupply.serviceEntrance = '';
    powerSupply.receptacleType = this.lastVisitInfoForm.value.receptacleType;
    //powerSupply.checkSeizureAltBox = this.lastVisitInfoForm.value.checkSeizure;
    powerSupply.checkSeizureAltBox = (this.SaveFlag) ? "Ok" : '';
    //powerSupply.powerSupplyIdLegible = this.lastVisitInfoForm.value.psIDLegibile;
     powerSupply.powerSupplyIdLegible = (this.SaveFlag) ? "Yes": '';
    //powerSupply.checkLampsLeds = this.lastVisitInfoForm.value.checkLamps;
    powerSupply.checkLampsLeds = (this.SaveFlag) ? "Ok" : '';
    //powerSupply.checkMagneticBreaker = this.lastVisitInfoForm.value.checkCircuitBreaker;
    powerSupply.checkMagneticBreaker = (this.SaveFlag) ? "Ok": '';
    powerSupply.visualCabinetInspection = (this.SaveFlag) ? "Ok" : '';
    powerSupply.cabinetLocked = this.lastVisitInfoForm.value.cabinetLocked;
    //powerSupply.securityBarPresent = this.lastVisitInfoForm.value.securityBar;
    powerSupply.checkGroundCabinet = this.lastVisitInfoForm.value.checkGround;

    // powerSupply.batteryString1Fused = this.lastVisitInfoForm.value.batteryStringFused1;
    // powerSupply.batteryString2Fused = this.lastVisitInfoForm.value.batteryStringFused2;
    // powerSupply.batteryString3Fused = this.lastVisitInfoForm.value.batteryStringFused3;
    // powerSupply.batteryString4Fused = this.lastVisitInfoForm.value.batteryStringFused4;
    // powerSupply.batteryString5Fused = this.lastVisitInfoForm.value.batteryStringFused5;
    // powerSupply.batteryString6Fused = this.lastVisitInfoForm.value.batteryStringFused6;
    powerSupply.tamperInstalledFunctioning = this.lastVisitInfoForm.value.tamperInstalled;
    //powerSupply.checkLaps = this.lastVisitInfoForm.value.checkLaps;
    powerSupply.checkLaps = (this.SaveFlag) ? "Ok" : '';
    powerSupply.cabinetVendor = this.lastVisitInfoForm.value.cabinetVendor;
    powerSupply.cabinetBatteryCapacity = this.lastVisitInfoForm.value.cabinetBattery;
    //powerSupply.checkOperatingLights = this.lastVisitInfoForm.value.checkOperating;
    powerSupply.checkOperatingLights = (this.SaveFlag) ? "Ok" : '';

    //powerSupply.followUpNeeded = this.lastVisitInfoForm.value.followUp;
    powerSupply.inputSurgeArrestor = this.lastVisitInfoForm.value.inputSurge;
    powerSupply.outputSurgeArrestor = this.lastVisitInfoForm.value.outputSurge;
    // powerSupply.coaxTvssPresent = this.lastVisitInfoForm.value.coaxTvss;
    powerSupply.localRemoteIndicator = (this.SaveFlag) ? "Yes" : '';

    powerSupply.acIndicatorGreenLight  = (this.SaveFlag) ? "Ok" : '';
    // powerSupply.localRemoteIndicator = this.lastVisitInfoForm.value.lri;
    powerSupply.comments = this.lastVisitInfoForm.value.lastVisitComments;

    //misc
    powerSupply.nodeId = this.editPowerSupply.nodeId;
    powerSupply.powerSupplyName = this.powerSupplyName;
    this.nodesServed = this.nodeName;
    for (let i = 0; i < this.nodeValues.length; i++) {
      if (this.nodeValues[i] !== undefined) {
        if (this.nodeValues[i] !== null && this.nodeValues[i] !== '' && this.nodesServed !== '') {
          this.nodesServed = this.nodesServed.concat(' ', this.nodeValues[i]);
        }
        else {
          this.nodesServed = this.nodesServed.concat(this.nodeValues[i]);
        }
      }
    }
    if (this.nodesServed !== null || this.nodesServed !== '') {
      powerSupply.nodesServed = this.nodesServed;
    }

    powerSupply.powerSupplyId = this.powerSupplyId;
    powerSupply.alertProfile = this.powerSupplyAlertProfile;
    powerSupply.alertProfileException = this.powerSupplyAlertProfile;
    powerSupply.psAlertProfile = this.powerSupplyAlertProfile;
    powerSupply.sysLocation = this.sysLocation;
    powerSupply.sysContact = this.sysContact;
    powerSupply.logDate = new Date().toISOString();
    powerSupply.dateEntered = new Date().toISOString();
    powerSupply.logNt = this.authService.getUserDetails.userName;
    if (this.authService.getUserDetails.lastName && this.authService.getUserDetails.firstName) {
      powerSupply.logName = this.authService.getUserDetails.lastName + ', ' + this.authService.getUserDetails.firstName;
      powerSupply.commTech = this.authService.getUserDetails.lastName + ', ' + this.authService.getUserDetails.firstName;
    } else {
      powerSupply.logName = this.msalService.instance?.getActiveAccount()?.name;
      powerSupply.commTech = powerSupply.logName;
    }
    node.name = this.nodeName;
    powerSupply.node = node;
    powerSupply.nodeName = this.nodeName;

    if (this.transponderInfoForm.value.powerSupplyNum === '001') {
      powerSupply.deviceId = '1';
    }
    else if (this.transponderInfoForm.value.powerSupplyNum === '002') {
      powerSupply.deviceId = '2';
    }
    else if (this.transponderInfoForm.value.powerSupplyNum === '003') {
      powerSupply.deviceId = '3';
    }
    else if (this.transponderInfoForm.value.powerSupplyNum === '004') {
      powerSupply.deviceId = '4';
    }
    else if (this.transponderInfoForm.value.powerSupplyNum === '005') {
      powerSupply.deviceId = '5';
    }

    if (this.userDetails.permissions.includes('{1091}')) {
      this.permissionValue = true;
    }else{
      this.permissionValue = false;
    }
    if(powerSupply.typeOfVisit && powerSupply.typeOfVisit.indexOf('Cert Required') !== -1){
      this.certRequiredValue = true;
    }else{
      this.certRequiredValue = false;
    }
    //1091 permission will go normal ps edit otherwise it will go triage table
    if (this.permissionValue) {
      //For Certification save only if the user select the type of visit is cert required
      // if ((powerSupply.typeOfVisit == 'Preventive Maintenance/Certification (Cert Required)'
      //   || powerSupply.typeOfVisit == 'Device Upgrade (Cert Required)'
      //   || powerSupply.typeOfVisit == 'Alarm (Cert Required)'
      //   || powerSupply.typeOfVisit == 'Other (Cert Required)'
      //   || powerSupply.typeOfVisit == 'Return Visit') && powerSupply.powerSupplyType == 'Built In Generator') {
      if((this.certRequiredValue || powerSupply.typeOfVisit == 'Return Visit') && powerSupply.powerSupplyType == 'Built In Generator'){
        this.saveApuChanges();
        this.saveApuVisitChanges();
        this.saveCertification(powerSupply);
      }
      // else if ((powerSupply.typeOfVisit == 'Preventive Maintenance/Certification (Cert Required)'
      //   || powerSupply.typeOfVisit == 'Device Upgrade (Cert Required)'
      //   || powerSupply.typeOfVisit == 'Alarm (Cert Required)'
      //   || powerSupply.typeOfVisit == 'Other (Cert Required)'
      //   || powerSupply.typeOfVisit == 'Return Visit') && powerSupply.powerSupplyType != 'Built In Generator') {
      else if((this.certRequiredValue || powerSupply.typeOfVisit == 'Return Visit') && powerSupply.powerSupplyType != 'Built In Generator'){
        this.saveCertification(powerSupply);
      }
      // else if ((powerSupply.typeOfVisit != 'Preventive Maintenance/Certification (Cert Required)'
      //   && powerSupply.typeOfVisit != 'Device Upgrade (Cert Required)'
      //   && powerSupply.typeOfVisit != 'Alarm (Cert Required)'
      //   && powerSupply.typeOfVisit != 'Other (Cert Required)'
      //   && powerSupply.typeOfVisit != 'Return Visit') && powerSupply.powerSupplyType == 'Built In Generator') {
      else if((!this.certRequiredValue || powerSupply.typeOfVisit != 'Return Visit') && powerSupply.powerSupplyType == 'Built In Generator'){
        this.saveApuChanges();
        //this.saveApuChangesCertification();
      }
      //Post call  - for Comcast user
      this.showProgressspinner = true;
      this.powerSupplyService.savePowerSupply(powerSupply)
        .subscribe(result => {
          if (result.success === true) {
            this.psSuccessMsg = result.success;
            this.genomeMsg = result.message;
            const activity = 'PowerSupply Edit Save';
            const message = `PowerSupply Edit Save Success. MAC Address: ${this.macAddress}`;
            this.commonService.loggerPost(message, activity, 3);
          } else {
            const activity = 'PowerSupply Edit Save - Error';
            const message = `PowerSupply Edit Save Error. Error: ${result.message}. MAC Address: ${this.macAddress}`;
            this.commonService.loggerPost(message, activity, 5);
          }
          if (result.success === true){
            //if any changes or upload in the file section
            if ((this.file !== null && this.file !== undefined) || this.submitFlag) {
              if(this.submitFlag){
                this.filearray = JSON.parse(localStorage.getItem('filearray'));
                console.log(this.filearray);
              }
              //this.psFileUpload(powerSupply);
              let imageRequest : ImageMetaDataUpdateRequest;
              var categoryValue = [];
              for (let i = 0; i < this.filearray.length; i++) {
                categoryValue.push(this.filearray[i]['id']);
              }
              imageRequest = {
                triageId: null,
                powerSupplyId : powerSupply.powerSupplyId,
                macAddress: powerSupply.macAddress,
                categories: categoryValue,
                actionType: 'Edit'
              };
              this.powerSupplyService.updatePSIDAndTriageIDByMacAndCategory(imageRequest).subscribe(res => {
                if (res.success === true) {
                  const activity = 'PowerSupply Image PSID & TriageID Update';
                  const message = `PowerSupply Image PSID & TriageID Update Success. PowerSupply Image Category Data: ${JSON.stringify(categoryValue)}`;
                  this.commonService.loggerPost(message, activity, 3);
                  this.showProgressBar = false;
                  this.psSuccessMsg = res.success;
                  this.openSavedDialog(this.powerSupplyName);
                  //once ps created removed all the picture in local storage
                  this.removePictureStorage();
                } else {
                  const activity = 'PowerSupply Image PSID & TriageID Update';
                  const message = `PowerSupply Image PSID & TriageID Update Error. Error: ${res.message}. PowerSupply Image Category Data: ${JSON.stringify(categoryValue)}`;
                  this.commonService.loggerPost(message, activity, 5);
                  this.showProgressBar = false;
                  this.openErrorDialog("Something went wrong. Please try later !!");
                }
              }, err => {
                this.showProgressBar = false;
                this.openErrorDialog("Something went wrong. Please try later !!");
              });
            } else {
              this.showProgressspinner = false;
              this.openSavedDialog(this.powerSupplyName);
            }
          } else if (result.success === false && result.message) {
            this.showProgressspinner = false;
            this.openErrorDialog(result.message);
            this.ref.detectChanges();
            //button enabled for save
            this.data.editsaveEnabledMessage('locform', "false");
          } else {
            this.showProgressspinner = false;
            this.openErrorDialog("Something went wrong. Please try later !!");
          }
        }, err => {
          this.showProgressspinner = false;
          this.openErrorDialog("Something went wrong. Please try later !!");
        });
    } else {
      this.showProgressspinner = true;
      //copy the ps object into pstriage
      let PowerSupplyTriage = JSON.parse(JSON.stringify(powerSupply))
      PowerSupplyTriage.phoneNo = this.lastVisitInfoForm.value.mobileno;
      this.powerSupplyService.editPowerSupplyForNonComcastUsers(PowerSupplyTriage)
        .subscribe(result => {
          if (result.responseStatus.success === true) {
              if(powerSupply.typeOfVisit && powerSupply.typeOfVisit.indexOf('Cert Required') !== -1){
                this.certRequiredValue = true;
              }else{
                this.certRequiredValue = false;
              }
            const activity = 'PowerSupply Edit Save';
            const message = `PowerSupply Edit Save Success. MAC Address: ${this.macAddress}`;
            this.commonService.loggerPost(message, activity, 3);
          } else {
            const activity = 'PowerSupply Edit Save - Error';
            const message = `PowerSupply Edit Save Error. Error: ${result.responseStatus.message}. MAC Address: ${this.macAddress}`;
            this.commonService.loggerPost(message, activity, 5);
          }

          if (result.responseStatus.success === true) {
            // if ((powerSupply.typeOfVisit == 'Preventive Maintenance/Certification (Cert Required)'
            //   || powerSupply.typeOfVisit == 'Device Upgrade (Cert Required)'
            //   || powerSupply.typeOfVisit == 'Alarm (Cert Required)'
            //   || powerSupply.typeOfVisit == 'Other (Cert Required)'
            //   || powerSupply.typeOfVisit == 'Return Visit') && powerSupply.powerSupplyType == 'Built In Generator') {
            if((this.certRequiredValue || powerSupply.typeOfVisit == 'Return Visit') && powerSupply.powerSupplyType == 'Built In Generator'){
              this.saveApuChangesCertificationTriage(result.triageId);
              this.saveApuVisitCertificationTriage(result.triageId);
              //this.saveCertification(powerSupply);
            }
            // else if ((powerSupply.typeOfVisit != 'Preventive Maintenance/Certification (Cert Required)'
            //   && powerSupply.typeOfVisit != 'Device Upgrade (Cert Required)'
            //   && powerSupply.typeOfVisit != 'Alarm (Cert Required)'
            //   && powerSupply.typeOfVisit != 'Other (Cert Required)'
            //   && powerSupply.typeOfVisit != 'Return Visit') && powerSupply.powerSupplyType == 'Built In Generator') {
            else if((!this.certRequiredValue || powerSupply.typeOfVisit != 'Return Visit') && powerSupply.powerSupplyType == 'Built In Generator'){
              this.saveApuChangesCertificationTriage(result.triageId);
              //this.saveApuChangesCertification();
            }
            if(powerSupply.nextGenNode == 'EPON with SFP'){
              this.saveSFPTriage(result.triageId);
            }
                // if (powerSupply.typeOfVisit == 'Preventive Maintenance/Certification (Cert Required)'
                // || powerSupply.typeOfVisit == 'Device Upgrade (Cert Required)'
                // || powerSupply.typeOfVisit == 'Alarm (Cert Required)'
                // || powerSupply.typeOfVisit == 'Other (Cert Required)'
                // || powerSupply.typeOfVisit == 'Return Visit') {
              if(this.certRequiredValue || powerSupply.typeOfVisit == 'Return Visit'){
                this.saveworkitemsTriage(result.triageId); }
            //if any changes or upload in the file section
            if ((this.file !== null && this.file !== undefined) || this.submitFlag) {
              if(this.submitFlag){
                this.filearray = JSON.parse(localStorage.getItem('filearray'));
                console.log(this.filearray);
              }
              //this.psFileUploadnoncomcast(result, PowerSupplyTriage);
              let imageRequest : ImageMetaDataUpdateRequest;
              var categoryValue = [];
              for (let i = 0; i < this.filearray.length; i++) {
                categoryValue.push(this.filearray[i]['id']);
              }
              imageRequest = {
                triageId: result.triageId,
                powerSupplyId : powerSupply.powerSupplyId,
                macAddress: powerSupply.macAddress,
                categories: categoryValue,
                actionType: 'Edit'
              };
              this.powerSupplyService.updatePSIDAndTriageIDByMacAndCategory(imageRequest).subscribe(res => {
                if (res.success === true) {
                  const activity = 'PowerSupply Image PSID & TriageID Update';
                  const message = `PowerSupply Image PSID & TriageID Update Success. PowerSupply Image Category Data: ${JSON.stringify(categoryValue)}`;
                  this.commonService.loggerPost(message, activity, 3);
                  this.showProgressBar = false;
                  this.openSavedDialog(this.powerSupplyName, true);
                  //once ps created removed all the picture in local storage
                  this.removePictureStorage();
                } else {
                  const activity = 'PowerSupply Image PSID & TriageID Update';
                  const message = `PowerSupply Image PSID & TriageID Update Error. Error: ${res.message}. PowerSupply Image Category Data: ${JSON.stringify(categoryValue)}`;
                  this.commonService.loggerPost(message, activity, 5);
                  this.showProgressBar = false;
                  this.openErrorDialog("Something went wrong. Please try later !!");
                }
              }, err => {
                this.showProgressBar = false;
                this.openErrorDialog("Something went wrong. Please try later !!");
              });
            } else {
              this.showProgressspinner = false;
              this.openSavedDialog(this.powerSupplyName, true);
            }

          }  else if (result.responseStatus.success === false && result.responseStatus.message) {
            this.showProgressspinner = false;
            this.openErrorDialog(result.responseStatus.message);
            this.ref.detectChanges();
            //button enabled for save
            this.data.editsaveEnabledMessage('locform', "false");
          } else {
            this.showProgressspinner = false;
            this.openErrorDialog("Something went wrong. Please try later !!");
            this.ref.detectChanges();
          }
        }, err => {
          this.showProgressspinner = false;
          this.openErrorDialog("Something went wrong. Please try later !!");
        });
    }
  }

  SelectAllOk(checked){

    let event = this.lastVisitInfoForm.value.typeOfVisit;
    if (checked && event && event.indexOf('Cert Required') !== -1) {
      this.disableSaveButton = true;
      this.SaveFlag = true;
      this.lastVisitInfoForm.controls["checkAll"].clearValidators();
      this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
    } else if (!checked && event && event.indexOf('Cert Required') !== -1) {
      //this.disableSaveButton = false;
      this.SaveFlag = false;
      this.lastVisitInfoForm.controls["checkAll"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
    }else {
      this.disableSaveButton = true;
      this.SaveFlag = true;
      this.lastVisitInfoForm.controls["checkAll"].clearValidators();
      this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
    }
    if(checked){
      this.isCheckedCheck = true;
      this.SaveFlag = true;
    }else{
      this.isCheckedCheck = false;
      this.SaveFlag = false;
    }
  }

  openSavedDialog(name: string, nonComcast: boolean = false) {
    this.powerSupplyUpdatedDialog = this.dialog.open(PowerSupplyUpdatedDialog, {
      data: {
        powerSupplyName: name ? name : '',
        nodeId: this.nodeId,
        nonComcast: nonComcast,
        genomeMsg:this.genomeMsg,
        psSuccessMsg:this.psSuccessMsg
      },
      disableClose: true
    });
    this.powerSupplyUpdatedDialog.afterClosed().subscribe(() => { });
  }

  openErrorDialog(message: string) {
    this.powerSupplyMoveErrorDialog = this.dialog.open(PowerSupplyMoveErrorDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
    this.powerSupplyMoveErrorDialog.afterClosed().subscribe(() => { });
  }

  openDialog(message: string) {
    this.validationErrorDialog = this.dialog.open(ValidationErrorDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
    this.validationErrorDialog.afterClosed().subscribe(() => { });
  }

  openUploadDialog(message: string) {
    this.uploadDialog = this.dialog.open(UploadDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
    this.uploadDialog.afterClosed().subscribe(() => {});
  }

  onTabChange(event) {
    const tab = event.tab.textLabel;
    if(tab === "Edit Photo(s)" && this.imagesLoaded === false) {
      this.imagesLoaded = true;
      this.getImageDetails(this.powerSupplyId,this.triageId);
    }
  }

  onClickpsStatus() {
    if (this.linkMacAddress !== null && this.linkMacAddress !== undefined && this.linkMacAddress !== '') {
      this.powerSupplyService.getPSStatusLink(this.linkMacAddress).subscribe(result => {
        if (result.success === true) window.open(result.message);
      })
    }
  }

  getBatteryNumber(j) {
    return j % this.noOfBatteries + 1;
  }

  onChangeNextgenType(){
    let event = this.transponderInfoForm.value.nextGenNode;
    if (event !== null && event !== undefined && event !== '') {
      this.selectedPSType = event;
       if (this.selectedPSType === 'EPON with SFP') {
        this.showsfp= true;
        setTimeout(() => {
          //this.transponderInfoForm.controls['sfpMac'].setValue(this.sfpMAC);
          if(this.transponderInfoForm.value.activeMacAddress == ""){
            this.transponderInfoForm.controls['sfpMac'].patchValue('')
          }
          this.transponderInfoForm.controls['sfpMac'].setValue(this.sfpMAC);

        });
      }else{
        this.showsfp = false;
      }
    }
  }

  openSupplyDialogsfp(supplyNumber: number) {
    this.sfpsupplyComponent = this.dialog.open(PowerSupplyEditSupplysfpComponent, {
      panelClass: 'my-centered-dialog',
      disableClose: true,
      height: '50%',
      data: {
        id: this.powerSupplyId,
        noOfBatteries:this.batteryInfoForm.value.numberofBatteries,
        division:this.division,
        supplyNumber: supplyNumber,
        ampRatings:this.ampRatings,
        powerSupplyModels: this.powerSupplyModels,
        controlCardTypes: this.cardTypes,
        supplyName: this.powerSupplyName,
        sysContact: this.sysContact,
        sysLocation: this.sysLocation,
        permissionValue:this.permissionValue,
        triageId: this.triageId
      }
    });

    this.sfpsupplyComponent.afterClosed().subscribe(result => {
      if (result === 'CREATED') this.openDialog("SFP Information Created Sucessfully !!");
      else if (result === 'UPDATED') this.openDialog("SFP Information Updated Sucessfully !!");
      else if (result !== 'OK') this.openDialog("Something went wrong. Please try later !!");
    });
  }


  onChangePowerSupplyType() {
    let event = this.transponderInfoForm.value.standByOpts;
    if (event !== null && event !== undefined && event !== '') {
      this.selectedPSType = event;
      this.onChangevisitType();
      if (this.selectedPSType === 'Built In Generator'){
        this.showApu = true;
        this.inbuiltValue = true;
        //Open as a tab called APU
        this.apuFormGroup.controls["apuMakeModel"].setValidators(Validators.required);
        this.apuFormGroup.controls["apuMakeModel"].updateValueAndValidity();
        this.apuFormGroup.controls["apuSerialNumber"].setValidators(Validators.required);
        this.apuFormGroup.controls["apuSerialNumber"].updateValueAndValidity();
        this.apuFormGroup.controls["apuDeviceId"].setValidators(Validators.required);
        this.apuFormGroup.controls["apuDeviceId"].updateValueAndValidity();
        this.apuFormGroup.controls["apuRunTime"].setValidators(Validators.required);
        this.apuFormGroup.controls["apuRunTime"].updateValueAndValidity();
        this.apuFormGroup.controls["ecmAcm"].setValidators(Validators.required);
        this.apuFormGroup.controls["ecmAcm"].updateValueAndValidity();
        this.apuFormGroup.controls["dateApuInstalled"].setValidators(Validators.required);
        this.apuFormGroup.controls["dateApuInstalled"].updateValueAndValidity();
        this.apuFormGroup.controls["apuOpVltgRating"].setValidators(Validators.required);
        this.apuFormGroup.controls["apuOpVltgRating"].updateValueAndValidity();
        this.apuFormGroup.controls["apuNoLoadVltg"].setValidators(Validators.required);
        this.apuFormGroup.controls["apuNoLoadVltg"].updateValueAndValidity();
        this.apuFormGroup.controls["apuLoadVltg"].setValidators(Validators.required);
        this.apuFormGroup.controls["apuLoadVltg"].updateValueAndValidity();
        this.apuFormGroup.controls["apuEnclosure"].setValidators(Validators.required);
        this.apuFormGroup.controls["apuEnclosure"].updateValueAndValidity();
        this.apuFormGroup.controls["ngLp"].setValidators(Validators.required);
        this.apuFormGroup.controls["ngLp"].updateValueAndValidity();
        this.apuFormGroup.controls["ngProvider"].setValidators(Validators.required);
        this.apuFormGroup.controls["ngProvider"].updateValueAndValidity();
        this.apuFormGroup.controls["lpTankCapacity"].setValidators(Validators.required);
        this.apuFormGroup.controls["lpTankCapacity"].updateValueAndValidity();
        this.apuFormGroup.controls["noOfTanksInstalled"].setValidators(Validators.required);
        this.apuFormGroup.controls["noOfTanksInstalled"].updateValueAndValidity();

        this.apuTab = true;
        this.apuEnclosures = this.cabinetVendors;
        this.naturalGasProviderService.getAllNaturalGasProviderFromService().subscribe(res => {
          this.ngProvideres = res;
        });
        this.powerSupplyAputypesService.getAllApuTypesFromService().subscribe(res => {
          this.apuMakeModels = res;
        });
        if(!this.triageId) {
        if (this.powerSupplyId != null && this.powerSupplyId != 0) {
          this.powerSupplyResourceService.getApuByPowerSupplyId(this.powerSupplyId).subscribe( (res: any) => {
            if (res.id != 0 && res.id != null) {
              this.apu_id = res.id;
              let date: Date = null;
              if (res.dateApuInstalled != null && res.dateApuInstalled != 0) date = new Date(res.dateApuInstalled);
              setTimeout(() => {
                this.apuFormGroup.patchValue({
                  apuMakeModel: res.apuMakeModel,
                  apuSerialNumber: res.apuSerialNumber,
                  apuDeviceId: res.apuDeviceId,
                  apuRunTime: res.apuRunTime,
                  ecmAcm: res.ecmAcm,
                  dateApuInstalled: date,
                  apuOpVltgRating: res.apuOutputVoltageRating,
                  apuNoLoadVltg: res.apuNoLoadVoltage,
                  apuLoadVltg: res.apuLoadVoltage,
                  apuEnclosure: res.apuEnclosureMake,
                  ngLp: res.ngLp,
                  ngProvider: res.ngProvider,
                  lpTankCapacity: res.lpTankCapacity,
                  noOfTanksInstalled: res.numberOfTanks
                });
              });

            } else this.apu_id = 0;
            this.showProgressBar = false;
          }, err => {
            this.showProgressBar = false;
          });
        } else this.showProgressBar = false;
        } else {
          this.powerSupplyResourceService.getApuByPowerSupplyId(this.powerSupplyId).subscribe((res: any) => {
            if (res.id != 0 && res.id != null) {
              this.apu_id = res.id;
            }
          });
        }

      }
      else {
        this.apuTab = false;
        this.showApu = false;
        Object.keys(this.apuFormGroup.controls).forEach((key: string) => {
            const abstractControl = this.apuFormGroup.get(key);
            abstractControl.clearValidators();
            abstractControl.updateValueAndValidity();
          })
      }
    } else {
      this.selectedPSType = 'hint';
      this.showApu = false;
      this.apuTab = false;
    }
  }

  openApuDialog() {
    this.apuComponent = this.dialog.open(PowerSupplyEditApuComponent, {
      panelClass: 'my-centered-dialog',
      disableClose: true,
      height: '90%',
      data: {
        id: this.powerSupplyId,
        cabinetVendors: this.cabinetVendors,
        supplyName: this.powerSupplyName,
        sysContact: this.sysContact,
        sysLocation: this.sysLocation
      }
    });

    this.apuComponent.afterClosed().subscribe(result => {
      if (result === 'CREATED') this.openDialog("APU Created Sucessfully !!");
      else if (result === 'UPDATED') this.openDialog("APU Updated Sucessfully !!");
      else if (result !== 'OK') this.openDialog("Something went wrong. Please try later !!");
    });
  }

  mobilenopattern(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let trimmed = input.value.replace(/\s+/g, "");

    if (trimmed.length > 12) {
      trimmed = trimmed.substr(0, 12);
    }

    trimmed = trimmed.replace(/-/g, "");

    let numbers = [];
    numbers.push(trimmed.substr(0, 3));
    if (trimmed.substr(3, 3) !== "") numbers.push(trimmed.substr(3, 3));
    if (trimmed.substr(6, 4) != "") numbers.push(trimmed.substr(6, 4));
    input.value = numbers.join("-");
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  openApuVisitDialog() {
    this.apuVistComponent = this.dialog.open(PowerSupplyEditApuVisitComponent, {
      panelClass: 'my-centered-dialog',
      disableClose: true,
      height: '90%',
      data: {
        id: this.powerSupplyId,
        supplyName: this.powerSupplyName,
        sysContact: this.sysContact,
        sysLocation: this.sysLocation,
        batteryTypes: this.batteryManufactureres,
        tech: this.userName
      }
    });

    this.apuVistComponent.afterClosed().subscribe(result => {
      if (result === 'CREATED') this.openDialog("APU Visit Created Sucessfully !!");
      else if (result === 'UPDATED') this.openDialog("APU Visit Updated Sucessfully !!");
      else if (result !== 'OK') this.openDialog("Something went wrong. Please try later !!");
    });
  }

  openSupplyDialog(supplyNumber: number) {
    this.supplyComponent = this.dialog.open(PowerSupplyEditSupplyComponent, {
      panelClass: 'my-centered-dialog',
      disableClose: true,
      height: '50%',
      data: {
        id: this.powerSupplyId,
        noOfBatteries:this.batteryInfoForm.value.numberofBatteries,
        division:this.division,
        supplyNumber: supplyNumber,
        ampRatings:this.ampRatings,
        powerSupplyModels: this.powerSupplyModels,
        controlCardTypes: this.cardTypes,
        supplyName: this.powerSupplyName,
        sysContact: this.sysContact,
        sysLocation: this.sysLocation,

      }
    });

    this.supplyComponent.afterClosed().subscribe(result => {
      if (result === 'CREATED') this.openDialog("Supply Information Created Sucessfully !!");
      else if (result === 'UPDATED') this.openDialog("Supply Information Updated Sucessfully !!");
      else if (result !== 'OK') this.openDialog("Something went wrong. Please try later !!");
    });
  }

  validateFiberNodes() {
    this.validateFN = !this.validateFN;
    for (let i = 0; i < this.nodesForms.length; i++) {
      if (this.nodesForms.at(i).value.node != null && this.nodesForms.at(i).value.node !== '' && this.nodesForms.at(i).value.node !== undefined) {
        if (this.validateFN)
          this.filterNodeOptions[i] = this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(this.nodesForms.at(i).value.node).pipe(shareReplay({refCount:true,bufferSize:1}),map(res => res));
        else
          this.filterNodeOptions[i] = this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(this.nodesForms.at(i).value.node).pipe(shareReplay({refCount:true,bufferSize:1}),map(res => res.filter((item: JsonAdvancedSearchResult) => item.nodeCommunintyServed === this.communityServed)));
        this.filterNodeOptions[i].subscribe(nodes => {
          if (nodes.length > 0 && nodes.find(x => x.node.toUpperCase() == this.nodesForms.at(i).value.node.toUpperCase())) {
            this.nodesForms.at(i).get('node').setErrors(null);
            this.updateForm(this.nodesForms.at(i).value.node, i);
          } else {
            // this.nodesForms.at(i).get('node').markAsDirty();
            // this.nodesForms.at(i).get('node').markAsTouched();
            // this.nodesForms.at(i).get('node').setErrors({ nodeError: true });
            this.nodesForms.at(i).get('node').markAsDirty();
            this.nodesForms.at(i).get('node').markAsTouched();
           if(this.node2_id == null && i == 0){
              setTimeout(() => {
                 this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node3_id == null && i == 1){
              setTimeout(() => {
               this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node4_id == null && i == 2){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node5_id == null && i == 3){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node6_id == null && i == 4){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node7_id == null && i == 5){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node8_id == null && i == 6){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node9_id == null && i == 7){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node10_id == null && i == 8){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node11_id == null && i == 9){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node12_id == null && i == 10){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node13_id == null && i == 11){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node14_id == null && i == 12){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if(this.node15_id == null && i == 13){
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node16_id == null && i == 14) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node17_id == null && i == 15) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node18_id == null && i == 16) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node19_id == null && i == 17) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node20_id == null && i == 18) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node21_id == null && i == 19) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node22_id == null && i == 20) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node23_id == null && i == 21) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node24_id == null && i == 22) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node25_id == null && i == 23) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node26_id == null && i == 24) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node27_id == null && i == 25) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node28_id == null && i == 26) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node29_id == null && i == 27) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node30_id == null && i == 28) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node31_id == null && i == 29) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            } else if (this.node32_id == null && i == 30) {
              setTimeout(() => {
                this.nodesForms.at(i).get('node').setErrors({ nodeErrorIdnull: true });
              });
            }
            else{
              this.nodesForms.at(i).get('node').markAsDirty();
              this.nodesForms.at(i).get('node').markAsTouched();
              this.nodesForms.at(i).get('node').setErrors({ nodeError: true });
            }

          }
        });
      }
    }
  }

  titleCase(string) {
    var sentence = string.toLowerCase().split(" ");
    for(var i = 0; i< sentence.length; i++){
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    return sentence.join(" ");
  }

  // onChangeAccType(event){
  //   if(event === 'Metered'){
  //     this.showMeter = true;
  //     this.locationInfoForm.controls["meter"].setValue('');
  //     this.locationInfoForm.get('meter').enable();
  //   }else if(event === 'Un-Metered'){
  //     this.showMeter = true;
  //     //this.locationInfoForm.controls["meter"].setValue('Un-Metered');
  //     this.locationInfoForm.controls["meter"].setValue('');
  //     this.locationInfoForm.get('meter').enable();
  //   }else{
  //     this.showMeter = true;
  //     this.locationInfoForm.controls["meter"].setValue('');
  //     this.locationInfoForm.get('meter').enable();
  //   }
  // }

  downloadPDF(){
    this.showProgressPDFBar = true;
    const pdfName = 'XM360_' + this.powerSupplyId + '.pdf';
    this.powerSupplyService.getPsnbSdsPDFImageByPsId(this.powerSupplyId).subscribe(result => {
      if(result != null){
        var blob = new Blob([result], { type: "application/pdf"});
        FileSaver.saveAs(blob, pdfName);
        setTimeout(() => {
          this.showProgressPDFBar = false;
          this.ref.detectChanges();
        });
      } else{
        this.openDialog("No PDF images to download!");
        this.showProgressPDFBar = false;
      }
    }, err => {
      this.openDialog("No PDF images to download!");
      setTimeout(() => {
        this.showProgressPDFBar = false;
        this.ref.detectChanges();
      });
    });
  }

  //Values for Location Info
  states: string[] = [''];
  nodeFeeds: string[] = ['',
    'No',
    'Yes - 2 Nodes',
    'Yes - 3 Nodes',
    'Yes - 4 Nodes',
    'Yes - 5 Nodes',
    'Yes - 6 Nodes',
    'Yes - 7 Nodes',
    'Yes - 8 Nodes',
    'Yes - 9 Nodes',
    'Yes - 10 Nodes',
    'Yes - 11 Nodes',
    'Yes - 12 Nodes',
    'Yes - 13 Nodes',
    'Yes - 14 Nodes',
    'Yes - 15 Nodes',
    'Yes - 16 Nodes',
    'Yes - 17 Nodes',
    'Yes - 18 Nodes',
    'Yes - 19 Nodes',
    'Yes - 20 Nodes',
    'Yes - 21 Nodes',
    'Yes - 22 Nodes',
    'Yes - 23 Nodes',
    'Yes - 24 Nodes',
    'Yes - 25 Nodes',
    'Yes - 26 Nodes',
    'Yes - 27 Nodes',
    'Yes - 28 Nodes',
    'Yes - 29 Nodes',
    'Yes - 30 Nodes',
    'Yes - 31 Nodes',
    'Yes - 32 Nodes'];
  nodePowers: string[] = [];
  UGs: string[] = [];
  powerCompanies: string[] = [''];
  nwtTeams: string[] = [''];
  nodes: string[] = ['One', 'Two', 'Three'];
  calculatedRuntime: string[] = [''];
  externalSensors: string[] = ['Yes', 'No'];
  // acctypes: string[] = ['', 'Bulk', 'Metered', 'MDU Power Supply'];
  acctypes: string[] = [];
  //Values for TransponderInfo
   standByOptions: string[] = [];
  //standByOptions: string[] = [];
  PSNOptions: string[] = [''];
  PSNOptionsOther: string[] = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  PSNFreedomOptions: string[] = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'BB', 'CC', 'DD', 'EE', 'FF', 'GG', 'HH', 'II', 'JJ'];
  PSKeyStoneEastOptions: string[] = ['', '0', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  PSKeyStoneWestOptions: string[] = ['', '001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '01A-gen', '01B', '01C', '01D', '01E', '012', '02A-gen', '02B', '02C', '02D', '02E', '03A-gen', '03B', '03C', '03D', '03E', '04A-gen', '04B', '04C', '04D', '04E', '05A-gen', '05B', '05C', '05D', '05E'];
  businessPartneRestrictions: string[] = [];
  transponderVendors: string[] = [''];
  transponderModels: string[] = [''];
  powerSupplyModels: string[] = [''];
  powerSupplyTypes =
    [
      { name: 'Unknown', id: '1' },
      { name: 'Alpha XM2 - 120V', id: '2' },
      { name: 'Alpha XM2 - 240V', id: '3' },
      { name: 'Alpha XM - 120V', id: '4' },
      { name: 'Alpha XM - 240V', id: '5' },
      { name: 'Alpha AM/AP - 120V', id: '6' },
      { name: 'Alpha AM/AP - 220V', id: '7' },
      { name: 'Lectro (36V or 48V)ZTT - 120V', id: '8' },
      { name: 'Lectro (36V or 48V)ZTT - 240V', id: '9' },
      { name: 'Lectro ZTT+ - 120V', id: '10' },
      { name: 'Lectro ZTT+ - 240V', id: '11' },
      { name: 'Generic - 120V', id: '12' },
      { name: 'Generic - 240V', id: '13' },
      { name: 'Lectro CPR - 120V', id: '14' },
      { name: 'Lectro CPR - 240V', id: '15' },
      { name: 'Lectro 24VZTT - 120V', id: '16' },
      { name: 'Lectro Sentry II', id: '17' },
      { name: 'APC - 120V', id: '18' },
      { name: 'APC - 240V', id: '19' }
    ];

    inputVoltageRatings: string[] = [];//['', '120VAC', '210VAC', '240VAC'];
    outputVoltageRatings: string[] = [];//['', '60VAC', '75VAC', '90VAC'];
    ampRatings: string[] = [];//['', '4.8Amp', '8Amp', '15Amp', '18Amp', '22Amp', '24Amp'];
    ampOutputRatings: string[] = [];//['', 'Output#1', 'Output#2', 'DualOutput'];
    cardTypes: string[] = [''];
    DCReadyDecisions: string[] = [];//['', 'Yes', 'No'];

  // Values for LastVisit
  //visitTypes: string[] = ['', 'Annual Inspection', 'Maintenance', 'Repair', 'Outage', 'Nitro'];
  visitTypes:string[]=[];
  // XOCTransponderVerifications: string[] = ['', 'Yes', 'No'];
  // cleanDustOptions: string[] = ['', 'Yes', 'No'];
  // hardwareTightenOptions: string[] = ['', 'Yes', 'No'];
  // wireInspectionOption: string[] = ['', 'Yes', 'No'];
  // batteryTemperatureInspectionOptions: string[] = ['', 'Yes', 'No'];
  // meterPanConditions: string[] = ['', 'Good', 'Fair', 'Need Repair', 'Not Installed'];
  // coRiserConditions: string[] = ['', 'Good', 'Fair', 'Need Repair', 'U.G. Feed'];
  batteryHeaterMatTypes: string[] = [''];
  // snowSheildOptions: string[] = ['', 'Yes', 'No', 'NA'];
  // seizureScrews: string[] = ['', 'Ok', 'Tightened'];
  // powerSupplyIDLegibilities: string[] = ['', 'Yes', 'No'];
  // lampCheckOptions: string[] = ['', 'Ok', 'Replace'];
  // checkCircuitBreakOptions: string[] = ['', 'Ok', 'Replace'];
  // cabinetInspections: string[] = ['', 'New', 'Good', 'Poor'];
  // cabinetLockOptions: string[] = ['', 'Ok', 'Missing', 'Replace'];
  // securityBarOptions: string[] = ['', 'Yes', 'No', 'NA'];
  // checkGroundConnections: string[] = ['', 'CATV', 'Missing', 'Repaired'];
  // batteryStringFuses: string[] = ['', 'Yes', 'No', 'NA'];
  // tamperInstalled: string[] = ['', 'Yes', 'No', 'NA'];
  // checkLAPs: string[] = ['', 'Ok', 'Replaced', 'None'];
  cabinetVendors: string[] = [];
  // batteryCapacities: string[] = ['', '1', '2', '3', '4', '6', '8', '12'];
  // operatingLights: string[] = ['', 'Ok', 'Need Red', 'Need Green'];
  // followUpAction: string[] = ['', 'Yes', 'No', 'Alpha'];
  surgeArrestorInputs: string[] = [''];
  outputSurgeArrestors: string[] = [''];
  // coaxOptions: string[] = ['', 'Yes', 'No', 'NA'];
  // ACIOptions: string[] = ['', 'Yes', 'No', 'NA'];
  // LRIOptions: string[] = ['', 'Yes', 'No', 'NA'];
  nextGenOptions: string[] = [];

  //Values for BatteryInfo
    numberofBatteries: string[] = [];/*'',
    '0 String Of 0',
    '1 String Of 1',
    '1 String Of 2',
    '1 String Of 3',
    '2 Strings Of 3',
    '3 Strings Of 3',
    '1 String Of 4',
    '2 Strings Of 4',
    '3 Strings Of 4',
    '4 Strings Of 3',
    '4 Strings Of 4'];*/
  batteriesReplaced: string[] = [];//['', 'Yes', 'No'];
  //batterySeparatorPresent: string[] = [];//['', 'Yes', 'No'];
  batteryManagerModels: string[] = ['Embedded', 'External', 'None','Unknown'];
  batteryManufactureres: string[] = [''];
  batteryManufactureresRem: string[] = [''];

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onChangefollowup(){
    let event = this.lastVisitInfoForm.value.followUpReasons;
    let eventtypeofvisit = this.lastVisitInfoForm.value.typeOfVisit;
      if(eventtypeofvisit && eventtypeofvisit.indexOf('Cert Required') !== -1){
        this.certRequiredValue = true;
      }else{
        this.certRequiredValue = false;
      }
    if ((event != '' || event != undefined || event != null) && this.certRequiredValue) {
       if(event == 'Unable to Locate' || event == 'No Access - MDU' || event == 'No Access - Road Closure' ||
       event == 'No Access - Tree Trimming/Landscape' || event == 'No Access - Rear Easement'){
         this.lastVisitInfoForm.controls["meterPan"].clearValidators();
         this.lastVisitInfoForm.controls["meterPan"].updateValueAndValidity();
         this.lastVisitInfoForm.controls["cabinetVendor"].clearValidators();
         this.lastVisitInfoForm.controls["cabinetVendor"].updateValueAndValidity();
      }else{
        this.lastVisitInfoForm.controls["meterPan"].setValidators(Validators.required);
        this.lastVisitInfoForm.controls["meterPan"].updateValueAndValidity();
        this.lastVisitInfoForm.controls["cabinetVendor"].setValidators(Validators.required);
        this.lastVisitInfoForm.controls["cabinetVendor"].updateValueAndValidity();
      }

    }
  }

  trimLeadingAndTrailingSpaces(formControl: AbstractControl) {
    if (formControl && formControl.value && typeof formControl.value === 'string') {
        formControl.setValue(formControl.value.trim());
    }
  }

  omit_special_char(event) {
    if (event.target.value !== '') {
      if (this.mac_address == '') {
        this.remcolon = event.target.value.toString().replace(/:/g, "");
        let remcolonupdate = this.remcolon.replace(/\s/g, "");
        const blocks = remcolonupdate.match(/.{1,2}/g);
        let formattedMac = blocks.shift();
        for (const block of blocks) {
          formattedMac = formattedMac + ':' + block;
        }
        this.mac_address = formattedMac;
      } else {
        this.remcolon = event.target.value.toString().replace(/:/g, "");
        let remcolonupdate = this.remcolon.replace(/\s/g, "");
        const blocks = remcolonupdate.match(/.{1,2}/g);
        let formattedMac = blocks.shift();
        for (const block of blocks) {
          formattedMac = formattedMac + ':' + block;
        }
        this.mac_address = formattedMac;
      }
    }

    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 58));
  }

  // searchByMacAddress(e: MatAutocompleteSelectedEvent) {
  //   const message = "Search by MAC Address " + e.option.value.mac;
  //   const activity = 'PowerSupply Search - By Mac';
  //   this.commonService.loggerPost(message, activity, 3);
  //   this.mac_address = '';
  //   this.mac_address = e.option.value.mac;
  //   console.log(this.mac_address)
  //   this.transponderInfoForm.controls["activeMacAddress"].clearValidators();
  //   this.transponderInfoForm.controls["activeMacAddress"].updateValueAndValidity();
  // }

  getMacAddress(option) {
    if (option) {
      return option;
    }
  }

  restrictSpecialPaste(event: ClipboardEvent) {
    let regexp = new RegExp('[^0-9/]');
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^0-9]/g, '');
    this.locationInfoForm.controls['zip'].patchValue(trimmedText);
    if (test) {
      event.preventDefault();
    }
  }



  openAddEntryDialogPhoto(val) {
    this.powerSupplyNameEditNetConnectDialog = this.dialog.open(PowerSupplyNameEditNetConnectDialog, {
      autoFocus: false,
      data: {
        activeMac: this.activeMacAddress,
        parent: this,
        powerSupplyId: this.powerSupplyId,
        powerSupplyName: ''
      },
      disableClose: val,
      maxHeight: '90vh',
      panelClass: 'my-centered-dialog',
      width: '700px'
    });
    this.powerSupplyNameEditNetConnectDialog.afterClosed().subscribe();
  }



  b64toBlob = (b64Data, contentType='application/octet-stream', sliceSize=512) => {
    const byteCharacters = atob(b64Data.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    const blobUrl = URL.createObjectURL(blob);

    return blob;
  }
 public psSingleFileUploadSubmit(file, uploadedId,name,activeMac,filearray,powerSupplyId) {

     this.openUploadDialog("Image Uploading..........");

    var uploadvalue = [];
    var categoryUploaded = [];
    var fileurl = this.b64toBlob(file);
    var categoryValue = uploadedId;
    let fileBlob = null;
    let fileName = null;
    let fileblobarray = [];
    if (fileurl !== null && fileurl !== undefined){
      fileName = name;
      this.submitFlag =true;
    }
    var blob = new Blob([fileurl], { type: 'multipart/form-data' });
    fileBlob = new File([blob], fileName);
    categoryUploaded.push(categoryValue);
    let uploadObj = {
      powerSupplyId: powerSupplyId,
      powerSupplyName: null,
      macAddr: activeMac,
      //macAddr: '11',
      nodeId: null,
      createDate: "",
      latestImage: "null",
      fileName: "",
      contentType: "",
      category: categoryValue,
    };
    const uploadBlob = new Blob([JSON.stringify(uploadObj)], { type: 'multipart/form-data' });
    uploadvalue.push(uploadBlob);
    fileblobarray.push(fileBlob);
    var triageId = null;
    this.userDetails = JSON.parse(localStorage['user-details']);
    if ((this.userDetails.permissions.includes('{1091}'))) {
      //Comcast User or Inhouse
      this.permissionValue = true;
    }else{
      //Non Comcast User or Bp
      this.permissionValue = false;
    }
    if(!this.permissionValue){
      triageId = 0;
    }

    return new Promise((resolve, reject) => {

      this.powerSupplyService.uploadSdsImage('Edit', triageId, fileblobarray, uploadvalue)
        .pipe(map(binaryData => binaryData))
        .subscribe(binaryData => {
          resolve(binaryData);
          const message = `PowerSupply Images Uploaded by: ${this.userName} at ${new Date().toISOString()} . Image categories are: ${categoryUploaded}`;
          const activity = 'PowerSupply Image Upload';
          this.commonService.loggerPost(message, activity, 3);
          //this.dialog.closeAll();

          this.openErrorDialog("Uploaded Successfully. Please save Power Supply.");
          //this.openCreatedDialog("Image Uploaded Successfully");
          this.uploadDialog.close('OK')
        }, err => {
          reject(err);
          this.showProgressBar = false;
          this.openErrorDialog("Unable to Upload Images");
        });



    });
  }

  removePictureStorage(){
    localStorage.removeItem('cat1');
    localStorage.removeItem('cat2');
    localStorage.removeItem('cat3');
    localStorage.removeItem('cat4');
    localStorage.removeItem('cat5');
    localStorage.removeItem('cat6');
    localStorage.removeItem('cat7');
    localStorage.removeItem('cat8');
    localStorage.removeItem('cat9');
    localStorage.removeItem('cat10');
    localStorage.removeItem('cat11');
    localStorage.removeItem('cat12');
    localStorage.removeItem('filearray');
  }

  zoomIn(){

    if(this.zoomLevel < 1.4){
      this.zoomLevel += 0.1;
      this.applyZoom();
    }
  }
  zoomOut(){

    if(this.zoomLevel > 1){
      this.zoomLevel -= 0.1;
      this.applyZoom();
    }
  }
  applyZoom(){
    const videoElement = document.getElementById('qr-reader') as HTMLVideoElement;
    if(videoElement){
      videoElement.style.transform = `scale(${this.zoomLevel})`

    }
  }

}

export class DateAndLatestImage {
  latestImage: string;
  uploadedDate: string;
}
